export const CITY_TIME_ZONES = [
  { city: "Qal eh-ye Now", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Chaghcharan", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Lashkar Gah", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Zaranj", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Tarin Kowt", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Zareh Sharan", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Asadabad", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Taloqan", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Mahmud-E Eraqi", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Mehtar Lam", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Baraki Barak", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Aybak", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Mayda Shahr", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Karokh", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Sheberghan", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Pol-e Khomri", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Balkh", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Meymaneh", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Andkhvoy", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Qalat", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Ghazni", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Feyzabad", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Kondoz", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Jalalabad", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Charikar", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Gardiz", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Bamian", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Baghlan", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Farah", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Herat", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Mazar-e Sharif", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Kandahar", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Kabul", country: "Afghanistan", timezone: "Asia/Kabul" },
  { city: "Mariehamn", country: "Aland", timezone: "Europe/Mariehamn" },
  { city: "Kruje", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Fier", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Lushnje", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Puke", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Bajram Curri", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Kukes", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Sarande", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Erseke", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Pogradec", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Korce", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Berat", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Corovode", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Gramsh", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Librazhd", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Tepelene", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Permet", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Gjirokaster", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Peshkopi", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Burrel", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Lezhe", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Rreshen", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Vlore", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Elbasan", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Durres", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Shkoder", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Tirana", country: "Albania", timezone: "Europe/Tirane" },
  { city: "Jijel", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Tizi-Ouzou", country: "Algeria", timezone: "Africa/Algiers" },
  {
    city: "Bordj Bou Arreridj",
    country: "Algeria",
    timezone: "Africa/Algiers",
  },
  { city: "M'sila", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Guelma", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Oum el Bouaghi", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Timimoun", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Sidi bel Abbes", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Tlimcen", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Beni Ounif", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Abadla", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Sefra", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Skikda", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Djanet", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "I-n-Amenas", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "In Amguel", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "El Bayadh", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "El Oued", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Hassi Messaoud", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Chlef", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Mascara", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Mostaganem", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Saida", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Tiarat", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Bejaia", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Blida", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Bouira", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Medea", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Souk Ahras", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Tebessa", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Adrar", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Reggane", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Bechar", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Tindouf", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Illizi", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Arak", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "I-n-Salah", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "El Golea", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Laghouat", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Touggourt", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Ouargla", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Biskra", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Djelfa", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Setif", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Batna", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Annaba", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Constantine", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Oran", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Tamanrasset", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Ghardaia", country: "Algeria", timezone: "Africa/Algiers" },
  { city: "Algiers", country: "Algeria", timezone: "Africa/Algiers" },
  {
    city: "Pago Pago",
    country: "American Samoa",
    timezone: "Pacific/Pago_Pago",
  },
  { city: "Andorra", country: "Andorra", timezone: "Europe/Andorra" },
  { city: "Mucusso", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Lucapa", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Capenda-Camulemba", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Saurimo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Muconda", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Cacolo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Caxito", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Camabatela", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Ndalatando", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Quibala", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Calulo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Waku Kungo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Songo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Mbanza-Congo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Nzeto", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Soyo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Cabinda", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Calucinga", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Camacupa", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Cubal", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Mavinga", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Cuito Caunavale", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Luiana", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Ondjiva", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Chitado", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Chibemba", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Chibia", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Quipungo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Luau", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Cangamba", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Lumbala Nguimbo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Cazombo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Dundo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Ambriz", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Dondo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Sumbe", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Uige", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Kuito", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Lobito", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Xangongo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Luena", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Tômbua", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Malanje", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Benguela", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Lubango", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Namibe", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Menongue", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Huambo", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Luanda", country: "Angola", timezone: "Africa/Luanda" },
  { city: "Artigas Base", country: "Antarctica", timezone: null },
  {
    city: "Capitan Arturo Prat Station",
    country: "Antarctica",
    timezone: null,
  },
  { city: "Marambio Station", country: "Antarctica", timezone: null },
  { city: "Zucchelli Station", country: "Antarctica", timezone: null },
  { city: "Rothera Station", country: "Antarctica", timezone: null },
  { city: "Palmer Station", country: "Antarctica", timezone: null },
  { city: "Base Presidente Montalva", country: "Antarctica", timezone: null },
  { city: "Carlini Station", country: "Antarctica", timezone: null },
  { city: "King Sejong Station", country: "Antarctica", timezone: null },
  { city: "Great Wall Station", country: "Antarctica", timezone: null },
  { city: "Escudero Base", country: "Antarctica", timezone: null },
  { city: "Elephant Island", country: "Antarctica", timezone: null },
  { city: "Scott Base", country: "Antarctica", timezone: null },
  { city: "McMurdo Station", country: "Antarctica", timezone: null },
  { city: "Zhongshan Station", country: "Antarctica", timezone: null },
  { city: "Vostok", country: "Antarctica", timezone: null },
  { city: "Peter I Island", country: "Antarctica", timezone: null },
  { city: "Mirny Station", country: "Antarctica", timezone: null },
  { city: "Mawson Station", country: "Antarctica", timezone: null },
  { city: "Davis Station", country: "Antarctica", timezone: null },
  { city: "Concordia Research Station", country: "Antarctica", timezone: null },
  { city: "Casey Station", country: "Antarctica", timezone: null },
  {
    city: "Amundsen–Scott South Pole Station",
    country: "Antarctica",
    timezone: null,
  },
  { city: "Wasa Station", country: "Antarctica", timezone: null },
  { city: "Troll Station", country: "Antarctica", timezone: null },
  { city: "Svea Station", country: "Antarctica", timezone: null },
  { city: "Novolazarevskaya Station", country: "Antarctica", timezone: null },
  { city: "Neumayer Station III", country: "Antarctica", timezone: null },
  { city: "Maitri Station", country: "Antarctica", timezone: null },
  { city: "Halley Station", country: "Antarctica", timezone: null },
  { city: "Belgrano Station", country: "Antarctica", timezone: null },
  { city: "Camp Sobral", country: "Antarctica", timezone: null },
  { city: "Aboa Station", country: "Antarctica", timezone: null },
  { city: "San Martín Station", country: "Antarctica", timezone: null },
  { city: "Gen. O'Higgins Station", country: "Antarctica", timezone: null },
  { city: "Esperanza Station", country: "Antarctica", timezone: null },
  { city: "Orcadas Station", country: "Antarctica", timezone: null },
  { city: "Signy Research Station", country: "Antarctica", timezone: null },
  { city: "Dumont d'Urville Station", country: "Antarctica", timezone: null },
  { city: "Showa Station", country: "Antarctica", timezone: null },
  {
    city: "Saint John's",
    country: "Antigua and Barbuda",
    timezone: "America/Antigua",
  },
  {
    city: "28 de Noviembre",
    country: "Argentina",
    timezone: "America/Santiago",
  },
  {
    city: "Gobernador Gregores",
    country: "Argentina",
    timezone: "America/Argentina/Rio_Gallegos",
  },
  {
    city: "Comondante Luis Piedrabuena",
    country: "Argentina",
    timezone: "America/Argentina/Rio_Gallegos",
  },
  {
    city: "Paso Rio Mayo",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Alto Rio Sanguer",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "El Maiten",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Puerto Madryn",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Trelew",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Las Heras",
    country: "Argentina",
    timezone: "America/Argentina/Mendoza",
  },
  {
    city: "San Martin",
    country: "Argentina",
    timezone: "America/Argentina/Mendoza",
  },
  {
    city: "Uspallata",
    country: "Argentina",
    timezone: "America/Argentina/Mendoza",
  },
  {
    city: "Cutral Co",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Punta Alta",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "San Nicolas",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Campana",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Chacabuco",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Mercedes",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Lincoln",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Chivilcoy",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Veinticinco de Mayo",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Nueve de Julio",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Dolores",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Pedro Luro",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Tres Arroyos",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Coronel Suarez",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Balcarce",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "25 de Mayo",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "General Roca",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Comallo",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Ingeniero Jacobacci",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "General Conesa",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Choele Choel",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "San Francisco",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Alta Gracia",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Villa Maria",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Bell Ville",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Villa Rumipal",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Villa Carlos Paz",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Chumbicha",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Tinogasta",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Abra Pampa",
    country: "Argentina",
    timezone: "America/Argentina/Jujuy",
  },
  {
    city: "Humahuaca",
    country: "Argentina",
    timezone: "America/Argentina/Jujuy",
  },
  {
    city: "Susques",
    country: "Argentina",
    timezone: "America/Argentina/Jujuy",
  },
  {
    city: "Chepes",
    country: "Argentina",
    timezone: "America/Argentina/La_Rioja",
  },
  {
    city: "Yacuiba",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Tartagal",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Joaquin V. Gonzalez",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "General Guemes",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Trancas",
    country: "Argentina",
    timezone: "America/Argentina/Tucuman",
  },
  {
    city: "Presidencia Roque Saenz Pena",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Pampa del Infierno",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Villa Angela",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Ingeniero Guillermo N. Juarez",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Comandante Fontana",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Doctor Pedro P. Pena",
    country: "Argentina",
    timezone: "America/Asuncion",
  },
  {
    city: "San Lorenzo",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Corrientes",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Concepcion del Uruguay",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Victoria",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Gualeguay",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Parana",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Villa Constitucion",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Rafaela",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Eldorado",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Rodeo",
    country: "Argentina",
    timezone: "America/Argentina/San_Juan",
  },
  {
    city: "Las Plumas",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Gastre",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Telsen",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Malargue",
    country: "Argentina",
    timezone: "America/Argentina/Mendoza",
  },
  {
    city: "Tunuyan",
    country: "Argentina",
    timezone: "America/Argentina/Mendoza",
  },
  {
    city: "La Paz",
    country: "Argentina",
    timezone: "America/Argentina/Mendoza",
  },
  {
    city: "Chos Malal",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Las Lajas",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Zarate",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Carhue",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Darregueira",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Juarez",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Mar de Ajo",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Lobos",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Chascomus",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Junin",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "La Plata",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Pergamino",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Lujan",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Azul",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Villalonga",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Victorica",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "General Pico",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "San Antonio Oeste",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Sierra Colorado",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Mercedes",
    country: "Argentina",
    timezone: "America/Argentina/San_Luis",
  },
  {
    city: "Rio Tercero",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Belen",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Rinconada",
    country: "Argentina",
    timezone: "America/Argentina/Jujuy",
  },
  {
    city: "San Pedro",
    country: "Argentina",
    timezone: "America/Argentina/Jujuy",
  },
  {
    city: "Libertador General San Martin",
    country: "Argentina",
    timezone: "America/Argentina/Jujuy",
  },
  { city: "Chilecito", country: "Argentina", timezone: null },
  {
    city: "Chamical",
    country: "Argentina",
    timezone: "America/Argentina/La_Rioja",
  },
  {
    city: "Los Blancos",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Cafayate",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Cerrillos",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "San Antonio de los Cobres",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Anatuya",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Frias",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Monte Quemado",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Juan Jose Castelli",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Charata",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Las Lomitas",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Mercedes",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Concordia",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Sunchales",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "San Justo",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  { city: "Vera", country: "Argentina", timezone: "America/Argentina/Cordoba" },
  {
    city: "Reconquista",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Venado Tuerto",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Esquel",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  { city: "Zapala", country: "Argentina", timezone: "America/Argentina/Salta" },
  {
    city: "Olavarria",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Tandil",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  { city: "Viedma", country: "Argentina", timezone: "America/Argentina/Salta" },
  {
    city: "San Luis",
    country: "Argentina",
    timezone: "America/Argentina/San_Luis",
  },
  {
    city: "Rio Cuarto",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "San Salvador de Jujuy",
    country: "Argentina",
    timezone: "America/Argentina/Jujuy",
  },
  {
    city: "San Ramon de la Nueva Oran",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  { city: "Goya", country: "Argentina", timezone: "America/Argentina/Cordoba" },
  {
    city: "Puerto San Julian",
    country: "Argentina",
    timezone: "America/Argentina/Rio_Gallegos",
  },
  {
    city: "Perito Moreno",
    country: "Argentina",
    timezone: "America/Argentina/Rio_Gallegos",
  },
  {
    city: "Rio Grande",
    country: "Argentina",
    timezone: "America/Argentina/Ushuaia",
  },
  {
    city: "Ushuaia",
    country: "Argentina",
    timezone: "America/Argentina/Ushuaia",
  },
  {
    city: "Sarmiento",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "San Rafael",
    country: "Argentina",
    timezone: "America/Argentina/Mendoza",
  },
  {
    city: "Necochea",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Rio Colorado",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Catamarca",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "La Rioja",
    country: "Argentina",
    timezone: "America/Argentina/La_Rioja",
  },
  {
    city: "Santiago del Estero",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Resistencia",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Gualeguaychu",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "El Calafate",
    country: "Argentina",
    timezone: "America/Argentina/Rio_Gallegos",
  },
  {
    city: "San Juan",
    country: "Argentina",
    timezone: "America/Argentina/San_Juan",
  },
  {
    city: "Rawson",
    country: "Argentina",
    timezone: "America/Argentina/Catamarca",
  },
  {
    city: "Neuquen",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "Santa Rosa",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  {
    city: "San Carlos de Bariloche",
    country: "Argentina",
    timezone: "America/Argentina/Salta",
  },
  { city: "Salta", country: "Argentina", timezone: "America/Argentina/Salta" },
  {
    city: "Tucumán",
    country: "Argentina",
    timezone: "America/Argentina/Tucuman",
  },
  {
    city: "Formosa",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Santa Fe",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Rosario",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Puerto Deseado",
    country: "Argentina",
    timezone: "America/Argentina/Rio_Gallegos",
  },
  {
    city: "Rio Gallegos",
    country: "Argentina",
    timezone: "America/Argentina/Rio_Gallegos",
  },
  { city: "Comodoro Rivadavia", country: "Argentina", timezone: null },
  {
    city: "Mendoza",
    country: "Argentina",
    timezone: "America/Argentina/Mendoza",
  },
  {
    city: "Bahia Blanca",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Mar del Plata",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  {
    city: "Córdoba",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Posadas",
    country: "Argentina",
    timezone: "America/Argentina/Cordoba",
  },
  {
    city: "Buenos Aires",
    country: "Argentina",
    timezone: "America/Argentina/Buenos_Aires",
  },
  { city: "Ashtarak", country: "Armenia", timezone: "Asia/Yerevan" },
  { city: "Ijevan", country: "Armenia", timezone: "Asia/Yerevan" },
  { city: "Artashat", country: "Armenia", timezone: "Asia/Yerevan" },
  { city: "Gavarr", country: "Armenia", timezone: "Asia/Yerevan" },
  { city: "Yeghegnadzor", country: "Armenia", timezone: "Asia/Yerevan" },
  { city: "Gyumri", country: "Armenia", timezone: "Asia/Yerevan" },
  { city: "Vanadzor", country: "Armenia", timezone: "Asia/Yerevan" },
  { city: "Yerevan", country: "Armenia", timezone: "Asia/Yerevan" },
  { city: "Oranjestad", country: "Aruba", timezone: "America/Aruba" },
  { city: "Central Coast", country: "Australia", timezone: "Australia/Sydney" },
  {
    city: "Sunshine Coast",
    country: "Australia",
    timezone: "Australia/Brisbane",
  },
  { city: "Bourke", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Pine Creek", country: "Australia", timezone: "Australia/Darwin" },
  {
    city: "Adelaide River",
    country: "Australia",
    timezone: "Australia/Darwin",
  },
  {
    city: "McMinns Lagoon",
    country: "Australia",
    timezone: "Australia/Darwin",
  },
  {
    city: "Newcastle Waters",
    country: "Australia",
    timezone: "Australia/Darwin",
  },
  { city: "Ravensthorpe", country: "Australia", timezone: "Australia/Perth" },
  { city: "Wagin", country: "Australia", timezone: "Australia/Perth" },
  { city: "Roebourne", country: "Australia", timezone: "Australia/Perth" },
  { city: "Pannawonica", country: "Australia", timezone: "Australia/Perth" },
  { city: "Tom Price", country: "Australia", timezone: "Australia/Perth" },
  { city: "Kalbarri", country: "Australia", timezone: "Australia/Perth" },
  { city: "Mount Magnet", country: "Australia", timezone: "Australia/Perth" },
  { city: "Morawa", country: "Australia", timezone: "Australia/Perth" },
  { city: "Port Denison", country: "Australia", timezone: "Australia/Perth" },
  { city: "Merredin", country: "Australia", timezone: "Australia/Perth" },
  { city: "Mount Barker", country: "Australia", timezone: "Australia/Perth" },
  { city: "Katanning", country: "Australia", timezone: "Australia/Perth" },
  { city: "Narrogin", country: "Australia", timezone: "Australia/Perth" },
  { city: "Gingin", country: "Australia", timezone: "Australia/Perth" },
  { city: "Bunbury", country: "Australia", timezone: "Australia/Perth" },
  { city: "Kwinana", country: "Australia", timezone: "Australia/Perth" },
  { city: "Southern Cross", country: "Australia", timezone: "Australia/Perth" },
  { city: "Kaltukatjara", country: "Australia", timezone: "Australia/Perth" },
  { city: "Queanbeyan", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Tweed Heads", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Ivanhoe", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Wilcannia", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Merimbula", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Echuca", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Deniliquin", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Nowra", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Ulladulla", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Batemans Bay", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Cooma", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Tumut", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Leeton", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Young", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Cowra", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Forbes", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Goulburn", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Kiama", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Katoomba", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Richmond", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Lithgow", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Parkes", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Bathurst", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Maitland", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Singleton", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Mudgee", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Muswellbrook", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Taree", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Kempsey", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Gunnedah", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Coffs Harbour", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Narrabri", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Inverell", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Yamba", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Ballina", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Wagga Wagga", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Scone", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Byron Bay", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Berri", country: "Australia", timezone: "Australia/Adelaide" },
  {
    city: "Peterborough",
    country: "Australia",
    timezone: "Australia/Adelaide",
  },
  { city: "Wallaroo", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Clare", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Meningie", country: "Australia", timezone: "Australia/Adelaide" },
  {
    city: "Kingston South East",
    country: "Australia",
    timezone: "Australia/Adelaide",
  },
  { city: "Bordertown", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Penola", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Kingoonya", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Kimba", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Streaky Bay", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Cowell", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Tumby Bay", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Andamooka", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Woomera", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Port Pirie", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Gawler", country: "Australia", timezone: "Australia/Adelaide" },
  {
    city: "Murray Bridge",
    country: "Australia",
    timezone: "Australia/Adelaide",
  },
  {
    city: "Victor Harbor",
    country: "Australia",
    timezone: "Australia/Adelaide",
  },
  { city: "Hamilton", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Ouyen", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Colac", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Stawell", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Horsham", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Ararat", country: "Australia", timezone: "Australia/Melbourne" },
  {
    city: "Maryborough",
    country: "Australia",
    timezone: "Australia/Melbourne",
  },
  { city: "Bairnsdale", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Sale", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Traralgon", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Wonthaggi", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Cranbourne", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Ballarat", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Melton", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Seymour", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Shepparton", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Cobram", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Swan Hill", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Sunbury", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Proserpine", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Theodore", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Eidsvold", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Barcaldine", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Winton", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Longreach", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Caboolture", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Warwick", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Kingaroy", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Dalby", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Bongaree", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Gympie", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Ingham", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Birdsville", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Bedourie", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Boulia", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Richmond", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Burketown", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Hervey Bay", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Biloela", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Yeppoon", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Emerald", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Moranbah", country: "Australia", timezone: "Australia/Brisbane" },
  {
    city: "Charters Towers",
    country: "Australia",
    timezone: "Australia/Brisbane",
  },
  { city: "Ayr", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Atherton", country: "Australia", timezone: "Australia/Brisbane" },
  {
    city: "Port Douglas",
    country: "Australia",
    timezone: "Australia/Brisbane",
  },
  { city: "Smithton", country: "Australia", timezone: "Australia/Hobart" },
  { city: "Scottsdale", country: "Australia", timezone: "Australia/Hobart" },
  { city: "Bicheno", country: "Australia", timezone: "Australia/Hobart" },
  { city: "Oatlands", country: "Australia", timezone: "Australia/Hobart" },
  { city: "Queenstown", country: "Australia", timezone: "Australia/Hobart" },
  { city: "Kingston", country: "Australia", timezone: "Australia/Hobart" },
  { city: "Tennant Creek", country: "Australia", timezone: "Australia/Darwin" },
  { city: "Yulara", country: "Australia", timezone: "Australia/Darwin" },
  { city: "Erldunda", country: "Australia", timezone: "Australia/Darwin" },
  { city: "Norseman", country: "Australia", timezone: "Australia/Perth" },
  { city: "Halls Creek", country: "Australia", timezone: "Australia/Perth" },
  { city: "Kununurra", country: "Australia", timezone: "Australia/Perth" },
  { city: "Derby", country: "Australia", timezone: "Australia/Perth" },
  { city: "Onslow", country: "Australia", timezone: "Australia/Perth" },
  { city: "Exmouth", country: "Australia", timezone: "Australia/Perth" },
  { city: "Carnarvon", country: "Australia", timezone: "Australia/Perth" },
  { city: "Newman", country: "Australia", timezone: "Australia/Perth" },
  { city: "Meekatharra", country: "Australia", timezone: "Australia/Perth" },
  { city: "Three Springs", country: "Australia", timezone: "Australia/Perth" },
  { city: "Manjimup", country: "Australia", timezone: "Australia/Perth" },
  { city: "Northam", country: "Australia", timezone: "Australia/Perth" },
  { city: "Esperance", country: "Australia", timezone: "Australia/Perth" },
  { city: "Leonara", country: "Australia", timezone: "Australia/Perth" },
  { city: "Laverton", country: "Australia", timezone: "Australia/Perth" },
  { city: "Wyndham", country: "Australia", timezone: "Australia/Perth" },
  { city: "Albury", country: "Australia", timezone: "Australia/Sydney" },
  {
    city: "Forster-Tuncurry",
    country: "Australia",
    timezone: "Australia/Sydney",
  },
  {
    city: "Port Macquarie",
    country: "Australia",
    timezone: "Australia/Sydney",
  },
  { city: "Tamworth", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Grafton", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Moree", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Goondiwindi", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Lismore", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Wollongong", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Ceduna", country: "Australia", timezone: "Australia/Adelaide" },
  {
    city: "Mount Gambier",
    country: "Australia",
    timezone: "Australia/Adelaide",
  },
  {
    city: "Port Augusta",
    country: "Australia",
    timezone: "Australia/Adelaide",
  },
  {
    city: "Warrnambool",
    country: "Australia",
    timezone: "Australia/Melbourne",
  },
  { city: "Mildura", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Geelong", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Camooweal", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Quilpie", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Charleville", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Hughenden", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Caloundra", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Roma", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Toowoomba", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Georgetown", country: "Australia", timezone: "Australia/Brisbane" },
  {
    city: "Thargomindah",
    country: "Australia",
    timezone: "Australia/Brisbane",
  },
  { city: "Weipa", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Karumba", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Cloncurry", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Maryborough", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Bundaberg", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Gladstone", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Bowen", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Innisfail", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Mackay", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Burnie", country: "Australia", timezone: "Australia/Hobart" },
  { city: "Launceston", country: "Australia", timezone: "Australia/Hobart" },
  { city: "Katherine", country: "Australia", timezone: "Australia/Darwin" },
  { city: "Busselton", country: "Australia", timezone: "Australia/Perth" },
  { city: "Mandurah", country: "Australia", timezone: "Australia/Perth" },
  { city: "Broome", country: "Australia", timezone: "Australia/Perth" },
  { city: "Kalgoorlie", country: "Australia", timezone: "Australia/Perth" },
  { city: "Albany", country: "Australia", timezone: "Australia/Perth" },
  { city: "Port Hedland", country: "Australia", timezone: "Australia/Perth" },
  { city: "Karratha", country: "Australia", timezone: "Australia/Perth" },
  { city: "Geraldton", country: "Australia", timezone: "Australia/Perth" },
  { city: "Griffith", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Orange", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Dubbo", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Armidale", country: "Australia", timezone: "Australia/Sydney" },
  {
    city: "Broken Hill",
    country: "Australia",
    timezone: "Australia/Broken_Hill",
  },
  {
    city: "Port Lincoln",
    country: "Australia",
    timezone: "Australia/Adelaide",
  },
  { city: "Whyalla", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Portland", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Bendigo", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Wangaratta", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Windorah", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Mount Isa", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Rockhampton", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Cairns", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Gold Coast", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Devonport", country: "Australia", timezone: "Australia/Hobart" },
  { city: "Darwin", country: "Australia", timezone: "Australia/Darwin" },
  { city: "Alice Springs", country: "Australia", timezone: "Australia/Darwin" },
  { city: "Canberra", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Newcastle", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Adelaide", country: "Australia", timezone: "Australia/Adelaide" },
  { city: "Townsville", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Brisbane", country: "Australia", timezone: "Australia/Brisbane" },
  { city: "Hobart", country: "Australia", timezone: "Australia/Hobart" },
  { city: "Perth", country: "Australia", timezone: "Australia/Perth" },
  { city: "Melbourne", country: "Australia", timezone: "Australia/Melbourne" },
  { city: "Sydney", country: "Australia", timezone: "Australia/Sydney" },
  { city: "Bregenz", country: "Austria", timezone: "Europe/Vienna" },
  { city: "Eisenstadt", country: "Austria", timezone: "Europe/Vienna" },
  { city: "Wiener Neustadt", country: "Austria", timezone: "Europe/Vienna" },
  { city: "Graz", country: "Austria", timezone: "Europe/Vienna" },
  { city: "Klagenfurt", country: "Austria", timezone: "Europe/Vienna" },
  { city: "Linz", country: "Austria", timezone: "Europe/Vienna" },
  { city: "Passau", country: "Austria", timezone: "Europe/Berlin" },
  { city: "Salzburg", country: "Austria", timezone: "Europe/Vienna" },
  { city: "Innsbruck", country: "Austria", timezone: "Europe/Vienna" },
  { city: "Vienna", country: "Austria", timezone: "Europe/Vienna" },
  { city: "Gadabay", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Goranboy", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Tovuz", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Agdam", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Qabala", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Oguz", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Ganca", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Yevlax", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Sumqayt", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Ali Bayramli", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Goycay", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Lankaran", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Saki", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Stepanakert", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Kapan", country: "Azerbaijan", timezone: "Asia/Yerevan" },
  { city: "Naxcivan", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Baku", country: "Azerbaijan", timezone: "Asia/Baku" },
  { city: "Manama", country: "Bahrain", timezone: "Asia/Bahrain" },
  { city: "Tangail", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Sylhet", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Mymensingh", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Jamalpur", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Narayanganj", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Jessore", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Barisal", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Comilla", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Pabna", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Nawabganj", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Saidpur", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Rangpur", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Khulna", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Rajshahi", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Dhaka", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Chittagong", country: "Bangladesh", timezone: "Asia/Dhaka" },
  { city: "Bridgetown", country: "Barbados", timezone: "America/Barbados" },
  { city: "Baranavichy", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Polatsk", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Maladzyechna", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Pinsk", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Mazyr", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Mahilyow", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Babruysk", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Orsha", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Lida", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Hrodna", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Barysaw", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Homyel", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Vitsyebsk", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Brest", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Minsk", country: "Belarus", timezone: "Europe/Minsk" },
  { city: "Mons", country: "Belgium", timezone: "Europe/Brussels" },
  { city: "Hasselt", country: "Belgium", timezone: "Europe/Brussels" },
  { city: "Arlon", country: "Belgium", timezone: "Europe/Brussels" },
  { city: "Gent", country: "Belgium", timezone: "Europe/Brussels" },
  { city: "Liege", country: "Belgium", timezone: "Europe/Brussels" },
  { city: "Brugge", country: "Belgium", timezone: "Europe/Brussels" },
  { city: "Namur", country: "Belgium", timezone: "Europe/Brussels" },
  { city: "Charleroi", country: "Belgium", timezone: "Europe/Brussels" },
  { city: "Antwerpen", country: "Belgium", timezone: "Europe/Brussels" },
  { city: "Brussels", country: "Belgium", timezone: "Europe/Brussels" },
  { city: "El Cayo", country: "Belize", timezone: "America/Belize" },
  { city: "Corozal", country: "Belize", timezone: "America/Belize" },
  { city: "Dangriga", country: "Belize", timezone: "America/Belize" },
  { city: "Belize City", country: "Belize", timezone: "America/Belize" },
  { city: "Orange Walk", country: "Belize", timezone: "America/Belize" },
  { city: "Punta Gorda", country: "Belize", timezone: "America/Belize" },
  { city: "Belmopan", country: "Belize", timezone: "America/Belize" },
  { city: "Lokossa", country: "Benin", timezone: "Africa/Porto-Novo" },
  { city: "Kandi", country: "Benin", timezone: "Africa/Porto-Novo" },
  { city: "Ouidah", country: "Benin", timezone: "Africa/Porto-Novo" },
  { city: "Abomey", country: "Benin", timezone: "Africa/Porto-Novo" },
  { city: "Natitingou", country: "Benin", timezone: "Africa/Porto-Novo" },
  { city: "Djougou", country: "Benin", timezone: "Africa/Porto-Novo" },
  { city: "Parakou", country: "Benin", timezone: "Africa/Porto-Novo" },
  { city: "Porto-Novo", country: "Benin", timezone: "Africa/Porto-Novo" },
  { city: "Cotonou", country: "Benin", timezone: "Africa/Porto-Novo" },
  { city: "Hamilton", country: "Bermuda", timezone: "Atlantic/Bermuda" },
  { city: "Paro", country: "Bhutan", timezone: "Asia/Thimphu" },
  { city: "Punakha", country: "Bhutan", timezone: "Asia/Thimphu" },
  { city: "Wangdue Prodrang", country: "Bhutan", timezone: "Asia/Thimphu" },
  { city: "Thimphu", country: "Bhutan", timezone: "Asia/Thimphu" },
  { city: "Punata", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Cliza", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Quillacollo", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Puerto Villarroel", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Tarabuco", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Guayaramerin", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Santa Ana", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Baures", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Sica Sica", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Rurrenabaque", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Sorata", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Achacachi", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Viacha", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Quime", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Llallagua", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Uncia", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Uyuni", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Villa Martin", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Betanzos", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Portachuelo", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Samaipata", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Cuevo", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "San Carlos", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "San Lorenzo", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Entre Rios", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Aiquile", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Padilla", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Camargo", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Reyes", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "San Borja", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Magdalena", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "San Ramon", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Puerto Heath", country: "Bolivia", timezone: "America/Lima" },
  { city: "Charana", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Puerto Acosta", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Apolo", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Coroico", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Coro Coro", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Sabaya", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Challapata", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Llica", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Potosi", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Villazon", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Tupiza", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Montero", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Piso Firme", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Robore", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Puerto Quijarro", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "San Ignacio", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Ascension", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "San Javier", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "San Rafael", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Vallegrande", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Puerto Suarez", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Charagua", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Villamontes", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Bermejo", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Cochabamba", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Oruro", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Camiri", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Cobija", country: "Bolivia", timezone: "America/Rio_Branco" },
  { city: "San Matias", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "San José", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Trinidad", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Tarija", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Sucre", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Riberalta", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "La Paz", country: "Bolivia", timezone: "America/La_Paz" },
  { city: "Santa Cruz", country: "Bolivia", timezone: "America/La_Paz" },
  {
    city: "Zenica",
    country: "Bosnia and Herzegovina",
    timezone: "Europe/Sarajevo",
  },
  {
    city: "Mostar",
    country: "Bosnia and Herzegovina",
    timezone: "Europe/Sarajevo",
  },
  {
    city: "Tuzla",
    country: "Bosnia and Herzegovina",
    timezone: "Europe/Sarajevo",
  },
  {
    city: "Prijedor",
    country: "Bosnia and Herzegovina",
    timezone: "Europe/Sarajevo",
  },
  {
    city: "Banja Luka",
    country: "Bosnia and Herzegovina",
    timezone: "Europe/Sarajevo",
  },
  {
    city: "Sarajevo",
    country: "Bosnia and Herzegovina",
    timezone: "Europe/Sarajevo",
  },
  { city: "Mochudi", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Ghanzi", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Lokhwabe", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Lehututu", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Tshabong", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Tsau", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Nokaneng", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Mohembo", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Maun", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Kasane", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Nata", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Mopipi", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Palapye", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Lobatse", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Kanye", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Molepolole", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Francistown", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Mahalapye", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Serowe", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Gaborone", country: "Botswana", timezone: "Africa/Gaborone" },
  { city: "Grajau", country: "Brazil", timezone: "America/Fortaleza" },
  {
    city: "Presidente Dutra",
    country: "Brazil",
    timezone: "America/Fortaleza",
  },
  { city: "Itapecuru Mirim", country: "Brazil", timezone: "America/Fortaleza" },
  {
    city: "Sao Jose de Ribamar",
    country: "Brazil",
    timezone: "America/Fortaleza",
  },
  { city: "Santa Ines", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Rosario", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Timon", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Capanema", country: "Brazil", timezone: "America/Belem" },
  { city: "Portel", country: "Brazil", timezone: "America/Belem" },
  { city: "Itupiranga", country: "Brazil", timezone: "America/Belem" },
  { city: "Pimenta Bueno", country: "Brazil", timezone: "America/Porto_Velho" },
  { city: "Ponta Pora", country: "Brazil", timezone: "America/Campo_Grande" },
  { city: "Maracaju", country: "Brazil", timezone: "America/Campo_Grande" },
  { city: "Jardim", country: "Brazil", timezone: "America/Campo_Grande" },
  { city: "Tres Lagoas", country: "Brazil", timezone: "America/Campo_Grande" },
  { city: "Guanhaes", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Leopoldina", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Nova Lima", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Pouso Alegre", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Itauna", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Caratinga", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Diamantina", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Nanuque", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Barbacena", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Pocos de Caldas", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Guaxupe", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Sao Joao del Rei",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Muriae", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Passos", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Conselheiro Lafaiete",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Formiga", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Frutal", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Iturama", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Ituiutaba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Araguari", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Almenara", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Varzea Grande", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Cáceres", country: "Brazil", timezone: "America/Cuiaba" },
  {
    city: "Santana do Livramento",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Canoas", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Quarai", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Santa Vitoria do Palmar",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  {
    city: "Sao Lourenco do Sul",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Canela", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Sao Gabriel", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Rosario do Sul", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Cachoeira do Sul",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Osorio", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Santa Cruz do Sul",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  {
    city: "Sao Luiz Gonzaga",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Santo Angelo", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Carazinho", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Erechim", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Guaira", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Palmas", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Arapongas", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Paranagua", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Sao Jose dos Pinhais",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Guarapuava", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Rio Negro", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Apucarana", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Lapa", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Irati", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Castro", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Telemaco Borba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Jacarezinho", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Concordia", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Blumenau", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Brusque", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Ararangua", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Jaragua do Sul", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Tubarao", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Laguna", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Joacaba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Cacador", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Canoinhas", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Camocim", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Russas", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Sobral", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Iguatu", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Quixada", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Caninde", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Campo Maior", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Barras", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Rio Largo", country: "Brazil", timezone: "America/Maceio" },
  {
    city: "Palmeira dos Indios",
    country: "Brazil",
    timezone: "America/Maceio",
  },
  { city: "Santa Cruz Cabralia", country: "Brazil", timezone: "America/Bahia" },
  { city: "Paulo Afonso", country: "Brazil", timezone: "America/Bahia" },
  { city: "Brumado", country: "Brazil", timezone: "America/Bahia" },
  { city: "Jaguaquara", country: "Brazil", timezone: "America/Bahia" },
  { city: "Itapetinga", country: "Brazil", timezone: "America/Bahia" },
  { city: "Ubaitaba", country: "Brazil", timezone: "America/Bahia" },
  {
    city: "Cachoeiro de Itapemirim",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Barra Mansa", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Nova Iguacu", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Duque de Caxias", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Niteroi", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Cabo Frio", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Macae", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Miracema", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Apodi", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Santa Cruz", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Morrinhos", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Ceres", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Catalao", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Cristalina", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Trindade", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Ipora", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Inhumas", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Itaberai", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Santo Andre", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Pindamonhangaba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Rio Claro", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Ourinhos", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Itanhaem", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Jaboticabal", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Braganca Paulista",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Jundiai", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Sao Jose dos Campos",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Guaratingueta", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Pirassununga", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Americana", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Piracicaba", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Sao Joao da Boa Vista",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Sao Carlos", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Tupa", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Penapolis", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Presidente Prudente",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Registro", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Tatui", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Avare", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Garca", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Catanduva", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Batatais", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Barretos", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Marilia", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Itu", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Itapetininga", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Jaboatao", country: "Brazil", timezone: "America/Recife" },
  { city: "Olinda", country: "Brazil", timezone: "America/Recife" },
  {
    city: "Cabo de Santo Agostinho",
    country: "Brazil",
    timezone: "America/Recife",
  },
  { city: "Carpina", country: "Brazil", timezone: "America/Recife" },
  { city: "Arcoverde", country: "Brazil", timezone: "America/Recife" },
  { city: "Manacapuru", country: "Brazil", timezone: "America/Manaus" },
  { city: "Maues", country: "Brazil", timezone: "America/Manaus" },
  { city: "Pedreiras", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Codo", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Coroata", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Chapadinha", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Pinheiro", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Barra do Corda", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Viana", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Colinas", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Viseu", country: "Brazil", timezone: "America/Belem" },
  { city: "Capitao Poco", country: "Brazil", timezone: "America/Belem" },
  { city: "Castanhal", country: "Brazil", timezone: "America/Belem" },
  { city: "Salinopolis", country: "Brazil", timezone: "America/Belem" },
  { city: "Alenquer", country: "Brazil", timezone: "America/Santarem" },
  { city: "Oriximina", country: "Brazil", timezone: "America/Santarem" },
  { city: "Xinguara", country: "Brazil", timezone: "America/Belem" },
  { city: "Jacundá", country: "Brazil", timezone: "America/Belem" },
  { city: "Uruara", country: "Brazil", timezone: "America/Santarem" },
  { city: "Altamira", country: "Brazil", timezone: "America/Santarem" },
  { city: "Paragominas", country: "Brazil", timezone: "America/Belem" },
  { city: "Cameta", country: "Brazil", timezone: "America/Belem" },
  {
    city: "Rolim de Moura",
    country: "Brazil",
    timezone: "America/Porto_Velho",
  },
  { city: "Ariquemes", country: "Brazil", timezone: "America/Porto_Velho" },
  { city: "Abuna", country: "Brazil", timezone: "America/Porto_Velho" },
  { city: "Tocantinopolis", country: "Brazil", timezone: "America/Araguaina" },
  { city: "Gurupi", country: "Brazil", timezone: "America/Araguaina" },
  { city: "Aquidauana", country: "Brazil", timezone: "America/Campo_Grande" },
  { city: "Paranaiba", country: "Brazil", timezone: "America/Campo_Grande" },
  { city: "Sete Lagoas", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Divinopolis", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Ipatinga", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Araxa", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Lavras", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Uba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Campo Belo", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Ponte Nova", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Curvelo", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Paracatu", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Bocaiuva", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Aracuai", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Janauba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Juina", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Barra do Garcas", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Pontes e Lacerda", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Barra do Bugres", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Rondonopolis", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Uruguaiana", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Sao Borja", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Novo Hamburgo", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Rio Grande", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Camaqua", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Bento Goncalves", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Vacaria", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Ijui", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Santa Rosa", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Maringa", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Cascavel", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Campo Murao", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Foz do Iguacu", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Sao Francisco do Sul",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Porto Uniao", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Itajai", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Imbituba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Lajes", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Granja", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Crato", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Itapipoca", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Paracuru", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Acarau", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Taua", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Crateus", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Baturite", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Ipu", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Floriano", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Piripiri", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Penedo", country: "Brazil", timezone: "America/Maceio" },
  { city: "Itabuna", country: "Brazil", timezone: "America/Bahia" },
  { city: "Itamaraju", country: "Brazil", timezone: "America/Bahia" },
  { city: "Guanambi", country: "Brazil", timezone: "America/Bahia" },
  { city: "Porto Seguro", country: "Brazil", timezone: "America/Bahia" },
  { city: "Valenca", country: "Brazil", timezone: "America/Bahia" },
  { city: "Serrinha", country: "Brazil", timezone: "America/Bahia" },
  { city: "Tucano", country: "Brazil", timezone: "America/Bahia" },
  { city: "Senhor do Bonfim", country: "Brazil", timezone: "America/Bahia" },
  { city: "Remanso", country: "Brazil", timezone: "America/Bahia" },
  { city: "Itambe", country: "Brazil", timezone: "America/Bahia" },
  { city: "Bom Jesus da Lapa", country: "Brazil", timezone: "America/Bahia" },
  { city: "Itaberaba", country: "Brazil", timezone: "America/Bahia" },
  { city: "Sao Mateus", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Patos", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Volta Redonda", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Petropolis", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Nova Cruz", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Caico", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Acu", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Estancia", country: "Brazil", timezone: "America/Maceio" },
  { city: "Caracarai", country: "Brazil", timezone: "America/Boa_Vista" },
  { city: "Porto Santana", country: "Brazil", timezone: "America/Belem" },
  { city: "Rio Verde", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Pires do Rio", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Anapolis", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Goianesia", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Niquelandia", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Itumbiara", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Jatai", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Mineiros", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Formosa", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Sao Jose do Rio Preto",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Limeira", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Taubate", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Jau", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Assis", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Itapeva", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Botucatu", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Novo Horizonte", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Andradina", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Fernandopolis", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Barreiros", country: "Brazil", timezone: "America/Recife" },
  { city: "Salgueiro", country: "Brazil", timezone: "America/Recife" },
  { city: "Goiana", country: "Brazil", timezone: "America/Recife" },
  { city: "Timbauba", country: "Brazil", timezone: "America/Recife" },
  { city: "Bacabal", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Braganca", country: "Brazil", timezone: "America/Belem" },
  { city: "Obidos", country: "Brazil", timezone: "America/Santarem" },
  { city: "Guajara-Miram", country: "Brazil", timezone: "America/La_Paz" },
  { city: "Porto Nacional", country: "Brazil", timezone: "America/Araguaina" },
  { city: "Dourados", country: "Brazil", timezone: "America/Campo_Grande" },
  {
    city: "Governador Valadares",
    country: "Brazil",
    timezone: "America/Sao_Paulo",
  },
  { city: "Pirapora", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Juiz de Fora", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Santa Maria", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Passo Fundo", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Xapeco", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Joinville", country: "Brazil", timezone: "America/Sao_Paulo" },
  {
    city: "Juazeiro do Norte",
    country: "Brazil",
    timezone: "America/Fortaleza",
  },
  { city: "Nova Vicosa", country: "Brazil", timezone: "America/Bahia" },
  { city: "Alagoinhas", country: "Brazil", timezone: "America/Bahia" },
  { city: "Juazeiro", country: "Brazil", timezone: "America/Bahia" },
  { city: "Vitória", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Joao Pessoa", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Campina Grande", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Nova Friburgo", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Aracatuba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Sena Madureira", country: "Brazil", timezone: "America/Rio_Branco" },
  { city: "Fonte Boa", country: "Brazil", timezone: "America/Manaus" },
  { city: "Eirunepe", country: "Brazil", timezone: "America/Eirunepe" },
  { city: "Manicore", country: "Brazil", timezone: "America/Manaus" },
  { city: "Barcelos", country: "Brazil", timezone: "America/Manaus" },
  { city: "Tonantins", country: "Brazil", timezone: "America/Manaus" },
  { city: "Tefe", country: "Brazil", timezone: "America/Manaus" },
  { city: "Coari", country: "Brazil", timezone: "America/Manaus" },
  {
    city: "Sao Cabriel da Cachoeira",
    country: "Brazil",
    timezone: "America/Manaus",
  },
  { city: "Novo Airao", country: "Brazil", timezone: "America/Manaus" },
  { city: "Itacoatiara", country: "Brazil", timezone: "America/Manaus" },
  { city: "Parintins", country: "Brazil", timezone: "America/Manaus" },
  { city: "Natal", country: "Brazil", timezone: "America/Manaus" },
  { city: "Crato", country: "Brazil", timezone: "America/Manaus" },
  { city: "Imperatriz", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Balsas", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Breves", country: "Brazil", timezone: "America/Belem" },
  { city: "Jacareacanga", country: "Brazil", timezone: "America/Santarem" },
  { city: "Tucurui", country: "Brazil", timezone: "America/Belem" },
  { city: "Itaituba", country: "Brazil", timezone: "America/Santarem" },
  {
    city: "Conceicao do Araguaia",
    country: "Brazil",
    timezone: "America/Belem",
  },
  { city: "Abaetetuba", country: "Brazil", timezone: "America/Belem" },
  {
    city: "Principe da Beira",
    country: "Brazil",
    timezone: "America/Porto_Velho",
  },
  { city: "Araguaina", country: "Brazil", timezone: "America/Araguaina" },
  { city: "Palmas", country: "Brazil", timezone: "America/Araguaina" },
  { city: "Teofilo Otoni", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Uberaba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Januaria", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Mato Grosso", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Aripuana", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Sinop", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Jaguarao", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Bage", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Londrina", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Criciuma", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Aracati", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Ico", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Parnaiba", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Picos", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Arapiraca", country: "Brazil", timezone: "America/Maceio" },
  { city: "Jequie", country: "Brazil", timezone: "America/Bahia" },
  { city: "Ilheus", country: "Brazil", timezone: "America/Bahia" },
  { city: "Canavieiras", country: "Brazil", timezone: "America/Bahia" },
  {
    city: "Santa Maria da Vitoria",
    country: "Brazil",
    timezone: "America/Bahia",
  },
  { city: "Irece", country: "Brazil", timezone: "America/Bahia" },
  { city: "Xique-Xique", country: "Brazil", timezone: "America/Bahia" },
  { city: "Linhares", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Campos", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Mossoro", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Aracaju", country: "Brazil", timezone: "America/Maceio" },
  { city: "Laranjal do Jari", country: "Brazil", timezone: "America/Santarem" },
  { city: "Amapa", country: "Brazil", timezone: "America/Belem" },
  { city: "Vila Velha", country: "Brazil", timezone: "America/Belem" },
  { city: "Santos", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Bauru", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Iguape", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Franca", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Garanhuns", country: "Brazil", timezone: "America/Recife" },
  { city: "Caruaru", country: "Brazil", timezone: "America/Recife" },
  { city: "Rio Branco", country: "Brazil", timezone: "America/Rio_Branco" },
  { city: "São Luís", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Porto Velho", country: "Brazil", timezone: "America/Porto_Velho" },
  { city: "Alvorada", country: "Brazil", timezone: "America/Araguaina" },
  { city: "Corumba", country: "Brazil", timezone: "America/Campo_Grande" },
  { city: "Belo Horizonte", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Montes Claros", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Uberlandia", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Colider", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Alta Floresta", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Cuiaba", country: "Brazil", timezone: "America/Cuiaba" },
  { city: "Pelotas", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Caxias do Sul", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Ponta Grossa", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Teresina", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Maceio", country: "Brazil", timezone: "America/Maceio" },
  {
    city: "Vitoria da Conquista",
    country: "Brazil",
    timezone: "America/Bahia",
  },
  { city: "Barreiras", country: "Brazil", timezone: "America/Bahia" },
  { city: "Vila Velha", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Natal", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Campinas", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Sorocaba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Ribeirao Preto", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Petrolina", country: "Brazil", timezone: "America/Recife" },
  {
    city: "Cruzeiro do Sul",
    country: "Brazil",
    timezone: "America/Rio_Branco",
  },
  { city: "Manaus", country: "Brazil", timezone: "America/Manaus" },
  { city: "Caxias", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Santarem", country: "Brazil", timezone: "America/Santarem" },
  { city: "Maraba", country: "Brazil", timezone: "America/Belem" },
  { city: "Vilhena", country: "Brazil", timezone: "America/Porto_Velho" },
  { city: "Ji-Parana", country: "Brazil", timezone: "America/Porto_Velho" },
  { city: "Campo Grande", country: "Brazil", timezone: "America/Campo_Grande" },
  { city: "Florianopolis", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Feira de Santana", country: "Brazil", timezone: "America/Bahia" },
  { city: "Boa Vista", country: "Brazil", timezone: "America/Boa_Vista" },
  { city: "Macapá", country: "Brazil", timezone: "America/Belem" },
  { city: "Belem", country: "Brazil", timezone: "America/Belem" },
  { city: "Brasilia", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Porto Alegre", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Curitiba", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Fortaleza", country: "Brazil", timezone: "America/Fortaleza" },
  { city: "Salvador", country: "Brazil", timezone: "America/Bahia" },
  { city: "Goiania", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Recife", country: "Brazil", timezone: "America/Recife" },
  { city: "Rio de Janeiro", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Sao Paulo", country: "Brazil", timezone: "America/Sao_Paulo" },
  { city: "Bandar Seri Begawan", country: "Brunei", timezone: "Asia/Brunei" },
  { city: "Lovec", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Montana", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Razgrad", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Sliven", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Plovdiv", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Pernik", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Vratsa", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Shumen", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Khaskovo", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Stara Zagora", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Pleven", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Turnovo", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Kyustendil", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Dobrich", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Varna", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Ruse", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Burgas", country: "Bulgaria", timezone: "Europe/Sofia" },
  { city: "Sofia", country: "Bulgaria", timezone: "Europe/Sofia" },
  {
    city: "Fada Ngourma",
    country: "Burkina Faso",
    timezone: "Africa/Ouagadougou",
  },
  { city: "Orodara", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Solenzo", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Nouna", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Dedougou", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  {
    city: "Gorom Gorom",
    country: "Burkina Faso",
    timezone: "Africa/Ouagadougou",
  },
  { city: "Djibo", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Tougan", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  {
    city: "Kombissiri",
    country: "Burkina Faso",
    timezone: "Africa/Ouagadougou",
  },
  { city: "Ziniare", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Yako", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Reo", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Leo", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Sapouy", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Boulsa", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Zorgo", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Koupela", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Po", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Manga", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  {
    city: "Diebougou",
    country: "Burkina Faso",
    timezone: "Africa/Ouagadougou",
  },
  { city: "Gaoua", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Bogande", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Dori", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Sebba", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  { city: "Diapaga", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  {
    city: "Koudougou",
    country: "Burkina Faso",
    timezone: "Africa/Ouagadougou",
  },
  {
    city: "Ouahigouya",
    country: "Burkina Faso",
    timezone: "Africa/Ouagadougou",
  },
  { city: "Kaya", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  {
    city: "Tenkodogo",
    country: "Burkina Faso",
    timezone: "Africa/Ouagadougou",
  },
  { city: "Banfora", country: "Burkina Faso", timezone: "Africa/Ouagadougou" },
  {
    city: "Bobo Dioulasso",
    country: "Burkina Faso",
    timezone: "Africa/Ouagadougou",
  },
  {
    city: "Ouagadougou",
    country: "Burkina Faso",
    timezone: "Africa/Ouagadougou",
  },
  { city: "Cankuzo", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Karusi", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Rutana", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Ruyigi", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Bubanza", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Kayanza", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Makamba", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Ngozi", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Kirundo", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Muramvya", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Bururi", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Muyinga", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Gitega", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Bujumbura", country: "Burundi", timezone: "Africa/Bujumbura" },
  { city: "Kampong Spoe", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Kampong Thum", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Prey Veng", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  {
    city: "Phnum Tbeng Meanchey",
    country: "Cambodia",
    timezone: "Asia/Phnom_Penh",
  },
  { city: "Stoeng Treng", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Kracheh", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Senmonorom", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Lumphat", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Svay Rieng", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Sisophon", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Krong Koh Kong", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Pursat", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Kampong Cham", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Kompong Chhnang", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Kampot", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Takeo", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Battambang", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Siem Reap", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Phnom Penh", country: "Cambodia", timezone: "Asia/Phnom_Penh" },
  { city: "Buea", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Bafang", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Foumban", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Bafoussam", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Kumba", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Eyumojok", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Limbe", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Kribi", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Nkongsamba", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Edea", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Wum", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Kumbo", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Bafia", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Mbalmayo", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Eseka", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Bertoua", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Abong Mbang", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Batouri", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Belabo", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Meiganga", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Ngaoundere", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Tibati", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Kontcha", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Guider", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Mbe", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Douala", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Ebolowa", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Bamenda", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Garoua", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Maroua", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Yaounde", country: "Cameroon", timezone: "Africa/Douala" },
  { city: "Selkirk", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Berens River", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Pukatawagan", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Gimli", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Island Lake", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Melville", country: "Canada", timezone: "America/Regina" },
  { city: "Weyburn", country: "Canada", timezone: "America/Regina" },
  { city: "La Ronge", country: "Canada", timezone: "America/Regina" },
  { city: "Stony Rapids", country: "Canada", timezone: "America/Regina" },
  { city: "Camrose", country: "Canada", timezone: "America/Edmonton" },
  { city: "Hinton", country: "Canada", timezone: "America/Edmonton" },
  { city: "Vegreville", country: "Canada", timezone: "America/Edmonton" },
  { city: "Stettler", country: "Canada", timezone: "America/Edmonton" },
  { city: "Lac La Biche", country: "Canada", timezone: "America/Edmonton" },
  { city: "Wetaskiwin", country: "Canada", timezone: "America/Edmonton" },
  { city: "Meander River", country: "Canada", timezone: "America/Edmonton" },
  { city: "Creston", country: "Canada", timezone: "America/Creston" },
  { city: "Cranbrook", country: "Canada", timezone: "America/Edmonton" },
  { city: "Terrace", country: "Canada", timezone: "America/Vancouver" },
  { city: "Chilliwack", country: "Canada", timezone: "America/Vancouver" },
  { city: "Hall Beach", country: "Canada", timezone: "America/Iqaluit" },
  { city: "Lutselke", country: "Canada", timezone: "America/Yellowknife" },
  { city: "Hay River", country: "Canada", timezone: "America/Yellowknife" },
  { city: "Déline", country: "Canada", timezone: "America/Yellowknife" },
  { city: "Paulatuk", country: "Canada", timezone: "America/Yellowknife" },
  { city: "Tsiigehtchic", country: "Canada", timezone: "America/Yellowknife" },
  { city: "Owen Sound", country: "Canada", timezone: "America/Toronto" },
  { city: "Orillia", country: "Canada", timezone: "America/Toronto" },
  { city: "Kapuskasing", country: "Canada", timezone: "America/Toronto" },
  { city: "Thessalon", country: "Canada", timezone: "America/Toronto" },
  { city: "Geraldton", country: "Canada", timezone: "America/Toronto" },
  { city: "Belleville", country: "Canada", timezone: "America/Toronto" },
  { city: "Sarnia", country: "Canada", timezone: "America/Toronto" },
  { city: "Peterborough", country: "Canada", timezone: "America/Toronto" },
  { city: "Oshawa", country: "Canada", timezone: "America/Toronto" },
  { city: "London", country: "Canada", timezone: "America/Toronto" },
  { city: "Kitchener", country: "Canada", timezone: "America/Toronto" },
  { city: "New Liskeard", country: "Canada", timezone: "America/Toronto" },
  { city: "Brockville", country: "Canada", timezone: "America/Toronto" },
  { city: "Big Beaver House", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Port-Menier", country: "Canada", timezone: "America/Montreal" },
  { city: "Riviere-du-Loup", country: "Canada", timezone: "America/Montreal" },
  { city: "Drummondville", country: "Canada", timezone: "America/Montreal" },
  { city: "Sherbrooke", country: "Canada", timezone: "America/Montreal" },
  { city: "Cap-Chat", country: "Canada", timezone: "America/Montreal" },
  { city: "Baie-Comeau", country: "Canada", timezone: "America/Montreal" },
  { city: "Natashquan", country: "Canada", timezone: "America/Montreal" },
  { city: "Eastmain", country: "Canada", timezone: "America/Montreal" },
  { city: "Schefferville", country: "Canada", timezone: "America/Montreal" },
  { city: "Salluit", country: "Canada", timezone: "America/Montreal" },
  { city: "Amos", country: "Canada", timezone: "America/Montreal" },
  { city: "Joliette", country: "Canada", timezone: "America/Montreal" },
  { city: "St.-Jerome", country: "Canada", timezone: "America/Montreal" },
  { city: "St-Augustin", country: "Canada", timezone: "America/Blanc-Sablon" },
  { city: "Rouyn-Noranda", country: "Canada", timezone: "America/Montreal" },
  { city: "La Sarre", country: "Canada", timezone: "America/Montreal" },
  { city: "New Glasgow", country: "Canada", timezone: "America/Halifax" },
  { city: "Liverpool", country: "Canada", timezone: "America/Halifax" },
  { city: "Amherst", country: "Canada", timezone: "America/Halifax" },
  { city: "Baddeck", country: "Canada", timezone: "America/Halifax" },
  { city: "Deer Lake", country: "Canada", timezone: "America/St_Johns" },
  { city: "La Scie", country: "Canada", timezone: "America/St_Johns" },
  { city: "Hopedale", country: "Canada", timezone: "America/Goose_Bay" },
  {
    city: "Happy Valley - Goose Bay",
    country: "Canada",
    timezone: "America/Goose_Bay",
  },
  {
    city: "Port Hope Simpson",
    country: "Canada",
    timezone: "America/St_Johns",
  },
  { city: "Tofino", country: "Canada", timezone: "America/Vancouver" },
  { city: "Steinbach", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Nelson House", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Shamattawa", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Oxford House", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Yorkton", country: "Canada", timezone: "America/Regina" },
  { city: "Swift Current", country: "Canada", timezone: "America/Regina" },
  { city: "Biggar", country: "Canada", timezone: "America/Regina" },
  { city: "Kindersley", country: "Canada", timezone: "America/Regina" },
  { city: "Meadow Lake", country: "Canada", timezone: "America/Regina" },
  { city: "Hudson Bay", country: "Canada", timezone: "America/Regina" },
  { city: "Lethbridge", country: "Canada", timezone: "America/Edmonton" },
  { city: "Brooks", country: "Canada", timezone: "America/Edmonton" },
  { city: "Lake Louise", country: "Canada", timezone: "America/Edmonton" },
  { city: "Athabasca", country: "Canada", timezone: "America/Edmonton" },
  { city: "Fort Chipewyan", country: "Canada", timezone: "America/Edmonton" },
  { city: "Bella Bella", country: "Canada", timezone: "America/Vancouver" },
  { city: "Sandspit", country: "Canada", timezone: "America/Vancouver" },
  { city: "Campbell River", country: "Canada", timezone: "America/Vancouver" },
  { city: "Port Hardy", country: "Canada", timezone: "America/Vancouver" },
  { city: "Nanaimo", country: "Canada", timezone: "America/Vancouver" },
  { city: "Quesnel", country: "Canada", timezone: "America/Vancouver" },
  { city: "Abbotsford", country: "Canada", timezone: "America/Vancouver" },
  { city: "Dawson Creek", country: "Canada", timezone: "America/Dawson_Creek" },
  { city: "Penticton", country: "Canada", timezone: "America/Vancouver" },
  { city: "Nelson", country: "Canada", timezone: "America/Vancouver" },
  { city: "Lillooet", country: "Canada", timezone: "America/Vancouver" },
  { city: "Powell River", country: "Canada", timezone: "America/Vancouver" },
  { city: "Revelstoke", country: "Canada", timezone: "America/Vancouver" },
  { city: "Burns Lake", country: "Canada", timezone: "America/Vancouver" },
  { city: "Dease Lake", country: "Canada", timezone: "America/Vancouver" },
  {
    city: "Coral Harbour",
    country: "Canada",
    timezone: "America/Coral_Harbour",
  },
  { city: "Baker Lake", country: "Canada", timezone: "America/Rankin_Inlet" },
  { city: "Norman Wells", country: "Canada", timezone: "America/Yellowknife" },
  {
    city: "Fort McPherson",
    country: "Canada",
    timezone: "America/Yellowknife",
  },
  {
    city: "Burwash Landing",
    country: "Canada",
    timezone: "America/Whitehorse",
  },
  { city: "Orangeville", country: "Canada", timezone: "America/Toronto" },
  { city: "Little Current", country: "Canada", timezone: "America/Toronto" },
  { city: "Chapleau", country: "Canada", timezone: "America/Toronto" },
  { city: "Wawa", country: "Canada", timezone: "America/Toronto" },
  { city: "Hearst", country: "Canada", timezone: "America/Toronto" },
  { city: "Marathon", country: "Canada", timezone: "America/Toronto" },
  { city: "Sioux Lookout", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Red Lake", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Deer Lake", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Cat Lake", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Cornwall", country: "Canada", timezone: "America/Toronto" },
  { city: "Kingston", country: "Canada", timezone: "America/Toronto" },
  { city: "Barrie", country: "Canada", timezone: "America/Toronto" },
  { city: "Parry Sound", country: "Canada", timezone: "America/Toronto" },
  { city: "Wiarton", country: "Canada", timezone: "America/Toronto" },
  { city: "Cobalt", country: "Canada", timezone: "America/Toronto" },
  { city: "Cochrane", country: "Canada", timezone: "America/Toronto" },
  { city: "Nipigon", country: "Canada", timezone: "America/Nipigon" },
  { city: "Atikokan", country: "Canada", timezone: "America/Atikokan" },
  { city: "Rimouski", country: "Canada", timezone: "America/Montreal" },
  { city: "Saint-Georges", country: "Canada", timezone: "America/Montreal" },
  { city: "Victoriaville", country: "Canada", timezone: "America/Montreal" },
  { city: "Chevery", country: "Canada", timezone: "America/Blanc-Sablon" },
  { city: "Mistassini", country: "Canada", timezone: "America/Montreal" },
  { city: "Kangirsuk", country: "Canada", timezone: "America/Montreal" },
  { city: "Shawinigan", country: "Canada", timezone: "America/Montreal" },
  { city: "Matagami", country: "Canada", timezone: "America/Montreal" },
  { city: "Mont-Laurier", country: "Canada", timezone: "America/Montreal" },
  { city: "Pembroke", country: "Canada", timezone: "America/Montreal" },
  { city: "Radisson", country: "Canada", timezone: "America/Montreal" },
  { city: "Saint John", country: "Canada", timezone: "America/Moncton" },
  { city: "Edmundston", country: "Canada", timezone: "America/Moncton" },
  { city: "Shelburne", country: "Canada", timezone: "America/Halifax" },
  { city: "Antigonish", country: "Canada", timezone: "America/Halifax" },
  { city: "Windsor", country: "Canada", timezone: "America/Halifax" },
  { city: "Digby", country: "Canada", timezone: "America/Halifax" },
  { city: "Stephenville", country: "Canada", timezone: "America/St_Johns" },
  { city: "Argentia", country: "Canada", timezone: "America/St_Johns" },
  { city: "St. Anthony", country: "Canada", timezone: "America/St_Johns" },
  {
    city: "Channel-Port aux Basques",
    country: "Canada",
    timezone: "America/St_Johns",
  },
  { city: "Buchans", country: "Canada", timezone: "America/St_Johns" },
  { city: "Trout River", country: "Canada", timezone: "America/St_Johns" },
  { city: "Churchill Falls", country: "Canada", timezone: "America/Goose_Bay" },
  { city: "Forteau", country: "Canada", timezone: "America/St_Johns" },
  { city: "Trepassey", country: "Canada", timezone: "America/St_Johns" },
  { city: "Brochet", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Lynn Lake", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Gillam", country: "Canada", timezone: "America/Winnipeg" },
  { city: "North Battleford", country: "Canada", timezone: "America/Regina" },
  { city: "Prince Albert", country: "Canada", timezone: "America/Regina" },
  { city: "Courtenay", country: "Canada", timezone: "America/Vancouver" },
  { city: "Kelowna", country: "Canada", timezone: "America/Vancouver" },
  { city: "Pangnirtung", country: "Canada", timezone: "America/Pangnirtung" },
  { city: "Holman", country: "Canada", timezone: "America/Yellowknife" },
  { city: "Dryden", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Attawapiskat", country: "Canada", timezone: "America/Toronto" },
  { city: "Hamilton", country: "Canada", timezone: "America/Toronto" },
  { city: "Windsor", country: "Canada", timezone: "America/Detroit" },
  { city: "Trois-Rivières", country: "Canada", timezone: "America/Montreal" },
  { city: "Sept-Îles", country: "Canada", timezone: "America/Montreal" },
  { city: "Corner Brook", country: "Canada", timezone: "America/St_Johns" },
  { city: "Norway House", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Flin Flon", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Dauphin", country: "Canada", timezone: "America/Winnipeg" },
  { city: "The Pas", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Uranium City", country: "Canada", timezone: "America/Regina" },
  { city: "Moose Jaw", country: "Canada", timezone: "America/Regina" },
  { city: "Jasper", country: "Canada", timezone: "America/Edmonton" },
  { city: "Medicine Hat", country: "Canada", timezone: "America/Edmonton" },
  { city: "Red Deer", country: "Canada", timezone: "America/Edmonton" },
  { city: "Banff", country: "Canada", timezone: "America/Edmonton" },
  { city: "Grand Prairie", country: "Canada", timezone: "America/Edmonton" },
  { city: "Smithers", country: "Canada", timezone: "America/Vancouver" },
  { city: "Kamloops", country: "Canada", timezone: "America/Vancouver" },
  { city: "Williams Lake", country: "Canada", timezone: "America/Vancouver" },
  { city: "Prince George", country: "Canada", timezone: "America/Vancouver" },
  { city: "Fort Nelson", country: "Canada", timezone: "America/Fort_Nelson" },
  { city: "Pond Inlet", country: "Canada", timezone: "America/Iqaluit" },
  { city: "Cape Dorset", country: "Canada", timezone: "America/Iqaluit" },
  { city: "Kimmirut", country: "Canada", timezone: "America/Iqaluit" },
  { city: "Gjoa Haven", country: "Canada", timezone: "America/Cambridge_Bay" },
  { city: "Grise Fiord", country: "Canada", timezone: "America/Iqaluit" },
  { city: "Alert", country: "Canada", timezone: "America/Pangnirtung" },
  { city: "Ennadai", country: "Canada", timezone: "America/Rankin_Inlet" },
  { city: "Rankin Inlet", country: "Canada", timezone: "America/Rankin_Inlet" },
  {
    city: "Fort Resolution",
    country: "Canada",
    timezone: "America/Yellowknife",
  },
  { city: "Fort Simpson", country: "Canada", timezone: "America/Yellowknife" },
  { city: "Inuvik", country: "Canada", timezone: "America/Inuvik" },
  { city: "Tuktoyaktuk", country: "Canada", timezone: "America/Yellowknife" },
  { city: "Watson Lake", country: "Canada", timezone: "America/Whitehorse" },
  { city: "Lansdowne House", country: "Canada", timezone: "America/Toronto" },
  { city: "Moosonee", country: "Canada", timezone: "America/Toronto" },
  { city: "Sudbury", country: "Canada", timezone: "America/Toronto" },
  { city: "Kenora", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Gaspe", country: "Canada", timezone: "America/Montreal" },
  { city: "Mingan", country: "Canada", timezone: "America/Montreal" },
  { city: "Dolbeau", country: "Canada", timezone: "America/Montreal" },
  { city: "Val d'Or", country: "Canada", timezone: "America/Montreal" },
  { city: "Ivugivik", country: "Canada", timezone: "America/Montreal" },
  { city: "Inukjuak", country: "Canada", timezone: "America/Montreal" },
  { city: "Chicoutimi", country: "Canada", timezone: "America/Montreal" },
  { city: "Moncton", country: "Canada", timezone: "America/Moncton" },
  { city: "Fredericton", country: "Canada", timezone: "America/Moncton" },
  { city: "Bathurst", country: "Canada", timezone: "America/Moncton" },
  { city: "Yarmouth", country: "Canada", timezone: "America/Halifax" },
  { city: "Gander", country: "Canada", timezone: "America/St_Johns" },
  { city: "Cartwright", country: "Canada", timezone: "America/Goose_Bay" },
  { city: "Rigolet", country: "Canada", timezone: "America/Goose_Bay" },
  { city: "Port Burwell", country: "Canada", timezone: "America/Goose_Bay" },
  { city: "Thompson", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Brandon", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Fort Smith", country: "Canada", timezone: "America/Yellowknife" },
  { city: "Fort McMurray", country: "Canada", timezone: "America/Edmonton" },
  { city: "Peace River", country: "Canada", timezone: "America/Edmonton" },
  { city: "Fort St. John", country: "Canada", timezone: null },
  { city: "Iqaluit", country: "Canada", timezone: "America/Iqaluit" },
  {
    city: "Cambridge Bay",
    country: "Canada",
    timezone: "America/Cambridge_Bay",
  },
  { city: "Kugluktuk", country: "Canada", timezone: "America/Cambridge_Bay" },
  {
    city: "Chesterfield Inlet",
    country: "Canada",
    timezone: "America/Rankin_Inlet",
  },
  { city: "Arviat", country: "Canada", timezone: "America/Rankin_Inlet" },
  { city: "Taloyoak", country: "Canada", timezone: "America/Cambridge_Bay" },
  { city: "Igloolik", country: "Canada", timezone: "America/Iqaluit" },
  { city: "Dawson City", country: "Canada", timezone: "America/Dawson" },
  { city: "Timmins", country: "Canada", timezone: "America/Toronto" },
  { city: "North Bay", country: "Canada", timezone: "America/Toronto" },
  { city: "Kuujjuarapik", country: "Canada", timezone: "America/Montreal" },
  { city: "Kuujjuaq", country: "Canada", timezone: "America/Montreal" },
  { city: "Sydney", country: "Canada", timezone: "America/Glace_Bay" },
  { city: "Labrador City", country: "Canada", timezone: "America/Goose_Bay" },
  { city: "Winnipeg", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Churchill", country: "Canada", timezone: "America/Winnipeg" },
  { city: "Regina", country: "Canada", timezone: "America/Regina" },
  { city: "Saskatoon", country: "Canada", timezone: "America/Regina" },
  { city: "Calgary", country: "Canada", timezone: "America/Edmonton" },
  { city: "Prince Rupert", country: "Canada", timezone: "America/Vancouver" },
  { city: "Victoria", country: "Canada", timezone: "America/Vancouver" },
  { city: "Arctic Bay", country: "Canada", timezone: "America/Rankin_Inlet" },
  { city: "Resolute", country: "Canada", timezone: "America/Resolute" },
  { city: "Repulse Bay", country: "Canada", timezone: "America/Rankin_Inlet" },
  { city: "Yellowknife", country: "Canada", timezone: "America/Yellowknife" },
  {
    city: "Fort Good Hope",
    country: "Canada",
    timezone: "America/Yellowknife",
  },
  { city: "Whitehorse", country: "Canada", timezone: "America/Whitehorse" },
  { city: "Ottawa", country: "Canada", timezone: "America/Toronto" },
  { city: "Fort Severn", country: "Canada", timezone: "America/Toronto" },
  { city: "Thunder Bay", country: "Canada", timezone: "America/Thunder_Bay" },
  { city: "Québec", country: "Canada", timezone: "America/Montreal" },
  { city: "Halifax", country: "Canada", timezone: "America/Halifax" },
  { city: "St. John’s", country: "Canada", timezone: "America/St_Johns" },
  { city: "Nain", country: "Canada", timezone: "America/Goose_Bay" },
  { city: "Charlottetown", country: "Canada", timezone: "America/Halifax" },
  { city: "Edmonton", country: "Canada", timezone: "America/Edmonton" },
  { city: "Montréal", country: "Canada", timezone: "America/Montreal" },
  { city: "Vancouver", country: "Canada", timezone: "America/Vancouver" },
  { city: "Toronto", country: "Canada", timezone: "America/Toronto" },
  { city: "Mindelo", country: "Cape Verde", timezone: "Atlantic/Cape_Verde" },
  { city: "Praia", country: "Cape Verde", timezone: "Atlantic/Cape_Verde" },
  {
    city: "George Town",
    country: "Cayman Islands",
    timezone: "America/Cayman",
  },
  {
    city: "Mobaye",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Mbaiki",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Carnot",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Bozoum",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Kaga Bandoro",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Zemio",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Yakossi",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Nola",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Sibut",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Bossangoa",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Birao",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Ouadda",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Bangassou",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Bossembele",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Berberati",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Bria",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Bouar",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Bambari",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Ndele",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Obo",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  {
    city: "Bangui",
    country: "Central African Republic",
    timezone: "Africa/Bangui",
  },
  { city: "Lai", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Zouar", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Bol", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Ati", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Oum Hadjer", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Mongo", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Doba", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Pala", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Bongor", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Kelo", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Fada", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Faya Largeau", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Mao", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Biltine", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Sarh", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Am Timan", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Moundou", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Ndjamena", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Abeche", country: "Chad", timezone: "Africa/Ndjamena" },
  { city: "Rio Verde", country: "Chile", timezone: "America/Santiago" },
  { city: "Cuya", country: "Chile", timezone: "America/Santiago" },
  { city: "Chuquicamata", country: "Chile", timezone: "America/Santiago" },
  { city: "Maria Elena", country: "Chile", timezone: "America/Santiago" },
  { city: "Tierra Amarilla", country: "Chile", timezone: "America/Santiago" },
  { city: "Combarbala", country: "Chile", timezone: "America/Santiago" },
  { city: "San Bernardo", country: "Chile", timezone: "America/Santiago" },
  { city: "San Felipe", country: "Chile", timezone: "America/Santiago" },
  { city: "Vina del Mar", country: "Chile", timezone: "America/Santiago" },
  { city: "La Ligua", country: "Chile", timezone: "America/Santiago" },
  { city: "Quillota", country: "Chile", timezone: "America/Santiago" },
  { city: "Nueva Imperial", country: "Chile", timezone: "America/Santiago" },
  { city: "Loncoche", country: "Chile", timezone: "America/Santiago" },
  { city: "Villarica", country: "Chile", timezone: "America/Santiago" },
  { city: "Tolten", country: "Chile", timezone: "America/Santiago" },
  { city: "Lonquimay", country: "Chile", timezone: "America/Santiago" },
  { city: "Angol", country: "Chile", timezone: "America/Santiago" },
  { city: "Collipulli", country: "Chile", timezone: "America/Santiago" },
  { city: "La Union", country: "Chile", timezone: "America/Santiago" },
  { city: "Rio Bueno", country: "Chile", timezone: "America/Santiago" },
  { city: "Coronel", country: "Chile", timezone: "America/Santiago" },
  { city: "Talcahuano", country: "Chile", timezone: "America/Santiago" },
  { city: "Quirihue", country: "Chile", timezone: "America/Santiago" },
  { city: "Curanilahue", country: "Chile", timezone: "America/Santiago" },
  { city: "Santa Barbara", country: "Chile", timezone: "America/Santiago" },
  { city: "Pichilemu", country: "Chile", timezone: "America/Santiago" },
  { city: "San Fernando", country: "Chile", timezone: "America/Santiago" },
  { city: "Puerto Varas", country: "Chile", timezone: "America/Santiago" },
  { city: "Calbuco", country: "Chile", timezone: "America/Santiago" },
  { city: "Castro", country: "Chile", timezone: "America/Santiago" },
  { city: "Chonchi", country: "Chile", timezone: "America/Santiago" },
  { city: "Linares", country: "Chile", timezone: "America/Santiago" },
  { city: "Cauquenes", country: "Chile", timezone: "America/Santiago" },
  { city: "Cochrane", country: "Chile", timezone: "America/Santiago" },
  { city: "Lagunas", country: "Chile", timezone: "America/Santiago" },
  { city: "Pozo Almonte", country: "Chile", timezone: "America/Santiago" },
  { city: "Toconao", country: "Chile", timezone: "America/Santiago" },
  { city: "Huasco", country: "Chile", timezone: "America/Santiago" },
  { city: "Diego de Almagro", country: "Chile", timezone: "America/Santiago" },
  { city: "Caldera", country: "Chile", timezone: "America/Santiago" },
  { city: "Coquimbo", country: "Chile", timezone: "America/Santiago" },
  { city: "Vicuna", country: "Chile", timezone: "America/Santiago" },
  { city: "Illapel", country: "Chile", timezone: "America/Santiago" },
  { city: "Salamanca", country: "Chile", timezone: "America/Santiago" },
  { city: "Los Andes", country: "Chile", timezone: "America/Santiago" },
  { city: "San Antonio", country: "Chile", timezone: "America/Santiago" },
  { city: "Victoria", country: "Chile", timezone: "America/Santiago" },
  { city: "Carahue", country: "Chile", timezone: "America/Santiago" },
  { city: "Los Lagos", country: "Chile", timezone: "America/Santiago" },
  { city: "Lota", country: "Chile", timezone: "America/Santiago" },
  { city: "Lebu", country: "Chile", timezone: "America/Santiago" },
  { city: "Quellon", country: "Chile", timezone: "America/Santiago" },
  { city: "Constitucion", country: "Chile", timezone: "America/Santiago" },
  { city: "Villa O'Higgins", country: "Chile", timezone: "America/Santiago" },
  { city: "Puerto Aisen", country: "Chile", timezone: "America/Santiago" },
  { city: "Puerto Natales", country: "Chile", timezone: "America/Santiago" },
  { city: "Puerto Williams", country: "Chile", timezone: "America/Santiago" },
  { city: "Temuco", country: "Chile", timezone: "America/Santiago" },
  { city: "Tocopilla", country: "Chile", timezone: "America/Santiago" },
  { city: "Calama", country: "Chile", timezone: "America/Santiago" },
  { city: "Mejillones", country: "Chile", timezone: "America/Santiago" },
  { city: "Taltal", country: "Chile", timezone: "America/Santiago" },
  { city: "Vallenar", country: "Chile", timezone: "America/Santiago" },
  { city: "Chanaral", country: "Chile", timezone: "America/Santiago" },
  { city: "Ovalle", country: "Chile", timezone: "America/Santiago" },
  { city: "Chillan", country: "Chile", timezone: "America/Santiago" },
  { city: "Rancagua", country: "Chile", timezone: "America/Santiago" },
  { city: "Osorno", country: "Chile", timezone: "America/Santiago" },
  { city: "Ancud", country: "Chile", timezone: "America/Santiago" },
  { city: "Talca", country: "Chile", timezone: "America/Santiago" },
  { city: "Curico", country: "Chile", timezone: "America/Santiago" },
  { city: "Coihaique", country: "Chile", timezone: "America/Santiago" },
  { city: "Arica", country: "Chile", timezone: "America/Santiago" },
  { city: "Copiapo", country: "Chile", timezone: "America/Santiago" },
  { city: "La Serena", country: "Chile", timezone: "America/Santiago" },
  { city: "Los Angeles", country: "Chile", timezone: "America/Santiago" },
  { city: "Punta Arenas", country: "Chile", timezone: "America/Santiago" },
  { city: "Iquique", country: "Chile", timezone: "America/Santiago" },
  { city: "Antofagasta", country: "Chile", timezone: "America/Santiago" },
  { city: "Valparaiso", country: "Chile", timezone: "America/Santiago" },
  { city: "Valdivia", country: "Chile", timezone: "America/Santiago" },
  { city: "Concepcion", country: "Chile", timezone: "America/Santiago" },
  { city: "Puerto Montt", country: "Chile", timezone: "America/Santiago" },
  { city: "Santiago", country: "Chile", timezone: "America/Santiago" },
  { city: "Yumen", country: "China", timezone: "Asia/Urumqi" },
  { city: "Linxia", country: "China", timezone: "Asia/Chongqing" },
  { city: "Zhuozhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Sanming", country: "China", timezone: "Asia/Shanghai" },
  { city: "Huizhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Chaozhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Gyangze", country: "China", timezone: "Asia/Urumqi" },
  { city: "Dali", country: "China", timezone: "Asia/Chongqing" },
  { city: "Yangquan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shiyan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Danjiangkou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shashi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Anlu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zixing", country: "China", timezone: "Asia/Shanghai" },
  { city: "Deyang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Tengchong", country: "China", timezone: "Asia/Chongqing" },
  { city: "Mengzi", country: "China", timezone: "Asia/Chongqing" },
  { city: "Chuxiong", country: "China", timezone: "Asia/Chongqing" },
  { city: "Hengshui", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xuanhua", country: "China", timezone: "Asia/Shanghai" },
  { city: "Luohe", country: "China", timezone: "Asia/Shanghai" },
  { city: "Beipiao", country: "China", timezone: "Asia/Shanghai" },
  { city: "Wafangdian", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhucheng", country: "China", timezone: "Asia/Shanghai" },
  { city: "Hangu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xinyi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yangzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Linhai", country: "China", timezone: "Asia/Shanghai" },
  { city: "Huangyan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Daan", country: "China", timezone: "Asia/Harbin" },
  { city: "Changling", country: "China", timezone: "Asia/Harbin" },
  { city: "Tonghua", country: "China", timezone: "Asia/Harbin" },
  { city: "Baishan", country: "China", timezone: "Asia/Harbin" },
  { city: "Yanji", country: "China", timezone: "Asia/Harbin" },
  { city: "Ergun Zuoqi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shangdu", country: "China", timezone: "Asia/Chongqing" },
  { city: "Orongen Zizhiqi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zalantun", country: "China", timezone: "Asia/Shanghai" },
  { city: "Wuchuan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Hanggin Houqi", country: "China", timezone: "Asia/Chongqing" },
  { city: "Anda", country: "China", timezone: "Asia/Harbin" },
  { city: "Qinggang", country: "China", timezone: "Asia/Harbin" },
  { city: "Angangxi", country: "China", timezone: "Asia/Harbin" },
  { city: "Hulan Ergi", country: "China", timezone: "Asia/Harbin" },
  { city: "Qingan", country: "China", timezone: "Asia/Harbin" },
  { city: "Baiquan", country: "China", timezone: "Asia/Harbin" },
  { city: "Suileng", country: "China", timezone: "Asia/Harbin" },
  { city: "Linkou", country: "China", timezone: "Asia/Harbin" },
  { city: "Longxi", country: "China", timezone: "Asia/Chongqing" },
  { city: "Pingliang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Anxi", country: "China", timezone: "Asia/Urumqi" },
  { city: "Minxian", country: "China", timezone: "Asia/Chongqing" },
  { city: "Jinchang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Guide", country: "China", timezone: "Asia/Chongqing" },
  { city: "Qinzhou", country: "China", timezone: "Asia/Chongqing" },
  { city: "Pingxiang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Yishan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Beihai", country: "China", timezone: "Asia/Chongqing" },
  { city: "Hechi", country: "China", timezone: "Asia/Chongqing" },
  { city: "Tongren", country: "China", timezone: "Asia/Chongqing" },
  { city: "Fengjie", country: "China", timezone: "Asia/Chongqing" },
  { city: "Changping", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shaowu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Longyan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhangzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Putian", country: "China", timezone: "Asia/Shanghai" },
  { city: "Fuan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Changting", country: "China", timezone: "Asia/Shanghai" },
  { city: "Nanping", country: "China", timezone: "Asia/Shanghai" },
  { city: "Ninde", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jieshou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Tongling", country: "China", timezone: "Asia/Shanghai" },
  { city: "Maanshan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Fuyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yangjiang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Meizhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Heyuan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Qingyuan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhaoqing", country: "China", timezone: "Asia/Shanghai" },
  { city: "Lianxian", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jiangmen", country: "China", timezone: "Asia/Shanghai" },
  { city: "Maoming", country: "China", timezone: "Asia/Urumqi" },
  { city: "Gar", country: "China", timezone: "Asia/Kashgar" },
  { city: "Turpan", country: "China", timezone: "Asia/Urumqi" },
  { city: "Quiemo", country: "China", timezone: "Asia/Urumqi" },
  { city: "Koktokay", country: "China", timezone: "Asia/Urumqi" },
  { city: "Hancheng", country: "China", timezone: "Asia/Chongqing" },
  { city: "Weinan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Shuozhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xinzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jincheng", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jiexiu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Changzhi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Guangshui", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jingmen", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zicheng", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shishou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xiaogan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Puqi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yunxian", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jinshi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Chenzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhijiang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xiangtan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zigong", country: "China", timezone: "Asia/Chongqing" },
  { city: "Yaan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Langzhong", country: "China", timezone: "Asia/Chongqing" },
  { city: "Rongzhag", country: "China", timezone: "Asia/Chongqing" },
  { city: "Simao", country: "China", timezone: "Asia/Chongqing" },
  { city: "Wenshan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Zhanyi", country: "China", timezone: "Asia/Chongqing" },
  { city: "Huize", country: "China", timezone: "Asia/Chongqing" },
  { city: "Chengde", country: "China", timezone: "Asia/Shanghai" },
  { city: "Cangzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Baoding", country: "China", timezone: "Asia/Shanghai" },
  { city: "Huanghua", country: "China", timezone: "Asia/Shanghai" },
  { city: "Dingzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Nangong", country: "China", timezone: "Asia/Shanghai" },
  { city: "Linqing", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xiangtai", country: "China", timezone: "Asia/Shanghai" },
  { city: "Puyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Hebi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xuchang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhoukou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Dengzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Tieling", country: "China", timezone: "Asia/Shanghai" },
  { city: "Chaoyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Huanren", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhuanghe", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yishui", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shanxian", country: "China", timezone: "Asia/Shanghai" },
  { city: "Pingyi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Pingdu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Laiwu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Buizhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Liaocheng", country: "China", timezone: "Asia/Shanghai" },
  { city: "Rizhao", country: "China", timezone: "Asia/Shanghai" },
  { city: "Dezhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Linchuan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Fengcheng", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jian", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shangrao", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jingdezhen", country: "China", timezone: "Asia/Shanghai" },
  { city: "Taizhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shuyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Lianyungang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Lishui", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jiaojing", country: "China", timezone: "Asia/Shanghai" },
  { city: "Quzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Fuyu", country: "China", timezone: "Asia/Harbin" },
  { city: "Dunhua", country: "China", timezone: "Asia/Harbin" },
  { city: "Nongan", country: "China", timezone: "Asia/Harbin" },
  { city: "Taonan", country: "China", timezone: "Asia/Harbin" },
  { city: "Liuhe", country: "China", timezone: "Asia/Harbin" },
  { city: "Huinan", country: "China", timezone: "Asia/Harbin" },
  { city: "Panshi", country: "China", timezone: "Asia/Harbin" },
  { city: "Jiaohe", country: "China", timezone: "Asia/Harbin" },
  { city: "Linjiang", country: "China", timezone: "Asia/Harbin" },
  { city: "Wangqing", country: "China", timezone: "Asia/Harbin" },
  { city: "Helong", country: "China", timezone: "Asia/Harbin" },
  { city: "Shulan", country: "China", timezone: "Asia/Harbin" },
  { city: "Jiutai", country: "China", timezone: "Asia/Harbin" },
  { city: "Alxa Zuoqi", country: "China", timezone: "Asia/Chongqing" },
  { city: "Linxi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Kailu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Bairin Zuoqi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yitulihe", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yakeshi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Bugt", country: "China", timezone: "Asia/Shanghai" },
  { city: "Wuyuan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Bayan Obo", country: "China", timezone: "Asia/Chongqing" },
  { city: "Fengzhen", country: "China", timezone: "Asia/Chongqing" },
  { city: "Suihua", country: "China", timezone: "Asia/Harbin" },
  { city: "Shuangyashan", country: "China", timezone: "Asia/Harbin" },
  { city: "Shangzhi", country: "China", timezone: "Asia/Harbin" },
  { city: "Fujin", country: "China", timezone: "Asia/Harbin" },
  { city: "Yian", country: "China", timezone: "Asia/Harbin" },
  { city: "Tailai", country: "China", timezone: "Asia/Harbin" },
  { city: "Longjiang", country: "China", timezone: "Asia/Harbin" },
  { city: "Gannan", country: "China", timezone: "Asia/Harbin" },
  { city: "Hailun", country: "China", timezone: "Asia/Harbin" },
  { city: "Mishan", country: "China", timezone: "Asia/Harbin" },
  { city: "Tieli", country: "China", timezone: "Asia/Harbin" },
  { city: "Shuangcheng", country: "China", timezone: "Asia/Harbin" },
  { city: "Zhaodong", country: "China", timezone: "Asia/Harbin" },
  { city: "Lanxi", country: "China", timezone: "Asia/Harbin" },
  { city: "Keshan", country: "China", timezone: "Asia/Harbin" },
  { city: "Nancha", country: "China", timezone: "Asia/Harbin" },
  { city: "Xinqing", country: "China", timezone: "Asia/Harbin" },
  { city: "Hulin", country: "China", timezone: "Asia/Harbin" },
  { city: "Boli", country: "China", timezone: "Asia/Harbin" },
  { city: "Ningan", country: "China", timezone: "Asia/Harbin" },
  { city: "Jyekundo", country: "China", timezone: "Asia/Urumqi" },
  { city: "Liuzhou", country: "China", timezone: "Asia/Chongqing" },
  { city: "Xingyi", country: "China", timezone: "Asia/Chongqing" },
  { city: "Anshun", country: "China", timezone: "Asia/Chongqing" },
  { city: "Zunyi", country: "China", timezone: "Asia/Chongqing" },
  { city: "Wanzhou", country: "China", timezone: "Asia/Chongqing" },
  { city: "Huaibei", country: "China", timezone: "Asia/Shanghai" },
  { city: "Wuhu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Luan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Bengbu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Anqing", country: "China", timezone: "Asia/Shanghai" },
  { city: "Foshan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Nagchu", country: "China", timezone: "Asia/Urumqi" },
  { city: "Nyingchi", country: "China", timezone: "Asia/Urumqi" },
  { city: "Chamdo", country: "China", timezone: "Asia/Urumqi" },
  { city: "Korla", country: "China", timezone: "Asia/Urumqi" },
  { city: "Kuqa", country: "China", timezone: "Asia/Urumqi" },
  { city: "Tacheng", country: "China", timezone: "Asia/Urumqi" },
  { city: "Shihezi", country: "China", timezone: "Asia/Urumqi" },
  { city: "Karamay", country: "China", timezone: "Asia/Urumqi" },
  { city: "Aksu", country: "China", timezone: "Asia/Kashgar" },
  { city: "Sanya", country: "China", timezone: "Asia/Chongqing" },
  { city: "Haikou", country: "China", timezone: "Asia/Chongqing" },
  { city: "Hanzhong", country: "China", timezone: "Asia/Chongqing" },
  { city: "Baoji", country: "China", timezone: "Asia/Chongqing" },
  { city: "Tongchuan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Linfen", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yuci", country: "China", timezone: "Asia/Shanghai" },
  { city: "Datong", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jianmen", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yichang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xiantao", country: "China", timezone: "Asia/Shanghai" },
  { city: "Macheng", country: "China", timezone: "Asia/Shanghai" },
  { city: "Huangshi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhuzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yongzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yiyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Changde", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shaoyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Leshan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Panzhihua", country: "China", timezone: "Asia/Chongqing" },
  { city: "Fulin", country: "China", timezone: "Asia/Chongqing" },
  { city: "Guangyuan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Luzhou", country: "China", timezone: "Asia/Chongqing" },
  { city: "Yibin", country: "China", timezone: "Asia/Chongqing" },
  { city: "Zhaotang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Lijiang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Yuxi", country: "China", timezone: "Asia/Chongqing" },
  { city: "Dali", country: "China", timezone: "Asia/Chongqing" },
  { city: "Qinhuangdao", country: "China", timezone: "Asia/Shanghai" },
  { city: "Langfang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhangjiakou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Tangshan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Anyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jiaozuo", country: "China", timezone: "Asia/Shanghai" },
  { city: "Kaifeng", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shangqiu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Pingdingshan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xinyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xinxiang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Luoyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Liaoyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Dandong", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yingkow", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jinzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Fuxin", country: "China", timezone: "Asia/Shanghai" },
  { city: "Benxi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Fushun", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jining", country: "China", timezone: "Asia/Shanghai" },
  { city: "Weifang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Taian", country: "China", timezone: "Asia/Shanghai" },
  { city: "Heze", country: "China", timezone: "Asia/Shanghai" },
  { city: "Laiyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xinyu", country: "China", timezone: "Asia/Shanghai" },
  { city: "Ganzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jiujiang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Changzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhenjiang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Nantong", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jiaxing", country: "China", timezone: "Asia/Shanghai" },
  { city: "Huzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shaoxing", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jinhua", country: "China", timezone: "Asia/Shanghai" },
  { city: "Liaoyuan", country: "China", timezone: "Asia/Harbin" },
  { city: "Tumen", country: "China", timezone: "Asia/Harbin" },
  { city: "Siping", country: "China", timezone: "Asia/Harbin" },
  { city: "Baicheng", country: "China", timezone: "Asia/Harbin" },
  { city: "Wuhai", country: "China", timezone: "Asia/Chongqing" },
  { city: "Erenhot", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jining", country: "China", timezone: "Asia/Chongqing" },
  { city: "Arxan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Manzhouli", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xilinhot", country: "China", timezone: "Asia/Shanghai" },
  { city: "Heihe", country: "China", timezone: "Asia/Harbin" },
  { city: "Qitaihe", country: "China", timezone: "Asia/Harbin" },
  { city: "Yichun", country: "China", timezone: "Asia/Harbin" },
  { city: "Hegang", country: "China", timezone: "Asia/Harbin" },
  { city: "Nenjiang", country: "China", timezone: "Asia/Harbin" },
  { city: "Nehe", country: "China", timezone: "Asia/Harbin" },
  { city: "Mudangiang", country: "China", timezone: "Asia/Harbin" },
  { city: "Xuanzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhuhai", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xianyang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Xiangfan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Suining", country: "China", timezone: "Asia/Chongqing" },
  { city: "Lingyuan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Weihai", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yichun", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yancheng", country: "China", timezone: "Asia/Shanghai" },
  { city: "Fuyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xiamen", country: "China", timezone: "Asia/Shanghai" },
  { city: "Nanchong", country: "China", timezone: "Asia/Chongqing" },
  { city: "Neijiang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Nanyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jinxi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yantai", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zaozhuang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Suzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xuzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Wuxi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jilin", country: "China", timezone: "Asia/Harbin" },
  { city: "Zhangye", country: "China", timezone: "Asia/Chongqing" },
  { city: "Wuwei", country: "China", timezone: "Asia/Chongqing" },
  { city: "Dunhuang", country: "China", timezone: "Asia/Urumqi" },
  { city: "Tianshui", country: "China", timezone: "Asia/Chongqing" },
  { city: "Dulan", country: "China", timezone: "Asia/Urumqi" },
  { city: "Golmud", country: "China", timezone: "Asia/Urumqi" },
  { city: "Yulin", country: "China", timezone: "Asia/Chongqing" },
  { city: "Bose", country: "China", timezone: "Asia/Chongqing" },
  { city: "Wuzhou", country: "China", timezone: "Asia/Chongqing" },
  { city: "Lupanshui", country: "China", timezone: "Asia/Chongqing" },
  { city: "Quanzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Hefei", country: "China", timezone: "Asia/Shanghai" },
  { city: "Suzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zhanjiang", country: "China", timezone: "Asia/Urumqi" },
  { city: "Shaoguan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xigaze", country: "China", timezone: "Asia/Urumqi" },
  { city: "Shache", country: "China", timezone: "Asia/Kashgar" },
  { city: "Yining", country: "China", timezone: "Asia/Kashgar" },
  { city: "Altay", country: "China", timezone: "Asia/Urumqi" },
  { city: "Shizuishan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Yulin", country: "China", timezone: "Asia/Chongqing" },
  { city: "Ankang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Houma", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yueyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Hengyang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Mianyang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Xichang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Baoshan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Gejiu", country: "China", timezone: "Asia/Chongqing" },
  { city: "Shijianzhuang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Handan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Anshan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Dalian", country: "China", timezone: "Asia/Shanghai" },
  { city: "Qingdao", country: "China", timezone: "Asia/Shanghai" },
  { city: "Linyi", country: "China", timezone: "Asia/Shanghai" },
  { city: "Huaiyin", country: "China", timezone: "Asia/Shanghai" },
  { city: "Wenzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Ningbo", country: "China", timezone: "Asia/Shanghai" },
  { city: "Tongliao", country: "China", timezone: "Asia/Shanghai" },
  { city: "Hohhot", country: "China", timezone: "Asia/Chongqing" },
  { city: "Chifeng", country: "China", timezone: "Asia/Shanghai" },
  { city: "Ulanhot", country: "China", timezone: "Asia/Shanghai" },
  { city: "Hailar", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jiamusi", country: "China", timezone: "Asia/Harbin" },
  { city: "Beian", country: "China", timezone: "Asia/Harbin" },
  { city: "Daqing", country: "China", timezone: "Asia/Harbin" },
  { city: "Jixi", country: "China", timezone: "Asia/Harbin" },
  { city: "Jiayuguan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Xining", country: "China", timezone: "Asia/Chongqing" },
  { city: "Guilin", country: "China", timezone: "Asia/Chongqing" },
  { city: "Huainan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shantou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Lhasa", country: "China", timezone: "Asia/Urumqi" },
  { city: "Hami", country: "China", timezone: "Asia/Urumqi" },
  { city: "Hotan", country: "China", timezone: "Asia/Kashgar" },
  { city: "Kashgar", country: "China", timezone: "Asia/Kashgar" },
  { city: "Yinchuan", country: "China", timezone: "Asia/Chongqing" },
  { city: "Pingxiang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Qiqihar", country: "China", timezone: "Asia/Harbin" },
  { city: "Shenzhen", country: "China", timezone: "Asia/Shanghai" },
  { city: "Zibo", country: "China", timezone: "Asia/Shanghai" },
  { city: "Lanzhou", country: "China", timezone: "Asia/Chongqing" },
  { city: "Nanning", country: "China", timezone: "Asia/Chongqing" },
  { city: "Guiyang", country: "China", timezone: "Asia/Chongqing" },
  { city: "Chongqing", country: "China", timezone: "Asia/Chongqing" },
  { city: "Fuzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Guangzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Dongguan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Xian", country: "China", timezone: "Asia/Chongqing" },
  { city: "Taiyuan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Wuhan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Changsha", country: "China", timezone: "Asia/Shanghai" },
  { city: "Kunming", country: "China", timezone: "Asia/Chongqing" },
  { city: "Zhengzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shenyeng", country: "China", timezone: "Asia/Shanghai" },
  { city: "Jinan", country: "China", timezone: "Asia/Shanghai" },
  { city: "Tianjin", country: "China", timezone: "Asia/Shanghai" },
  { city: "Nanchang", country: "China", timezone: "Asia/Shanghai" },
  { city: "Nanjing", country: "China", timezone: "Asia/Shanghai" },
  { city: "Hangzhou", country: "China", timezone: "Asia/Shanghai" },
  { city: "Changchun", country: "China", timezone: "Asia/Harbin" },
  { city: "Baotou", country: "China", timezone: "Asia/Chongqing" },
  { city: "Harbin", country: "China", timezone: "Asia/Harbin" },
  { city: "Urumqi", country: "China", timezone: "Asia/Urumqi" },
  { city: "Chengdu", country: "China", timezone: "Asia/Chongqing" },
  { city: "Beijing", country: "China", timezone: "Asia/Shanghai" },
  { city: "Shanghai", country: "China", timezone: "Asia/Shanghai" },
  { city: "Yopal", country: "Colombia", timezone: "America/Bogota" },
  { city: "San Andres", country: "Colombia", timezone: "America/Bogota" },
  { city: "Sonson", country: "Colombia", timezone: "America/Bogota" },
  { city: "Sogamoso", country: "Colombia", timezone: "America/Bogota" },
  { city: "Barrancabermeja", country: "Colombia", timezone: "America/Bogota" },
  { city: "Girardot", country: "Colombia", timezone: "America/Bogota" },
  { city: "Campoalegre", country: "Colombia", timezone: "America/Bogota" },
  { city: "Tuquerres", country: "Colombia", timezone: "America/Bogota" },
  { city: "Mocoa", country: "Colombia", timezone: "America/Bogota" },
  { city: "Cartago", country: "Colombia", timezone: "America/Bogota" },
  { city: "Soledad", country: "Colombia", timezone: "America/Bogota" },
  { city: "Sabanalarga", country: "Colombia", timezone: "America/Bogota" },
  { city: "Arjona", country: "Colombia", timezone: "America/Bogota" },
  { city: "Magangue", country: "Colombia", timezone: "America/Bogota" },
  { city: "Valledupar", country: "Colombia", timezone: "America/Bogota" },
  {
    city: "San Jose del Guaviare",
    country: "Colombia",
    timezone: "America/Bogota",
  },
  { city: "Puerto Lopez", country: "Colombia", timezone: "America/Bogota" },
  { city: "Yarumal", country: "Colombia", timezone: "America/Bogota" },
  { city: "Puerto Berrio", country: "Colombia", timezone: "America/Bogota" },
  { city: "Turbo", country: "Colombia", timezone: "America/Bogota" },
  { city: "Tunja", country: "Colombia", timezone: "America/Bogota" },
  { city: "Chiquinquira", country: "Colombia", timezone: "America/Bogota" },
  { city: "Duitama", country: "Colombia", timezone: "America/Bogota" },
  { city: "Ayapel", country: "Colombia", timezone: "America/Bogota" },
  { city: "Lorica", country: "Colombia", timezone: "America/Bogota" },
  { city: "Socorro", country: "Colombia", timezone: "America/Bogota" },
  { city: "Riohacha", country: "Colombia", timezone: "America/Bogota" },
  { city: "Armenia", country: "Colombia", timezone: "America/Bogota" },
  { city: "Pereira", country: "Colombia", timezone: "America/Bogota" },
  { city: "Honda", country: "Colombia", timezone: "America/Bogota" },
  {
    city: "San Vicente del Caguan",
    country: "Colombia",
    timezone: "America/Bogota",
  },
  { city: "Florencia", country: "Colombia", timezone: "America/Bogota" },
  { city: "Guapi", country: "Colombia", timezone: "America/Bogota" },
  { city: "Neiva", country: "Colombia", timezone: "America/Bogota" },
  { city: "Garzon", country: "Colombia", timezone: "America/Bogota" },
  { city: "Ipiales", country: "Colombia", timezone: "America/Bogota" },
  { city: "Buenaventura", country: "Colombia", timezone: "America/Bogota" },
  { city: "Tulua", country: "Colombia", timezone: "America/Bogota" },
  {
    city: "El Carmen de Bolivar",
    country: "Colombia",
    timezone: "America/Bogota",
  },
  { city: "Jurado", country: "Colombia", timezone: "America/Bogota" },
  { city: "Nuqui", country: "Colombia", timezone: "America/Bogota" },
  { city: "Quibdo", country: "Colombia", timezone: "America/Bogota" },
  { city: "El Banco", country: "Colombia", timezone: "America/Bogota" },
  { city: "Cienaga", country: "Colombia", timezone: "America/Bogota" },
  { city: "Sincelejo", country: "Colombia", timezone: "America/Bogota" },
  { city: "Tolu", country: "Colombia", timezone: "America/Bogota" },
  { city: "Arauca", country: "Colombia", timezone: "America/Bogota" },
  { city: "Tame", country: "Colombia", timezone: "America/Bogota" },
  { city: "Pamplona", country: "Colombia", timezone: "America/Bogota" },
  { city: "Ocana", country: "Colombia", timezone: "America/Bogota" },
  { city: "Orocue", country: "Colombia", timezone: "America/Bogota" },
  { city: "Obando", country: "Colombia", timezone: "America/Bogota" },
  { city: "San Martin", country: "Colombia", timezone: "America/Bogota" },
  { city: "Puerto Carreno", country: "Colombia", timezone: "America/Bogota" },
  { city: "Bello", country: "Colombia", timezone: "America/Bogota" },
  { city: "Monteria", country: "Colombia", timezone: "America/Bogota" },
  { city: "Bucaramanga", country: "Colombia", timezone: "America/Bogota" },
  { city: "Ibague", country: "Colombia", timezone: "America/Bogota" },
  { city: "Popayan", country: "Colombia", timezone: "America/Bogota" },
  { city: "Santa Marta", country: "Colombia", timezone: "America/Bogota" },
  { city: "Cucuta", country: "Colombia", timezone: "America/Bogota" },
  { city: "Villavicencio", country: "Colombia", timezone: "America/Bogota" },
  { city: "Tumaco", country: "Colombia", timezone: "America/Bogota" },
  { city: "Manizales", country: "Colombia", timezone: "America/Bogota" },
  { city: "Pasto", country: "Colombia", timezone: "America/Bogota" },
  { city: "Barranquilla", country: "Colombia", timezone: "America/Bogota" },
  { city: "Cartagena", country: "Colombia", timezone: "America/Bogota" },
  { city: "Mitu", country: "Colombia", timezone: "America/Bogota" },
  { city: "Leticia", country: "Colombia", timezone: "America/Bogota" },
  { city: "Medellin", country: "Colombia", timezone: "America/Bogota" },
  { city: "Cali", country: "Colombia", timezone: "America/Bogota" },
  { city: "Bogota", country: "Colombia", timezone: "America/Bogota" },
  { city: "Moroni", country: "Comoros", timezone: "Indian/Comoro" },
  {
    city: "Madingou",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Kinkala",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Ewo",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Impfondo",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Sembe",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Moloundou",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Owando",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Makoua",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Sibiti",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Mossendjo",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Loubomo",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Gamboma",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Djambala",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Ouesso",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Kayes",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Pointe-Noire",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Brazzaville",
    country: "Congo (Brazzaville)",
    timezone: "Africa/Brazzaville",
  },
  {
    city: "Buluko",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Zongo", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Libenge", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Bongandanga",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Kinshasa",
  },
  { city: "Ikela", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Binga", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Basankusu",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Kinshasa",
  },
  { city: "Boende", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Gbadolite",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Kinshasa",
  },
  { city: "Businga", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Bosobolo",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Kinshasa",
  },
  {
    city: "Yangambi",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Aketi", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  {
    city: "Mongbwalu",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Bafwasende",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Bunia", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Wamba", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  {
    city: "Basoko",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Kenge", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Bolobo", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Kahemba", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Bulungu", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Lusanga", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Mangai", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Kasongo-Lunda",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Kinshasa",
  },
  { city: "Mushie", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Dibaya",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Mweka", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Luebo", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Demba", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Ilebo", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Moanda", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Kimpese", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Kasangulu",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Kinshasa",
  },
  {
    city: "Mbanza-Ngungu",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Kinshasa",
  },
  { city: "Tshela", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Mwenga",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kampene",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kalima",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Lubutu",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kabinda",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Lubao", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  {
    city: "Lusambo",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Gandajika",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Lodja", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  {
    city: "Dilolo",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Nyunzu",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kasaji",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Luanza",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Moba", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  {
    city: "Bukama",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kaniama",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kipushi",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kambove",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kongolo",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kabalo",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Beni", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Lisala", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Gemena", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Buta", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Watsa", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Isiro", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Bondo", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Inongo", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Tshikapa",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Boma", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Bukavu",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Uvira", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Kindu", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  {
    city: "Mwene-Ditu",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Likasi",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Manono",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kamina",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Mbandaka",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Kinshasa",
  },
  {
    city: "Kisangani",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Bandundu",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Kinshasa",
  },
  {
    city: "Kananga",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kasongo",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Mbuji-Mayi",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kalemie",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Butembo",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  { city: "Goma", country: "Congo (Kinshasa)", timezone: "Africa/Lubumbashi" },
  { city: "Bumba", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Kikwit", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  { city: "Matadi", country: "Congo (Kinshasa)", timezone: "Africa/Kinshasa" },
  {
    city: "Kolwezi",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Lubumbashi",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Lubumbashi",
  },
  {
    city: "Kinshasa",
    country: "Congo (Kinshasa)",
    timezone: "Africa/Kinshasa",
  },
  { city: "Rarotonga", country: "Cook Islands", timezone: "Pacific/Rarotonga" },
  { city: "Heredia", country: "Costa Rica", timezone: "America/Costa_Rica" },
  { city: "Cartago", country: "Costa Rica", timezone: "America/Costa_Rica" },
  { city: "Golfito", country: "Costa Rica", timezone: "America/Costa_Rica" },
  { city: "Alajuela", country: "Costa Rica", timezone: "America/Costa_Rica" },
  { city: "Canas", country: "Costa Rica", timezone: "America/Costa_Rica" },
  { city: "Sixaola", country: "Costa Rica", timezone: "America/Costa_Rica" },
  { city: "Puntarenas", country: "Costa Rica", timezone: "America/Costa_Rica" },
  {
    city: "Ciudad Cortes",
    country: "Costa Rica",
    timezone: "America/Costa_Rica",
  },
  { city: "Quesada", country: "Costa Rica", timezone: "America/Costa_Rica" },
  { city: "Liberia", country: "Costa Rica", timezone: "America/Costa_Rica" },
  { city: "La Cruz", country: "Costa Rica", timezone: "America/Costa_Rica" },
  {
    city: "Puerto Limon",
    country: "Costa Rica",
    timezone: "America/Costa_Rica",
  },
  { city: "San Jose", country: "Costa Rica", timezone: "America/Costa_Rica" },
  { city: "Sibenik", country: "Croatia", timezone: "Europe/Zagreb" },
  { city: "Karlovac", country: "Croatia", timezone: "Europe/Zagreb" },
  { city: "Rijeka", country: "Croatia", timezone: "Europe/Zagreb" },
  { city: "Slavonski Brod", country: "Croatia", timezone: "Europe/Zagreb" },
  { city: "Dubrovnik", country: "Croatia", timezone: "Europe/Zagreb" },
  { city: "Split", country: "Croatia", timezone: "Europe/Zagreb" },
  { city: "Zadar", country: "Croatia", timezone: "Europe/Zagreb" },
  { city: "Pula", country: "Croatia", timezone: "Europe/Zagreb" },
  { city: "Osijek", country: "Croatia", timezone: "Europe/Zagreb" },
  { city: "Zagreb", country: "Croatia", timezone: "Europe/Zagreb" },
  { city: "Ciego de Avila", country: "Cuba", timezone: "America/Havana" },
  { city: "Palma Soriano", country: "Cuba", timezone: "America/Havana" },
  {
    city: "San Antonio de los Banos",
    country: "Cuba",
    timezone: "America/Havana",
  },
  { city: "Guines", country: "Cuba", timezone: "America/Havana" },
  { city: "Caibarien", country: "Cuba", timezone: "America/Havana" },
  { city: "Placetas", country: "Cuba", timezone: "America/Havana" },
  { city: "Cienfuegos", country: "Cuba", timezone: "America/Havana" },
  { city: "Nueva Gerona", country: "Cuba", timezone: "America/Havana" },
  { city: "Sancti Spiritus", country: "Cuba", timezone: "America/Havana" },
  { city: "Moron", country: "Cuba", timezone: "America/Havana" },
  { city: "Nuevitas", country: "Cuba", timezone: "America/Havana" },
  { city: "Manzanillo", country: "Cuba", timezone: "America/Havana" },
  { city: "Bayamo", country: "Cuba", timezone: "America/Havana" },
  { city: "Banes", country: "Cuba", timezone: "America/Havana" },
  { city: "Las Tunas", country: "Cuba", timezone: "America/Havana" },
  { city: "Artemisa", country: "Cuba", timezone: "America/Havana" },
  { city: "Matanzas", country: "Cuba", timezone: "America/Havana" },
  { city: "Colon", country: "Cuba", timezone: "America/Havana" },
  { city: "Sagua la Grande", country: "Cuba", timezone: "America/Havana" },
  { city: "Pinar del Rio", country: "Cuba", timezone: "America/Havana" },
  { city: "Camaguey", country: "Cuba", timezone: "America/Havana" },
  { city: "Guantanamo", country: "Cuba", timezone: "America/Havana" },
  { city: "Holguin", country: "Cuba", timezone: "America/Havana" },
  { city: "Santa Clara", country: "Cuba", timezone: "America/Havana" },
  { city: "Santiago de Cuba", country: "Cuba", timezone: "America/Havana" },
  { city: "Havana", country: "Cuba", timezone: "America/Havana" },
  { city: "Willemstad", country: "Curacao", timezone: "America/Curacao" },
  { city: "Larnaka", country: "Cyprus", timezone: "Asia/Nicosia" },
  { city: "Paphos", country: "Cyprus", timezone: "Asia/Nicosia" },
  { city: "Lemosos", country: "Cyprus", timezone: "Asia/Nicosia" },
  { city: "Nicosia", country: "Cyprus", timezone: "Asia/Nicosia" },
  {
    city: "Usti Nad Labem",
    country: "Czech Republic",
    timezone: "Europe/Prague",
  },
  {
    city: "Hradec Kralove",
    country: "Czech Republic",
    timezone: "Europe/Prague",
  },
  {
    city: "Ceske Budejovice",
    country: "Czech Republic",
    timezone: "Europe/Prague",
  },
  { city: "Liberec", country: "Czech Republic", timezone: "Europe/Prague" },
  { city: "Olomouc", country: "Czech Republic", timezone: "Europe/Prague" },
  { city: "Pizen", country: "Czech Republic", timezone: "Europe/Prague" },
  { city: "Jihlava", country: "Czech Republic", timezone: "Europe/Prague" },
  { city: "Zlin", country: "Czech Republic", timezone: "Europe/Prague" },
  { city: "Brno", country: "Czech Republic", timezone: "Europe/Prague" },
  { city: "Pardubice", country: "Czech Republic", timezone: "Europe/Prague" },
  { city: "Ostrava", country: "Czech Republic", timezone: "Europe/Prague" },
  { city: "Prague", country: "Czech Republic", timezone: "Europe/Prague" },
  { city: "Vejle", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Hillerod", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Soro", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Viborg", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Roskilde", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Svendborg", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Odense", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Esbjerg", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Frederikshavn", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Aalborg", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Århus", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "København", country: "Denmark", timezone: "Europe/Copenhagen" },
  { city: "Dikhil", country: "Djibouti", timezone: "Africa/Djibouti" },
  { city: "Tadjoura", country: "Djibouti", timezone: "Africa/Djibouti" },
  { city: "Ali Sabih", country: "Djibouti", timezone: "Africa/Djibouti" },
  { city: "Obock", country: "Djibouti", timezone: "Africa/Djibouti" },
  { city: "Djibouti", country: "Djibouti", timezone: "Africa/Djibouti" },
  { city: "Roseau", country: "Dominica", timezone: "America/Dominica" },
  {
    city: "Sabaneta",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Mao",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Cotui",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Puerto Plata",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Dajabon",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Moca",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Salcedo",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Jimani",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Comendador",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Pedernales",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Azua",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Bonao",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Bani",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Hato Mayor",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Monte Plata",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Nagua",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Samana",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "San Cristobal",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "El Seibo",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Higuey",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Neiba",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "La Vega",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "San Francisco de Macoris",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "San Pedro de Macoris",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Monte Cristi",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Barahona",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Bavaro",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "La Romana",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "San Juan",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Santiago",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  {
    city: "Santo Domingo",
    country: "Dominican Republic",
    timezone: "America/Santo_Domingo",
  },
  { city: "Dili", country: "East Timor", timezone: "Asia/Dili" },
  { city: "Puyo", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Tulcan", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Pinas", country: "Ecuador", timezone: "America/Guayaquil" },
  {
    city: "Puerto Villamil",
    country: "Ecuador",
    timezone: "Pacific/Galapagos",
  },
  {
    city: "Puerto Baquerizo Moreno",
    country: "Ecuador",
    timezone: "Pacific/Galapagos",
  },
  { city: "Guaranda", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Azogues", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Salinas", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Alausi", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Sangolqui", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Muisne", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "San Gabriel", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Macara", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Zamora", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Latacunga", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Milagro", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Babahoyo", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Chone", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Jipijapa", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Yaupi", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Macas", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Cayambe", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Ambato", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Tena", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Valdez", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "San Lorenzo", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Esmeraldas", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Ibarra", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Portoviejo", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Machala", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Loja", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Manta", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Riobamba", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Cuenca", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Santa Cruz", country: "Ecuador", timezone: "Pacific/Galapagos" },
  { city: "Quito", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Guayaquil", country: "Ecuador", timezone: "America/Guayaquil" },
  { city: "Shibin el Kom", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Benha", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Zagazig", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Kafr el Sheikh", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Tanta", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Ismailia", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "El Mansura", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Dumyat", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Matruh", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "El Alamein", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "El Daba", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Salum", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Damanhûr", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Samalut", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Mallawi", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Beni Mazar", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Beni Suef", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Rashid", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Qasr Farafra", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "El Qasr", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Isna", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Qena", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Girga", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Sohag", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Berenice", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Bur Safaga", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "El Tur", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "El Arish", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "El Giza", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Siwa", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "El Minya", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Kom Ombo", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "El Kharga", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Hurghada", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Suez", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Bur Said", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "El Faiyum", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Aswan", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Asyut", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Luxor", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Alexandria", country: "Egypt", timezone: "Africa/Cairo" },
  { city: "Cairo", country: "Egypt", timezone: "Africa/Cairo" },
  {
    city: "Ahuachapan",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    city: "Cojutepeque",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    city: "Nueva San Salvador",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    city: "Zacatecoluca",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  { city: "La Union", country: "El Salvador", timezone: "America/El_Salvador" },
  {
    city: "San Francisco Gotera",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    city: "San Vicente",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  { city: "Usulutan", country: "El Salvador", timezone: "America/El_Salvador" },
  {
    city: "Chalatenango",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    city: "Sensuntepeque",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    city: "Sonsonate",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    city: "San Miguel",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    city: "Santa Ana",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    city: "San Salvador",
    country: "El Salvador",
    timezone: "America/El_Salvador",
  },
  {
    city: "Evinayong",
    country: "Equatorial Guinea",
    timezone: "Africa/Malabo",
  },
  { city: "Luba", country: "Equatorial Guinea", timezone: "Africa/Malabo" },
  {
    city: "Calatrava",
    country: "Equatorial Guinea",
    timezone: "Africa/Malabo",
  },
  { city: "Mongomo", country: "Equatorial Guinea", timezone: "Africa/Malabo" },
  { city: "Bata", country: "Equatorial Guinea", timezone: "Africa/Malabo" },
  { city: "Malabo", country: "Equatorial Guinea", timezone: "Africa/Malabo" },
  { city: "Tessenei", country: "Eritrea", timezone: "Africa/Asmara" },
  { city: "Agordat", country: "Eritrea", timezone: "Africa/Asmara" },
  { city: "Massawa", country: "Eritrea", timezone: "Africa/Asmara" },
  { city: "Keren", country: "Eritrea", timezone: "Africa/Asmara" },
  { city: "Mendefera", country: "Eritrea", timezone: "Africa/Asmara" },
  { city: "Assab", country: "Eritrea", timezone: "Africa/Asmara" },
  { city: "Asmara", country: "Eritrea", timezone: "Africa/Asmara" },
  { city: "Haapsalu", country: "Estonia", timezone: "Europe/Tallinn" },
  { city: "Viljandi", country: "Estonia", timezone: "Europe/Tallinn" },
  { city: "Kohtla-Jarve", country: "Estonia", timezone: "Europe/Tallinn" },
  { city: "Narva", country: "Estonia", timezone: "Europe/Tallinn" },
  { city: "Tartu", country: "Estonia", timezone: "Europe/Tallinn" },
  { city: "Parnu", country: "Estonia", timezone: "Europe/Tallinn" },
  { city: "Tallinn", country: "Estonia", timezone: "Europe/Tallinn" },
  { city: "Awasa", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Gore", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Debre Birhan", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Bati", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Adigrat", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Aksum", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Yirga Alem", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Hosaina", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Dila", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Giyon", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  {
    city: "Hagere Hiywet",
    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  { city: "Nekemte", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Asela", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Shashemene", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Dembi Dolo", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Gimbi", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Asosa", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Jijiga", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Debre Markos", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Dese", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Sodo", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Arba Minch", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  { city: "Harar", country: "Ethiopia", timezone: "Africa/Addis_Ababa" },
  {
    city: "Goba",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Jima",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Nazret",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Nagele",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Gode",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Dolo Bay",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Bahir Dar",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Mekele",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Dire Dawa",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Gonder",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Addis Ababa",

    country: "Ethiopia",
    timezone: "Africa/Addis_Ababa",
  },
  {
    city: "Fox Bay",

    country: "Falkland Islands",
    timezone: "Atlantic/Stanley",
  },
  {
    city: "Stanley",

    country: "Falkland Islands",
    timezone: "Atlantic/Stanley",
  },
  {
    city: "Klaksvik",

    country: "Faroe Islands",
    timezone: "Atlantic/Faroe",
  },
  {
    city: "Tórshavn",

    country: "Faroe Islands",
    timezone: "Atlantic/Faroe",
  },
  {
    city: "Palikir",

    country: "Federated States of Micronesia",
    timezone: "Pacific/Pohnpei",
  },
  {
    city: "Nandi",

    country: "Fiji",
    timezone: "Pacific/Fiji",
  },
  {
    city: "Lautoka",

    country: "Fiji",
    timezone: "Pacific/Fiji",
  },
  {
    city: "Labasa",

    country: "Fiji",
    timezone: "Pacific/Fiji",
  },
  {
    city: "Suva",

    country: "Fiji",
    timezone: "Pacific/Fiji",
  },
  {
    city: "Hameenlinna",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Kouvola",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Mikkeli",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Savonlinna",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Pori",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Sodankylä",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Jyväskylä",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Kuopio",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Lappeenranta",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Porvoo",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Kemijarvi",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Kokkola",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Lahti",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Joensuu",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Turku",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Kemi",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Oulu",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Rovaniemi",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Vaasa",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Tampere",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Helsinki",

    country: "Finland",
    timezone: "Europe/Helsinki",
  },
  {
    city: "Annecy",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Roanne",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Roura",

    country: "France",
    timezone: "America/Cayenne",
  },
  {
    city: "Sinnamary",

    country: "France",
    timezone: "America/Cayenne",
  },
  {
    city: "St.-Brieuc",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Poitier",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Angers",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Biarritz",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Aix-en-Provence",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Perpignan",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Tarbes",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Clermont-Ferrand",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Melun",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Arras",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Besancon",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Saint-Georges",

    country: "France",
    timezone: "America/Cayenne",
  },
  {
    city: "Saint-Etienne",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Grenoble",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Fort-de-France",

    country: "France",
    timezone: "America/Martinique",
  },
  {
    city: "Saint-Laurent-du-Maroni",

    country: "France",
    timezone: "America/Cayenne",
  },
  {
    city: "Iracoubo",

    country: "France",
    timezone: "America/Cayenne",
  },
  {
    city: "Cherbourg",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Caen",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Lorient",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Brest",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Le Mans",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Nantes",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Agen",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Ajaccio",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Bastia",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Toulon",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Beziers",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Montpellier",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Nimes",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Vichy",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Nevers",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Auxerre",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Dijon",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Bourges",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Tours",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Orleans",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Dieppe",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Rouen",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Versailles",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Brive",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Troyes",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Reims",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Calais",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Amiens",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Mulhouse",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Nancy",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Metz",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Pointe-a-Pitre",

    country: "France",
    timezone: "America/Guadeloupe",
  },
  {
    city: "Basse-terre",

    country: "France",
    timezone: "America/Guadeloupe",
  },
  {
    city: "St.-Benoit",

    country: "France",
    timezone: "Indian/Reunion",
  },
  {
    city: "Dzaoudzi",

    country: "France",
    timezone: "Indian/Mayotte",
  },
  {
    city: "Rennes",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Nice",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Toulouse",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Limoges",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Lille",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Strasbourg",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Kourou",

    country: "France",
    timezone: "America/Cayenne",
  },
  {
    city: "La Rochelle",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Bordeaux",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Marseille",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Le Havre",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "St.-Denis",

    country: "France",
    timezone: "Indian/Reunion",
  },
  {
    city: "Lyon",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Cayenne",

    country: "France",
    timezone: "America/Cayenne",
  },
  {
    city: "Paris",

    country: "France",
    timezone: "Europe/Paris",
  },
  {
    city: "Papeete",

    country: "French Polynesia",
    timezone: "Pacific/Tahiti",
  },
  {
    city: "Ebebiyin",

    country: "Gabon",
    timezone: "Africa/Malabo",
  },
  {
    city: "Tchibanga",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Mekambo",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Makokou",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Mitzik",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Bitam",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Lambarene",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Bifoum",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Ndende",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Mouila",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Omboue",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Moanda",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Okandja",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Koulamoutou",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Oyem",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Mayumba",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Gamba",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Franceville",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Libreville",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Port-Gentil",

    country: "Gabon",
    timezone: "Africa/Libreville",
  },
  {
    city: "Kutaisi",

    country: "Georgia",
    timezone: "Asia/Tbilisi",
  },
  {
    city: "Tskhinvali",

    country: "Georgia",
    timezone: "Asia/Tbilisi",
  },
  {
    city: "Poti",

    country: "Georgia",
    timezone: "Asia/Tbilisi",
  },
  {
    city: "Rustavi",

    country: "Georgia",
    timezone: "Asia/Tbilisi",
  },
  {
    city: "Batumi",

    country: "Georgia",
    timezone: "Asia/Tbilisi",
  },
  {
    city: "Sukhumi",

    country: "Georgia",
    timezone: "Asia/Tbilisi",
  },
  {
    city: "Tbilisi",

    country: "Georgia",
    timezone: "Asia/Tbilisi",
  },
  {
    city: "Mainz",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Schwerin",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Bielefeld",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Dortmund",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Duisburg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Wuppertal",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Essen",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Karlsruhe",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Heidelberg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Kassel",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Oldenburg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Emden",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Braunschweig",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Erfurt",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Coburg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Augsburg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Furth",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Chemnitz",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Bonn",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Münster",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Düsseldorf",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Ulm",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Mannheim",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Freiburg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Giessen",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Wiesbaden",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Bremerhaven",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Osnabrück",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Hannover",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Gottingen",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Gera",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Jena",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Flensburg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Lubeck",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Kiel",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Koblenz",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Saarbrucken",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Regensburg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Rosenheim",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Hof",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Wurzburg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Ingolstadt",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Cottbus",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Potsdam",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Magdeburg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Leipzig",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Stralsund",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Rostock",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Stuttgart",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Bremen",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Nürnberg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Cologne",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Dresden",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Frankfurt",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Hamburg",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Munich",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Berlin",

    country: "Germany",
    timezone: "Europe/Berlin",
  },
  {
    city: "Sunyani",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Tamale",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Yendi",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Bolgatanga",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Bawku",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Wa",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Obuasi",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Berekum",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Winneba",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Cape Coast",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Nkawkaw",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Koforidua",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Tema",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Ho",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Kumasi",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Sekondi",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Accra",

    country: "Ghana",
    timezone: "Africa/Accra",
  },
  {
    city: "Gibraltar",

    country: "Gibraltar",
    timezone: "Europe/Gibraltar",
  },
  {
    city: "Lamia",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Polygyros",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Komatini",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Piraiévs",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Volos",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Hania",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Kavala",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Alexandroupoli",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Kerkira",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Tripoli",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Sparti",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Agrinio",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Pirgos",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Larissa",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Ioanina",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Mitilini",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Hios",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Chalkida",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Sitia",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Katerini",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Seres",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Xanthi",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Ermoupoli",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Kos",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Rodos",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Patra",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Kalamata",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Iraklio",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Thessaloniki",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Athens",

    country: "Greece",
    timezone: "Europe/Athens",
  },
  {
    city: "Qasigiannguit",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Kullorsuaq",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Tasiusaq",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Kulusuk",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Paamiut",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Ittoqqortoormiit",

    country: "Greenland",
    timezone: "America/Danmarkshavn",
  },
  {
    city: "Timmiarmiut",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Qaqortoq",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Kangerlussuaq",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Nord",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Qeqertasuaq",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Nuussuaq",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Ilulissat",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Tasiilaq",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Savissivik",

    country: "Greenland",
    timezone: "America/Thule",
  },
  {
    city: "Kangersuatsiaq",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Uummannaq",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Narsarsuaq",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Sisimiut",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Upernavik",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Qaanaaq",

    country: "Greenland",
    timezone: "America/Thule",
  },
  {
    city: "Nuuk",

    country: "Greenland",
    timezone: "America/Godthab",
  },
  {
    city: "Saint George's",

    country: "Grenada",
    timezone: "America/Grenada",
  },
  {
    city: "Agana",

    country: "Guam",
    timezone: "Pacific/Guam",
  },
  {
    city: "Salama",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Retalhuleu",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "San Marcos",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Chimaltenango",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Antigua Guatemala",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Solola",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Totonicapan",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "El Progreso",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Cuilapa",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Chiquimula",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Jalapa",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Zacapa",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Santa Cruz Del Quiche",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "San Luis",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Coban",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Livingston",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Jutiapa",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Huehuetenango",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Flores",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "La Libertad",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "San Jose",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Escuintla",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Mazatenango",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Puerto Barrios",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Quetzaltenango",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Guatemala",

    country: "Guatemala",
    timezone: "America/Guatemala",
  },
  {
    city: "Mali",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Tongue",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Kouroussa",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Pita",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Dalaba",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Boffa",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Koundara",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Gaoual",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Telimele",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Forecariah",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Beyla",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Gueckedou",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Dinguiraye",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Dabola",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Kerouane",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Siguiri",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Mamou",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Kamsar",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Fria",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Macenta",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Yomou",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Faranah",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Kissidougou",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Labe",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Boke",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Kindia",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Kankan",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Nzerekore",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Conakry",

    country: "Guinea",
    timezone: "Africa/Conakry",
  },
  {
    city: "Cacheu",

    country: "Guinea Bissau",
    timezone: "Africa/Bissau",
  },
  {
    city: "Farim",

    country: "Guinea Bissau",
    timezone: "Africa/Bissau",
  },
  {
    city: "Fulacunda",

    country: "Guinea Bissau",
    timezone: "Africa/Bissau",
  },
  {
    city: "Gabu",

    country: "Guinea Bissau",
    timezone: "Africa/Bissau",
  },
  {
    city: "Catio",

    country: "Guinea Bissau",
    timezone: "Africa/Bissau",
  },
  {
    city: "Bolama",

    country: "Guinea Bissau",
    timezone: "Africa/Bissau",
  },
  {
    city: "Bafata",

    country: "Guinea Bissau",
    timezone: "Africa/Bissau",
  },
  {
    city: "Bissau",

    country: "Guinea Bissau",
    timezone: "Africa/Bissau",
  },
  {
    city: "Corriverton",

    country: "Guyana",
    timezone: "America/Guyana",
  },
  {
    city: "Ituni",

    country: "Guyana",
    timezone: "America/Guyana",
  },
  {
    city: "Lethem",

    country: "Guyana",
    timezone: "America/Guyana",
  },
  {
    city: "Kumaka",

    country: "Guyana",
    timezone: "America/Guyana",
  },
  {
    city: "Bartica",

    country: "Guyana",
    timezone: "America/Guyana",
  },
  {
    city: "Anna Regina",

    country: "Guyana",
    timezone: "America/Guyana",
  },
  {
    city: "Linden",

    country: "Guyana",
    timezone: "America/Guyana",
  },
  {
    city: "Mabaruma",

    country: "Guyana",
    timezone: "America/Guyana",
  },
  {
    city: "New Amsterdam",

    country: "Guyana",
    timezone: "America/Guyana",
  },
  {
    city: "Georgetown",

    country: "Guyana",
    timezone: "America/Guyana",
  },
  {
    city: "Jeremie",

    country: "Haiti",
    timezone: "America/Port-au-Prince",
  },
  {
    city: "Port-De-Paix",

    country: "Haiti",
    timezone: "America/Port-au-Prince",
  },
  {
    city: "Hinche",

    country: "Haiti",
    timezone: "America/Port-au-Prince",
  },
  {
    city: "Fort-Liberte",

    country: "Haiti",
    timezone: "America/Port-au-Prince",
  },
  {
    city: "Jacmel",

    country: "Haiti",
    timezone: "America/Port-au-Prince",
  },
  {
    city: "Les Cayes",

    country: "Haiti",
    timezone: "America/Port-au-Prince",
  },
  {
    city: "Gonaives",

    country: "Haiti",
    timezone: "America/Port-au-Prince",
  },
  {
    city: "Cap-Haitien",

    country: "Haiti",
    timezone: "America/Port-au-Prince",
  },
  {
    city: "Port-au-Prince",

    country: "Haiti",
    timezone: "America/Port-au-Prince",
  },
  {
    city: "Yoro",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "La Esperanza",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "La Paz",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Santa Barbara",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Gracias",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Nueva Ocotepeque",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Yuscaran",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Roatan",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Nacaome",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Santa Rosa de Copan",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Trujillo",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Brus Laguna",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Puerto Lempira",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Juticalpa",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Comayagua",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Choluteca",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "La Ceiba",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "San Pedro Sula",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Tegucigalpa",

    country: "Honduras",
    timezone: "America/Tegucigalpa",
  },
  {
    city: "Hong Kong",

    country: "Hong Kong S.A.R.",
    timezone: "Asia/Hong_Kong",
  },
  {
    city: "Veszprem",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Zalaegerszeg",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Tatabanya",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Szekszard",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Salgotarjan",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Bekescsaba",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Eger",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Szombathely",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Kecskemet",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Szekesfehervar",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Nyiregyhaza",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Pecs",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Gyor",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Kaposvar",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Vac",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Miskolc",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Szeged",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Debrecen",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Szolnok",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Budapest",

    country: "Hungary",
    timezone: "Europe/Budapest",
  },
  {
    city: "Borgarnes",

    country: "Iceland",
    timezone: "Atlantic/Reykjavik",
  },
  {
    city: "Egilsstaðir",

    country: "Iceland",
    timezone: "Atlantic/Reykjavik",
  },
  {
    city: "Sauðárkrókur",

    country: "Iceland",
    timezone: "Atlantic/Reykjavik",
  },
  {
    city: "Selfoss",

    country: "Iceland",
    timezone: "Atlantic/Reykjavik",
  },
  {
    city: "Hofn",

    country: "Iceland",
    timezone: "Atlantic/Reykjavik",
  },
  {
    city: "Ísafjörður",

    country: "Iceland",
    timezone: "Atlantic/Reykjavik",
  },
  {
    city: "Akureyi",

    country: "Iceland",
    timezone: "Atlantic/Reykjavik",
  },
  {
    city: "Keflavík",

    country: "Iceland",
    timezone: "Atlantic/Reykjavik",
  },
  {
    city: "Reykjavík",

    country: "Iceland",
    timezone: "Atlantic/Reykjavik",
  },
  {
    city: "Panaji",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Simla",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Gurgaon",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Sonipat",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Rohtak",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Hisar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhiwani",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Ambala",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Sopore",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Silvassa",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kalyan",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhusawal",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Jorhat",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Hoshiarpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Ajmer",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Hathras",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Sitapur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Pilibhit",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Budaun",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Firozabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Mathura",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bulandshahr",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Hapur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Muzaffarnagar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Gangtok",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Diu",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Pathankot",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Sirsa",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Panipat",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Karnal",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Baramula",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Proddatur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Nandyal",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Hindupur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Tirupati",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Ongole",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Vizianagaram",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Rajahmundry",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Machilipatnam",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Khammam",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Chirala",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Karimnagar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Nizamabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kollam",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Alappuzha",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Puri",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Sambalpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Raurkela",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kavaratti",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Mandya",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kolar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Shimoga",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Raichur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Hospet",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bidar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Sangli",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Parbhani",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Malegaon",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Port Blair",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Tezpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Silchar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kohima",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Shillong",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Abohar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Patiala",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhilwara",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Pali",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Tonk",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Sikar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bikaner",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bharatpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Alwar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Fatehpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Faizabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bahraich",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Mirzapur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Jhansi",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Shahjahanpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Rampur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bareilly",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Etawah",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Dehra Dun",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Haora",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Alipur Duar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Haldia",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhatpara",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Medinipur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Siliguri",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Purnia",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Muzaffarpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Aurangabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bilaspur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Burhanpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Ujjain",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Ratlam",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Sagar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Vellore",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Tiruvannamalai",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Rajapalaiyam",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Cuddalore",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Karur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kanchipuram",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Tirunelveli",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Nagercoil",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Thanjavur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kumbakonam",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Valparai",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Tiruppur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Daman",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Navsari",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhuj",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhavnagar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Gandhinagar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Itanagar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Aizawl",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Agartala",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kakinada",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Warangal",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Brahmapur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bijapur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhiwandi",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Latur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Ahmednagar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Chandrapur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Amravati",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Dhule",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Dibrugarh",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Imphal",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Udaipur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Gorakhpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Barddhaman",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Krishnanagar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Gaya",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Porbandar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Nellore",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kurnool",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Guntur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Tumkur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Davangere",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bellary",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Belgaum",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Tuticorin",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Dindigul",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Chandigarh",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Jammu",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Sholapur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Aurangabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Nasik",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Dispur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Jullundur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Allahabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Moradabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Ghaziabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Agra",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Aligarh",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Meerut",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Dhanbad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Gwalior",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Vadodara",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Rajkot",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Faridabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Srinagar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Vijayawada",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Thiruvananthapuram",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kochi",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Cuttack",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Hubli",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Mangalore",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Mysore",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Gulbarga",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kolhapur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Nanded",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Akola",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Guwahati",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Ludhiana",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kota",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Jodhpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Lucknow",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Saharanpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Ranchi",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhagalpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Raipur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Jabalpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Indore",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Pondicherry",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Salem",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Tiruchirappalli",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kozhikode",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhubaneshwar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Jamshedpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Vishakhapatnam",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Amritsar",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Varanasi",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Asansol",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhilai",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bhopal",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Madurai",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Coimbatore",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Delhi",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Hyderabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Pune",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Nagpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Jaipur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kanpur",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Patna",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Chennai",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Ahmedabad",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Surat",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "New Delhi",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Bangalore",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Mumbai",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Kolkata",

    country: "India",
    timezone: "Asia/Kolkata",
  },
  {
    city: "Binjai",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Padangsidempuan",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Tarutung",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Tebingtinggi",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Tidore",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Bukittinggi",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Sawahlunto",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Padangpanjang",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Amahai",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Mataram",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Praya",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Baubau",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Luwuk",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Poso",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Biak",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Timika",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Langsa",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Indramayu",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Sukabumi",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Cilacap",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Pati",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Pakalongan",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Tegal",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Salatiga",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Magelang",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Serang",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Bekasi",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Singkawang",

    country: "Indonesia",
    timezone: "Asia/Pontianak",
  },
  {
    city: "Bandar Lampung",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Perabumulih",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Kuta",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Singaraja",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Sumenep",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Banyuwangi",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Tuban",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Probolinggo",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Pasuruan",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Mojokerto",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Madiun",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Kediri",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Blitar",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Waingapu",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Maumere",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Ende",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Makale",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Palopo",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Watampone",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Pinrang",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Majene",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Tanjungpinang",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Telukbutun",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Sungaipenuh",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Sampit",

    country: "Indonesia",
    timezone: "Asia/Pontianak",
  },
  {
    city: "Kualakapuas",

    country: "Indonesia",
    timezone: "Asia/Pontianak",
  },
  {
    city: "Palangkaraya",

    country: "Indonesia",
    timezone: "Asia/Pontianak",
  },
  {
    city: "Bontang",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Denpasar",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Sorong",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Sibolga",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Pematangsiantar",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Pekanbaru",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Manado",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Yogyakarta",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Kendari",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Palu",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Nabire",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Merauke",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Lhokseumawe",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Samarinda",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Cirebon",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Tasikmalaya",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Bogor",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Bengkulu",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Pontianak",

    country: "Indonesia",
    timezone: "Asia/Pontianak",
  },
  {
    city: "Kotabumi",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Lahat",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Pangkalpinang",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Jember",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Martapura",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Ruteng",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Jambi",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Manokwari",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Ternate",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Ambon",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Raba",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Jayapura",

    country: "Indonesia",
    timezone: "Asia/Jayapura",
  },
  {
    city: "Banda Aceh",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Balikpapan",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Surakarta",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Bandar Lampung",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Tanjungpandan",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Malang",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Kupang",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Parepare",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Gorontalo",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Padang",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Tarakan",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Semarang",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Palembang",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Bandjarmasin",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Ujungpandang",

    country: "Indonesia",
    timezone: "Asia/Makassar",
  },
  {
    city: "Medan",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Bandung",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Surabaya",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Jakarta",

    country: "Indonesia",
    timezone: "Asia/Jakarta",
  },
  {
    city: "Yasuj",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Shar e Kord",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Marv Dasht",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Shahrud",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Varamin",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Masjed Soleyman",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Borujerd",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Malayer",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Zanjan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Urmia",

    country: "Iran",
    timezone: null,
  },
  {
    city: "Ahar",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Sanandaj",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Neyshabur",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Bojnurd",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Sirjan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Qomsheh",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Kashan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Khomeini Shahr",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Fasa",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Gonbad-e Kavus",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Gorgan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Amol",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Sari",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Semnan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Karaj",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Behbehan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Dezful",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Khorramabad",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Ilam",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Saveh",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Arak",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Mahabad",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Khvoy",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Maragheh",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Qasr-e Shirin",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Bijar",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Yazdan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Torbat-e Jam",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Quchan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Chabahar",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Kashmar",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Bam",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Kerman",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Bandar-e Bushehr",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Abadan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Ardabil",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Qom",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Qazvin",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Kermanshah",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Rasht",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Birjand",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Sabzewar",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Zabol",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Zahedan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Yazd",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Ahvaz",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Bandar-e-Abbas",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Hamadan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Tabriz",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Isfahan",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Shiraz",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Mashhad",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Tehran",

    country: "Iran",
    timezone: "Asia/Tehran",
  },
  {
    city: "Dahuk",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Samarra",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Az Aubayr",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Ad Diwaniyah",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Ash Shatrah",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Mandali",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Ar Ramadi",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Al Musayyib",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Zakho",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Tall Afar",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Tikrit",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Karbala",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "As Samawah",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "An Nasiriyah",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Al Amarah",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Al Kut",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "As Sulaymaniyah",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Baqubah",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Ar Rutbah",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Al Fallujah",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Al Hillah",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Irbil",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Kirkuk",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Mosul",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "An Najaf",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Basra",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Baghdad",

    country: "Iraq",
    timezone: "Asia/Baghdad",
  },
  {
    city: "Ros Comain",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Muineachan",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Shannon",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Waterford",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Tralee",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Donegal",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Drogheda",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Dundalk",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Galway",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Kilkenny",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Killarney",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Sligo",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Cork",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Limerick",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Dublin",

    country: "Ireland",
    timezone: "Europe/Dublin",
  },
  {
    city: "Douglas",

    country: "Isle of Man",
    timezone: "Europe/Isle_of_Man",
  },
  {
    city: "Ramla",

    country: "Israel",
    timezone: "Asia/Jerusalem",
  },
  {
    city: "Beer Sheva",

    country: "Israel",
    timezone: "Asia/Jerusalem",
  },
  {
    city: "Haifa",

    country: "Israel",
    timezone: "Asia/Jerusalem",
  },
  {
    city: "Nazareth",

    country: "Israel",
    timezone: "Asia/Jerusalem",
  },
  {
    city: "Jerusalem",

    country: "Israel",
    timezone: "Asia/Jerusalem",
  },
  {
    city: "Tel Aviv-Yafo",

    country: "Israel",
    timezone: "Asia/Jerusalem",
  },
  {
    city: "Potenza",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Campobasso",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Aosta",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Modena",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Crotone",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Vibo Valentia",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Reggio di Calabria",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Caserta",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Barletta",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Ragusa",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Asti",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Novara",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Como",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Udine",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Treviso",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Parma",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Ravenna",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Ferrara",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Bologna",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Olbia",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Cagliari",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Pisa",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Livorno",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Siena",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Arezzo",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Catanzaro",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Salerno",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Benevento",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Bari",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Foggia",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Lecce",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Brindisi",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Taranto",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Messina",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Marsala",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Siracusa",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Pescara",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "L'Aquila",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Civitavecchia",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Ancona",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Perugia",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Bergamo",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Trieste",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Bolzano",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Trento",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Verona",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Sassari",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Turin",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Genoa",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Florence",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Catania",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Venice",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Palermo",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Naples",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Milan",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Rome",

    country: "Italy",
    timezone: "Europe/Rome",
  },
  {
    city: "Touba",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Bouafle",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Divo",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Toumodi",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Aboisso",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Ferkessedougou",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Odienne",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Man",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Seguela",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Gagnoa",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Soubre",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "San-Pedro",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Sassandra",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Bondoukou",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Agboville",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Dimbokro",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Grand Bassam",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Dabou",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Guiglo",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Abengourou",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Korhogo",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Daloa",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Bouake",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Yamoussoukro",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Abidjan",

    country: "Ivory Coast",
    timezone: "Africa/Abidjan",
  },
  {
    city: "Lucea",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Mandeville",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Black River",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Falmouth",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Savanna-la-Mar",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Port Antonio",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "St. Ann's Bay",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Port Maria",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Half Way Tree",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Port Morant",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "May Pen",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Spanish Town",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Montego Bay",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Kingston",

    country: "Jamaica",
    timezone: "America/Jamaica",
  },
  {
    city: "Okayama",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Shimonoseki",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kanoya",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Takamatsu",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Tokushima",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Toyama",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Takaoka",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Otsu",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Maebashi",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kawasaki",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kawagoe",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Utsunomiya",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Hachioji",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Koriyama",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kure",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Matsue",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Tottori",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Sasebo",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kitakyushu",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kumamoto",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Oita",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Gifu",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Tsu",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Matsumoto",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Shizuoka",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Hamamatsu",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Obihiro",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Tomakomai",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kitami",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Otaru",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Fukui",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Maizuru",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Wakayama",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Mito",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kofu",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Iwaki",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Nagaoka",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Yamagata",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Tsuruoka",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kagoshima",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Matsuyama",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kanazawa",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Muroran",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Asahikawa",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kobe",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Yokohama",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Akita",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Aomori",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Hirosaki",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Hachinohe",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Fukushima",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Morioka",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Niigata",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Fukuoka",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Miyazaki",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Naha",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kochi",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Nagoya",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Nagano",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kushiro",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Hakodate",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Kyoto",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Sendai",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Sakata",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Nagasaki",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Hiroshima",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Sapporo",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Osaka",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Tokyo",

    country: "Japan",
    timezone: "Asia/Tokyo",
  },
  {
    city: "Al Mafraq",

    country: "Jordan",
    timezone: "Asia/Amman",
  },
  {
    city: "At Tafilah",

    country: "Jordan",
    timezone: "Asia/Amman",
  },
  {
    city: "Ma'an",

    country: "Jordan",
    timezone: "Asia/Amman",
  },
  {
    city: "Irbid",

    country: "Jordan",
    timezone: "Asia/Amman",
  },
  {
    city: "As Salt",

    country: "Jordan",
    timezone: "Asia/Amman",
  },
  {
    city: "Az Zarqa",

    country: "Jordan",
    timezone: "Asia/Amman",
  },
  {
    city: "Al Aqabah",

    country: "Jordan",
    timezone: "Asia/Amman",
  },
  {
    city: "Al Karak",

    country: "Jordan",
    timezone: "Asia/Amman",
  },
  {
    city: "Amman",

    country: "Jordan",
    timezone: "Asia/Amman",
  },
  {
    city: "Turgay",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Mangyshlak",

    country: "Kazakhstan",
    timezone: "Asia/Aqtau",
  },
  {
    city: "Maqat",

    country: "Kazakhstan",
    timezone: "Asia/Atyrau",
  },
  {
    city: "Bestobe",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Osakarovka",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Aqadyr",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Sharbaqty",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Shemonaikha",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Serebryansk",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Boralday",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Zharkent",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Esik",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Lenger",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Kentau",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Zhosaly",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Oktyabrsk",

    country: "Kazakhstan",
    timezone: "Asia/Aqtobe",
  },
  {
    city: "Algha",

    country: "Kazakhstan",
    timezone: "Asia/Aqtobe",
  },
  {
    city: "Bayghanin",

    country: "Kazakhstan",
    timezone: "Asia/Aqtobe",
  },
  {
    city: "Embi",

    country: "Kazakhstan",
    timezone: "Asia/Aqtobe",
  },
  {
    city: "Zhetiqara",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Komsomolets",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Tobol",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Qusmuryn",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Shieli",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Makhambet",

    country: "Kazakhstan",
    timezone: "Asia/Atyrau",
  },
  {
    city: "Chapaev",

    country: "Kazakhstan",
    timezone: "Asia/Oral",
  },
  {
    city: "Zhanibek",

    country: "Kazakhstan",
    timezone: "Asia/Oral",
  },
  {
    city: "Aqsay",

    country: "Kazakhstan",
    timezone: "Asia/Oral",
  },
  {
    city: "Esil",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Derzhavinsk",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Zhaltyr",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Makinsk",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Aqsu",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Zholymbet",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Erymentau",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Saryshaghan",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Qarazhal",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Atasu",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Kishkenekol",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Tayynsha",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Bulaevo",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Ertis",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Kachiry",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Zaysan",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Zyryanovsk",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Ridder",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Shar",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Urzhar",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Sarqan",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Ushtobe",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Shonzhy",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Qapshaghay",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Otar",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Fort Shevchenko",

    country: "Kazakhstan",
    timezone: "Asia/Aqtau",
  },
  {
    city: "Zhangaozen",

    country: "Kazakhstan",
    timezone: "Asia/Aqtau",
  },
  {
    city: "Arys",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Burylbaytal",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Shu",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Qulan",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Oytal",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Qaratau",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Khromtau",

    country: "Kazakhstan",
    timezone: "Asia/Aqtobe",
  },
  {
    city: "Arqalyq",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Oostanay",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Baykonur",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Balyqshy",

    country: "Kazakhstan",
    timezone: "Asia/Atyrau",
  },
  {
    city: "Atbasar",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Kokshetau",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Temirtau",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Zhezqazghan",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Qarqaraly",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Balqash",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Petropavlovsk",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Ayakoz",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Taldyqorghan",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Turkistan",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Shalqar",

    country: "Kazakhstan",
    timezone: "Asia/Aqtobe",
  },
  {
    city: "Qazaly",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Aral",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Qulsary",

    country: "Kazakhstan",
    timezone: "Asia/Atyrau",
  },
  {
    city: "Oral",

    country: "Kazakhstan",
    timezone: "Asia/Oral",
  },
  {
    city: "Beyneu",

    country: "Kazakhstan",
    timezone: "Asia/Aqtau",
  },
  {
    city: "Aktau",

    country: "Kazakhstan",
    timezone: "Asia/Aqtau",
  },
  {
    city: "Aktobe",

    country: "Kazakhstan",
    timezone: "Asia/Aqtobe",
  },
  {
    city: "Rudny",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Qyzylorda",

    country: "Kazakhstan",
    timezone: "Asia/Qyzylorda",
  },
  {
    city: "Atyrau",

    country: "Kazakhstan",
    timezone: "Asia/Atyrau",
  },
  {
    city: "Ekibastuz",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Pavlodar",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Semey",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Oskemen",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Shymkent",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Taraz",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Astana",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Qaraghandy",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Almaty",

    country: "Kazakhstan",
    timezone: "Asia/Almaty",
  },
  {
    city: "Nyeri",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Mwingi",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Embu",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Machakos",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Nanyuki",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Maralal",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Konza",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Lodwar",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Eldama Ravine",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Sotik",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Namanga",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Naivasha",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Kericho",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Kitale",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Bungoma",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Kakamega",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Wajir",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Garissa",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Witu",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Tsavo",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Voi",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Kilifi",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Thika",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Kendu Bay",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Karungu",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Kisii",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Marsabit",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Moyale",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Nakuru",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Lamu",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Malindi",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Kisumu",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Meru",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Eldoret",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Mombasa",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Nairobi",

    country: "Kenya",
    timezone: "Africa/Nairobi",
  },
  {
    city: "Tarawa",

    country: "Kiribati",
    timezone: "Pacific/Tarawa",
  },
  {
    city: "Prizren",

    country: "Kosovo",
    timezone: "Europe/Belgrade",
  },
  {
    city: "Pec",

    country: "Kosovo",
    timezone: "Europe/Belgrade",
  },
  {
    city: "Pristina",

    country: "Kosovo",
    timezone: "Europe/Belgrade",
  },
  {
    city: "Hawalli",

    country: "Kuwait",
    timezone: "Asia/Kuwait",
  },
  {
    city: "Al Ahmadi",

    country: "Kuwait",
    timezone: "Asia/Kuwait",
  },
  {
    city: "Al Jahra",

    country: "Kuwait",
    timezone: "Asia/Kuwait",
  },
  {
    city: "Kuwait",

    country: "Kuwait",
    timezone: "Asia/Kuwait",
  },
  {
    city: "Tokmak",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Kara Balta",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Cholpon Ata",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Naryn",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Kok Yangak",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Balykchy",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "At Bashy",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Jalal Abad",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Toktogul",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Tash Komur",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Talas",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Osh",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Karakol",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Bishkek",

    country: "Kyrgyzstan",
    timezone: "Asia/Bishkek",
  },
  {
    city: "Ban Houayxay",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Louang Namtha",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Champasak",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Saravan",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Xam Nua",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Phongsali",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Attapu",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Xaignabouri",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Pakxe",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Xiangkhoang",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Louangphrabang",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Thakhek",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Savannakhet",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Vientiane",

    country: "Laos",
    timezone: "Asia/Vientiane",
  },
  {
    city: "Rezekne",

    country: "Latvia",
    timezone: "Europe/Riga",
  },
  {
    city: "Ventspils",

    country: "Latvia",
    timezone: "Europe/Riga",
  },
  {
    city: "Jelgava",

    country: "Latvia",
    timezone: "Europe/Riga",
  },
  {
    city: "Liepaga",

    country: "Latvia",
    timezone: "Europe/Riga",
  },
  {
    city: "Daugavpils",

    country: "Latvia",
    timezone: "Europe/Riga",
  },
  {
    city: "Riga",

    country: "Latvia",
    timezone: "Europe/Riga",
  },
  {
    city: "B'abda",

    country: "Lebanon",
    timezone: "Asia/Beirut",
  },
  {
    city: "Nabatiye et Tahta",

    country: "Lebanon",
    timezone: "Asia/Beirut",
  },
  {
    city: "Saida",

    country: "Lebanon",
    timezone: "Asia/Beirut",
  },
  {
    city: "Zahle",

    country: "Lebanon",
    timezone: "Asia/Beirut",
  },
  {
    city: "Trablous",

    country: "Lebanon",
    timezone: "Asia/Beirut",
  },
  {
    city: "Beirut",

    country: "Lebanon",
    timezone: "Asia/Beirut",
  },
  {
    city: "Teyateyaneng",

    country: "Lesotho",
    timezone: "Africa/Maseru",
  },
  {
    city: "Mohales Hoek",

    country: "Lesotho",
    timezone: "Africa/Maseru",
  },
  {
    city: "Moyeni",

    country: "Lesotho",
    timezone: "Africa/Maseru",
  },
  {
    city: "Hlotse",

    country: "Lesotho",
    timezone: "Africa/Maseru",
  },
  {
    city: "Butha-Buthe",

    country: "Lesotho",
    timezone: "Africa/Maseru",
  },
  {
    city: "Mokhotlong",

    country: "Lesotho",
    timezone: "Africa/Maseru",
  },
  {
    city: "Mafetang",

    country: "Lesotho",
    timezone: "Africa/Maseru",
  },
  {
    city: "Maseru",

    country: "Lesotho",
    timezone: "Africa/Maseru",
  },
  {
    city: "Barclayville",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Voinjama",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Bensonville",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Kakata",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Sanniquellie",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Rivercess",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Harper",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Gbarnga",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Zwedru",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Greenville",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Buchanan",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Robertsport",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Monrovia",

    country: "Liberia",
    timezone: "Africa/Monrovia",
  },
  {
    city: "Dirj",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Nalut",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Zillah",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Al Khums",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Tajarhi",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Umm al Abid",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Az Zawiyah",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Gharyan",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Mizdah",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Bani Walid",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Al Marj",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Al Bayda",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Shahhat",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "El Agheila",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Maradah",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Qaminis",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "As Sidr",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Al Jaghbub",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Ghadamis",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Hun",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Birak",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Ghat",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Marzuq",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Ajdabiya",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Awjilah",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Surt",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Darnah",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Tubruq",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Al Jawf",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Tmassah",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Misratah",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Zuwarah",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Sabha",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Banghazi",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Tripoli",

    country: "Libya",
    timezone: "Africa/Tripoli",
  },
  {
    city: "Vaduz",

    country: "Liechtenstein",
    timezone: "Europe/Vaduz",
  },
  {
    city: "Panevežys",

    country: "Lithuania",
    timezone: "Europe/Vilnius",
  },
  {
    city: "Siauliai",

    country: "Lithuania",
    timezone: "Europe/Vilnius",
  },
  {
    city: "Klaipeda",

    country: "Lithuania",
    timezone: "Europe/Vilnius",
  },
  {
    city: "Kaunas",

    country: "Lithuania",
    timezone: "Europe/Vilnius",
  },
  {
    city: "Vilnius",

    country: "Lithuania",
    timezone: "Europe/Vilnius",
  },
  {
    city: "Diekirch",

    country: "Luxembourg",
    timezone: "Europe/Luxembourg",
  },
  {
    city: "Grevenmacher",

    country: "Luxembourg",
    timezone: "Europe/Luxembourg",
  },
  {
    city: "Luxembourg",

    country: "Luxembourg",
    timezone: "Europe/Luxembourg",
  },
  {
    city: "Macau",

    country: "Macau S.A.R",
    timezone: "Asia/Macau",
  },
  {
    city: "Tetovo",

    country: "Macedonia",
    timezone: "Europe/Skopje",
  },
  {
    city: "Bitola",

    country: "Macedonia",
    timezone: "Europe/Skopje",
  },
  {
    city: "Skopje",

    country: "Macedonia",
    timezone: "Europe/Skopje",
  },
  {
    city: "Sambava",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Ambanja",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Ihosy",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Mandritsara",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Besalampy",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Marovoay",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Antsohihy",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Ambatondrazaka",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Bekiy",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Manja",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Miandrivazo",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Antsirabe",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Antalaha",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Andoany",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Farafangana",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Mananjary",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Maintirano",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Toamasina",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Maroantsetra",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Tolanaro",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Morombe",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Androka",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Morondava",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Antsiranana",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Fianarantsoa",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Mahajanga",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Toliara",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Antananarivo",

    country: "Madagascar",
    timezone: "Indian/Antananarivo",
  },
  {
    city: "Mzimba",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Machinga",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Dedza",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Mchinji",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Ntcheu",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Chiradzulu",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Nsanje",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Mwanza",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Mulanje",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Karonga",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Chitipa",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Nkhata Bay",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Nkhotakota",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Mangochi",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Salima",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Chiromo",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Zomba",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Mzuzu",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Blantyre",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Lilongwe",

    country: "Malawi",
    timezone: "Africa/Blantyre",
  },
  {
    city: "Kangar",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Kuala Lipis",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Shah Alam",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Teluk Intan",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Butterworth",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Sungai Petani",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Alor Setar",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Muar",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Batu Pahat",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Keluang",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Seremban",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Raub",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Chukai",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Kuala Terengganu",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Lahad Datu",

    country: "Malaysia",
    timezone: "Asia/Kuching",
  },
  {
    city: "Bintulu",

    country: "Malaysia",
    timezone: "Asia/Kuching",
  },
  {
    city: "Miri",

    country: "Malaysia",
    timezone: "Asia/Kuching",
  },
  {
    city: "Johor Bahru",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Kelang",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Taiping",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Ipoh",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Kota Baharu",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Malacca",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Kuantan",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Tawau",

    country: "Malaysia",
    timezone: "Asia/Kuching",
  },
  {
    city: "Sandakan",

    country: "Malaysia",
    timezone: "Asia/Kuching",
  },
  {
    city: "Kota Kinabalu",

    country: "Malaysia",
    timezone: "Asia/Kuching",
  },
  {
    city: "Sibu",

    country: "Malaysia",
    timezone: "Asia/Kuching",
  },
  {
    city: "George Town",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Kuching",

    country: "Malaysia",
    timezone: "Asia/Kuching",
  },
  {
    city: "Putrajaya",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Kuala Lumpur",

    country: "Malaysia",
    timezone: "Asia/Kuala_Lumpur",
  },
  {
    city: "Male",

    country: "Maldives",
    timezone: "Indian/Maldives",
  },
  {
    city: "Goundam",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Aguelhok",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Bourem",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Kati",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Banamba",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Kangaba",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Nioro du Sahel",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Bafoulabe",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Satadougou",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Yelimane",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Kita",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Koutiala",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Sikasso",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Bougouni",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Markala",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Sokolo",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "San",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Taoudenni",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Araouane",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Tessalit",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Menaka",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Nara",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Koulikoro",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Mopti",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Gao",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Kayes",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Segou",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Timbuktu",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Bamako",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Djenne",

    country: "Mali",
    timezone: "Africa/Bamako",
  },
  {
    city: "Valletta",

    country: "Malta",
    timezone: "Europe/Malta",
  },
  {
    city: "Majuro",

    country: "Marshall Islands",
    timezone: "Pacific/Majuro",
  },
  {
    city: "Fderik",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Aleg",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Akjoujt",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Zouirat",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Chegga",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Magta Lajar",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Bogue",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Boutilimit",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Selibaby",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Timbedra",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Nema",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Saint-Louis",

    country: "Mauritania",
    timezone: "Africa/Dakar",
  },
  {
    city: "Tidjikdja",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Bir Mogrein",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Rosso",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Kiffa",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Nouadhibou",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Ayoun el Atrous",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Nouakchott",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Atar",

    country: "Mauritania",
    timezone: "Africa/Nouakchott",
  },
  {
    city: "Curepipe",

    country: "Mauritius",
    timezone: "Indian/Mauritius",
  },
  {
    city: "Port Louis",

    country: "Mauritius",
    timezone: "Indian/Mauritius",
  },
  {
    city: "Vicente Guerrero",

    country: "Mexico",
    timezone: "America/Tijuana",
  },
  {
    city: "Loreto",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Ciudad Constitucion",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Allende",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Nueva Rosita",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Hidalgo del Parral",

    country: "Mexico",
    timezone: "America/Chihuahua",
  },
  {
    city: "Ascension",

    country: "Mexico",
    timezone: "America/Ojinaga",
  },
  {
    city: "Gomez Palacio",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Canatlan",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Villa Union",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Altata",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Esperanza",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Magdalena",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Nacozari Viejo",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Villanueva",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Montemorelos",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Sabinas Hidalgo",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Cardenas",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Ciudad Valles",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Rio Verde",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Ciudad Mante",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Reynosa",

    country: "Mexico",
    timezone: "America/Matamoros",
  },
  {
    city: "Ciudad Madero",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Autlan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Ciudad Hidalgo",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Apatzingan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Santiago Ixcuintla",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Juchitan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Miahuatlan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Atlixco",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Acatlan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Paraiso",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Balancan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tlaxcala",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Irapuato",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Celaya",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Chilpancingo",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Iguala",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tecpan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Atoyac",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Nezahualcoyotl",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "San Juan del Rio",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Jaltipan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Orizaba",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Xalapa",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Nautla",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "San Cristobal de Las Casas",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Escuintla",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Motul",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Tekax",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Peto",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Halacho",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "San Quintin",

    country: "Mexico",
    timezone: "America/Tijuana",
  },
  {
    city: "Punta Prieta",

    country: "Mexico",
    timezone: "America/Tijuana",
  },
  {
    city: "San Felipe",

    country: "Mexico",
    timezone: "America/Tijuana",
  },
  {
    city: "Santa Rosalia",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Guerrero Negro",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Piedras Negras",

    country: "Mexico",
    timezone: "America/Matamoros",
  },
  {
    city: "San Pedro de las Colonias",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Sierra Mojada",

    country: "Mexico",
    timezone: "America/Matamoros",
  },
  {
    city: "Parras",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Cuauhtemoc",

    country: "Mexico",
    timezone: "America/Chihuahua",
  },
  {
    city: "Nuevo Casas Grandes",

    country: "Mexico",
    timezone: "America/Chihuahua",
  },
  {
    city: "Ojinaga",

    country: "Mexico",
    timezone: "America/Ojinaga",
  },
  {
    city: "Villa Ahumada",

    country: "Mexico",
    timezone: "America/Chihuahua",
  },
  {
    city: "Santa Barbara",

    country: "Mexico",
    timezone: "America/Chihuahua",
  },
  {
    city: "Ciudad Camargo",

    country: "Mexico",
    timezone: "America/Chihuahua",
  },
  {
    city: "Cuencame",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Papasquiaro",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Escuinapa",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Guamuchil",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Guasave",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "El Fuerte",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Eldorado",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "La Cruz",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Agua Prieta",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Ciudad Obregon",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Navajoa",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Caborca",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Mazatlán",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Cananea",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Huatabampo",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Zacatecas",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Juan Aldama",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Valparaiso",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Fresnillo",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Linares",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Matehuala",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tamuin",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tamazunchale",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tula",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Aldama",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "San Fernando",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Tecoman",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Puerto Vallarta",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "La Barca",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Ciudad Guzman",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Lagos de Moreno",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Morelia",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Lazaro Cardenas",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Zamora",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Coalcoman",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Uruapan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tuxpan",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Tepic",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Compostela",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Tecuala",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Ciudad del Carmen",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Champoton",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Salina Cruz",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Puerto Escondido",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Pochutla",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Mitla",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tlaxiaco",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Huajuapan de Leon",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tehuacan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Teziutlan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Frontera",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tenosique",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Salamanca",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Guanajuato",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Taxco",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Ayutla",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Ciudad Altamirano",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Petatlan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Pachuca",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Toluca",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Zumpango",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Minatitlan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Coatzacoalcos",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Poza Rica de Hidalgo",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Cordoba",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Santiago Tuxtla",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tuxpam",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Panuco",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Pijijiapan",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Isla Mujeres",

    country: "Mexico",
    timezone: "America/Cancun",
  },
  {
    city: "Felipe Carrillo Puerto",

    country: "Mexico",
    timezone: "America/Cancun",
  },
  {
    city: "Tizimin",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Valladolid",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Izamal",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Ticul",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Ensenada",

    country: "Mexico",
    timezone: "America/Tijuana",
  },
  {
    city: "Saltillo",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Ciudad Juárez",

    country: "Mexico",
    timezone: "America/Ojinaga",
  },
  {
    city: "Delicias",

    country: "Mexico",
    timezone: "America/Chihuahua",
  },
  {
    city: "Durango",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Los Mochis",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Ciudad Victoria",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Aguascalientes",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Manzanillo",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tehuantepec",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Villahermosa",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Cuernavaca",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Queretaro",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tapachula",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Chetumal",

    country: "Mexico",
    timezone: "America/Cancun",
  },
  {
    city: "Progreso",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Cabo San Lucas",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Monclova",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Ometepec",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Cozumel",

    country: "Mexico",
    timezone: "America/Cancun",
  },
  {
    city: "Mexicali",

    country: "Mexico",
    timezone: "America/Tijuana",
  },
  {
    city: "La Paz",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Torreon",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Culiacan",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Nogales",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Hermosillo",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "Guaymas",

    country: "Mexico",
    timezone: "America/Hermosillo",
  },
  {
    city: "San Luis Potosi",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Matamoros",

    country: "Mexico",
    timezone: "America/Matamoros",
  },
  {
    city: "Nuevo Laredo",

    country: "Mexico",
    timezone: "America/Matamoros",
  },
  {
    city: "Colima",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Campeche",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Oaxaca",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Leon",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tijuana",

    country: "Mexico",
    timezone: "America/Tijuana",
  },
  {
    city: "Chihuahua",

    country: "Mexico",
    timezone: "America/Chihuahua",
  },
  {
    city: "Mazatlan",

    country: "Mexico",
    timezone: "America/Mazatlan",
  },
  {
    city: "Tampico",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Acapulco",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Veracruz",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Tuxtla Gutierrez",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Cancun",

    country: "Mexico",
    timezone: "America/Cancun",
  },
  {
    city: "Merida",

    country: "Mexico",
    timezone: "America/Merida",
  },
  {
    city: "Guadalajara",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Puebla",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Monterrey",

    country: "Mexico",
    timezone: "America/Monterrey",
  },
  {
    city: "Mexico City",

    country: "Mexico",
    timezone: "America/Mexico_City",
  },
  {
    city: "Dubasari",

    country: "Moldova",
    timezone: "Europe/Chisinau",
  },
  {
    city: "Balti",

    country: "Moldova",
    timezone: "Europe/Chisinau",
  },
  {
    city: "Cahul",

    country: "Moldova",
    timezone: "Europe/Chisinau",
  },
  {
    city: "Tiraspol",

    country: "Moldova",
    timezone: "Europe/Chisinau",
  },
  {
    city: "Chisinau",

    country: "Moldova",
    timezone: "Europe/Chisinau",
  },
  {
    city: "Monaco",

    country: "Monaco",
    timezone: "Europe/Paris",
  },
  {
    city: "Suchboatar",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Dzuunmod",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Tsetserleg",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Olgiy",

    country: "Mongolia",
    timezone: "Asia/Hovd",
  },
  {
    city: "Ulaan-Uul",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Hodrogo",

    country: "Mongolia",
    timezone: "Asia/Hovd",
  },
  {
    city: "Buyant-Uhaa",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Ondorhaan",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Bayankhongor",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Uliastay",

    country: "Mongolia",
    timezone: "Asia/Hovd",
  },
  {
    city: "Altay",

    country: "Mongolia",
    timezone: "Asia/Hovd",
  },
  {
    city: "Moron",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Ulaangom",

    country: "Mongolia",
    timezone: "Asia/Hovd",
  },
  {
    city: "Bulgan",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Mandalgovi",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Darhan",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Dzuunharaa",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Arvayheer",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Baruun Urt",

    country: "Mongolia",
    timezone: "Asia/Choibalsan",
  },
  {
    city: "Dalandzadgad",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Dund-Us",

    country: "Mongolia",
    timezone: "Asia/Hovd",
  },
  {
    city: "Choybalsan",

    country: "Mongolia",
    timezone: "Asia/Choibalsan",
  },
  {
    city: "Erdenet",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Ulaanbaatar",

    country: "Mongolia",
    timezone: "Asia/Ulaanbaatar",
  },
  {
    city: "Podgorica",

    country: "Montenegro",
    timezone: "Europe/Podgorica",
  },
  {
    city: "Ksar El Kebir",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Larache",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Taza",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Ouezzane",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Kenitra",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Settat",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Er Rachidia",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Meknes",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Tiznit",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "El Jadida",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Dawra",

    country: "Morocco",
    timezone: "Africa/El_Aaiun",
  },
  {
    city: "Lemsid",

    country: "Morocco",
    timezone: "Africa/El_Aaiun",
  },
  {
    city: "Tan Tan",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Bir Anzarane",

    country: "Morocco",
    timezone: "Africa/El_Aaiun",
  },
  {
    city: "Tangier",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Agadir",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Goulimine",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Smara",

    country: "Morocco",
    timezone: "Africa/El_Aaiun",
  },
  {
    city: "Ad Dakhla",

    country: "Morocco",
    timezone: "Africa/El_Aaiun",
  },
  {
    city: "Oujda",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Safi",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Laayoune",

    country: "Morocco",
    timezone: "Africa/El_Aaiun",
  },
  {
    city: "Fez",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Rabat",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Marrakesh",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Casablanca",

    country: "Morocco",
    timezone: "Africa/Casablanca",
  },
  {
    city: "Moatize",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Luangwa",

    country: "Mozambique",
    timezone: "Africa/Lusaka",
  },
  {
    city: "Manica",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Espungabera",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Montepuez",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Mocimboa",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Marrupa",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Cuamba",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Ligonha",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Macia",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Massangena",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Mapai",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Dondo",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Chiramba",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Mocuba",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Nicuadala",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Maxixe",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Panda",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Quissico",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Vilanculos",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Matola",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Chimoio",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Lichinga",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Angoche",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Mocambique",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Inhambane",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Tete",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Pemba",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Nampula",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Xai-Xai",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Quelimane",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Nacala",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Beira",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Maputo",

    country: "Mozambique",
    timezone: "Africa/Maputo",
  },
  {
    city: "Loikaw",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Pa-an",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Hakha",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Taunggyi",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Sagaing",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Myingyan",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Letpadan",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Taungoo",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Thongwa",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Mudon",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Ye",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Mawlamyine",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Kyaukphyu",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Wakema",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Labutta",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Phyarpon",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Yandoon",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Hinthada",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Pathein",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Allanmyo",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Yaynangyoung",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Chauk",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Pakokku",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Namtu",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Dawei",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Shwebo",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Bago",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Pyu",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Pyay",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Magway",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Myitkyina",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Monywa",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Myeik",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Mandalay",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Sittwe",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Naypyidaw",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Rangoon",

    country: "Myanmar",
    timezone: "Asia/Rangoon",
  },
  {
    city: "Omaruru",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Karibib",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Otavi",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Gobabis",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Karasburg",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Bethanie",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Oranjemund",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Mariental",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Rehoboth",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Outjo",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Opuwo",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Usakos",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Okahandja",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Otjiwarongo",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Oshikango",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Cuangar",

    country: "Namibia",
    timezone: "Africa/Luanda",
  },
  {
    city: "Katima Mulilo",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Keetmanshoop",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Maltahöhe",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Swakopmund",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Ongwediva",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Rundu",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Tsumeb",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Lüderitz",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Walvis Bay",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Windhoek",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Grootfontein",

    country: "Namibia",
    timezone: "Africa/Windhoek",
  },
  {
    city: "Salyan",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Baglung",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Jumla",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Bhairawa",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Dandeldhura",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Dhangarhi",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Ramechhap",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Bhimphedi",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Rajbiraj",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Ilam",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Lalitpur",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Hetauda",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Nepalganj",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Birganj",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Biratnagar",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Pokhara",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Kathmandu",

    country: "Nepal",
    timezone: "Asia/Kathmandu",
  },
  {
    city: "Assen",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Arnhem",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Maastricht",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Zwolle",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Middelburg",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "'s-Hertogenbosch",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Eindhoven",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Leeuwarden",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Groningen",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Utrecht",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Haarlem",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Rotterdam",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "The Hague",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Amsterdam",

    country: "Netherlands",
    timezone: "Europe/Amsterdam",
  },
  {
    city: "Noumea",

    country: "New Caledonia",
    timezone: "Pacific/Noumea",
  },
  {
    city: "Greymouth",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Upper Hutt",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Masterton",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Levin",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Waitakere",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Takapuna",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Whakatane",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Ashburton",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Kaiapoi",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "New Plymouth",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Westport",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Hokitika",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Oamaru",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Palmerston North",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Wanganui",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Hastings",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Gisborne",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Rotorua",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Taupo",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Tauranga",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Timaru",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Nelson",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Whangarei",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Queenstown",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Invercargill",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Napier",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Manukau",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Hamilton",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Blenheim",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Dunedin",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Wellington",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Christchurch",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Auckland",

    country: "New Zealand",
    timezone: "Pacific/Auckland",
  },
  {
    city: "Somoto",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Ocotal",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "San Carlos",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Jinotepe",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Jinotega",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Masaya",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "San Juan del Sur",

    country: "Nicaragua",
    timezone: null,
  },
  {
    city: "Esteli",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Boaco",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Juigalpa",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Rivas",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "San Juan de Nicaragua",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Granada",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Chinandega",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Matagalpa",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Puerto Cabezas",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Leon",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Bluefields",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Managua",

    country: "Nicaragua",
    timezone: "America/Managua",
  },
  {
    city: "Goure",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Gaya",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Tillaberi",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Ayorou",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Birni Nkonni",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Madaoua",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Diffa",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Nguigmi",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Dosso",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Arlit",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Djado",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Maradi",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Tahoua",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Zinder",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Niamey",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Agadez",

    country: "Niger",
    timezone: "Africa/Niamey",
  },
  {
    city: "Umuahia",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Uyo",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Owerri",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Dutse",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Damaturu",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Iwo",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Iseyin",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Biu",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Bama",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Aba",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Opobo",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Orlu",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Oturkpo",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Calabar",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Wukari",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Jalingo",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Kontagora",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Bida",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Abeokuta",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Ijebu Ode",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Akure",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Ikare",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Owo",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Ondo",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Ado Ekiti",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Ife",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Oshogbo",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Oyo",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Awka",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Onitsha",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Azare",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Bauchi",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Gombe",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Kumo",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Sapele",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Nsukka",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Lokoja",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Idah",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Lafia",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Keffi",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Funtua",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Katsina",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Gusau",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Nguru",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Gashua",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Potiskum",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Birnin Kebbi",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Koko",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Mubi",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Numan",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Ilorin",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Minna",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Zaria",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Jos",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Yola",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Benin City",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Maiduguri",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Port Harcourt",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Makurdi",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Ibadan",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Ogbomosho",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Warri",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Kaduna",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Enugu",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Sokoto",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Abuja",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Kano",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Lagos",

    country: "Nigeria",
    timezone: "Africa/Lagos",
  },
  {
    city: "Sariwon",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Sin-Ni",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Changyon",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Anbyon",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Munchon",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Kaesong",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Chosan",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Manpo",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Sunchon",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Kimhyonggwon",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Pyongsan",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Ongjin",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Haeju",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Kilchu",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Musan",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Sonbong",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Kanggye",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Hungnam",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Taedong",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Chongju",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Hyeson",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Nampo",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Chongjin",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Kimchaek",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Hamhung",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Wonsan",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Sinuiju",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Pyongyang",

    country: "North Korea",
    timezone: "Asia/Pyongyang",
  },
  {
    city: "Kyrenia",

    country: "Northern Cyprus",
    timezone: "Asia/Famagusta",
  },
  {
    city: "Ammochostos",

    country: "Northern Cyprus",
    timezone: "Asia/Famagusta",
  },
  {
    city: "Capitol Hill",

    country: "Northern Mariana Islands",
    timezone: "Pacific/Saipan",
  },
  {
    city: "Arendal",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Vossavangen",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Leikanger",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Bærum",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Hamar",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Tønsberg",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Finnsnes",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Gjøvik",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Rørvik",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Harstad",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Ålesund",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Sandnes",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Drammen",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Moss",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Steinkjer",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Svolvær",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Mo i Rana",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Narvik",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Bodø",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Haugesund",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Stavanger",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Skien",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Namsos",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Alta",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Vadsø",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Molde",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Lillehammer",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Kirkenes",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Kristiansand",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Hammerfest",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Tromsø",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Trondheim",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Bergen",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Oslo",

    country: "Norway",
    timezone: "Europe/Oslo",
  },
  {
    city: "Alayat Samail",

    country: "Oman",
    timezone: "Asia/Muscat",
  },
  {
    city: "Dawwah",

    country: "Oman",
    timezone: "Asia/Muscat",
  },
  {
    city: "Mirbat",

    country: "Oman",
    timezone: "Asia/Muscat",
  },
  {
    city: "Ibri",

    country: "Oman",
    timezone: "Asia/Muscat",
  },
  {
    city: "Salalah",

    country: "Oman",
    timezone: "Asia/Muscat",
  },
  {
    city: "Suhar",

    country: "Oman",
    timezone: "Asia/Muscat",
  },
  {
    city: "As Sib",

    country: "Oman",
    timezone: "Asia/Muscat",
  },
  {
    city: "Nizwa",

    country: "Oman",
    timezone: "Asia/Muscat",
  },
  {
    city: "Sur",

    country: "Oman",
    timezone: "Asia/Muscat",
  },
  {
    city: "Muscat",

    country: "Oman",
    timezone: "Asia/Muscat",
  },
  {
    city: "Parachinar",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Sialkote",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Sheikhu Pura",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Gujrat",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Sahiwal",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Chiniot",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Rahim Yar Khan",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Mansehra",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Kohat",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Abbottabad",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Mardan",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Gwadar",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Zhob",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Gilgit",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Kasur",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Kundian",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Okara",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Jhang",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Sargodha",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Dera Ghazi Khan",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Sadiqabad",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Nawabshah",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Bannu",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Dera Ismail Khan",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Chaman",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Turbat",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Faisalabad",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Rawalpindi",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Bahawalpur",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Mirput Khas",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Sukkur",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Saidu",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Gujranwala",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Quetta",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Larkana",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Islamabad",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Multan",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Hyderabad",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Peshawar",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Lahore",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Karachi",

    country: "Pakistan",
    timezone: "Asia/Karachi",
  },
  {
    city: "Koror",

    country: "Palau",
    timezone: "Pacific/Palau",
  },
  {
    city: "Melekeok",

    country: "Palau",
    timezone: "Pacific/Palau",
  },
  {
    city: "Ramallah",

    country: "Palestine",
    timezone: "Asia/Hebron",
  },
  {
    city: "Al Khalil",

    country: "Palestine",
    timezone: "Asia/Hebron",
  },
  {
    city: "Nablus",

    country: "Palestine",
    timezone: "Asia/Hebron",
  },
  {
    city: "Gaza",

    country: "Palestine",
    timezone: "Asia/Gaza",
  },
  {
    city: "El Porvenir",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Penonome",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Chitre",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Jaque",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Bocas del Toro",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Almirante",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Las Tablas",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Santiago",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "La Palma",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Colon",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Balboa",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Puerto Armuelles",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "David",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Panama City",

    country: "Panama",
    timezone: "America/Panama",
  },
  {
    city: "Wabag",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Vanimo",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Kundiawa",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Kerema",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Arawa",

    country: "Papua New Guinea",
    timezone: "Pacific/Bougainville",
  },
  {
    city: "Lorengau",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Kimbe",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Daru",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Sohano",

    country: "Papua New Guinea",
    timezone: "Pacific/Bougainville",
  },
  {
    city: "Kieta",

    country: "Papua New Guinea",
    timezone: "Pacific/Bougainville",
  },
  {
    city: "Mendi",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Abau",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Alotau",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Popondetta",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Hoskins",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Wewak",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Madang",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Kavieng",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Goroka",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Mt. Hagen",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Rabaul",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Lae",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Port Moresby",

    country: "Papua New Guinea",
    timezone: "Pacific/Port_Moresby",
  },
  {
    city: "Mariscal Estigarribia",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Caacupe",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "General Eugenio Alejandrino Garay",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Arroyos y Esteros",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Villa Hayes",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Fortin Falcon",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Puerto Pinasco",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Pozo Colorado",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "San Pedro",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "San Lorenzo",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Ypacarai",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "San Juan Bautista",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Paraguari",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Nacunday",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Coronel Oviedo",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Caazapa",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Ype Jhu",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Encarnacion",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Coronel Bogado",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Fuerte Olimpo",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Capitan Pablo Lagerenza",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "La Victoria",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Horqueta",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Belen",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Rosario",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Ita",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Pilar",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Pedro Juan Caballero",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Bella Vista",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Abai",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Ygatimi",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Hohenau",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Concepcion",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Villarrica",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Filadelfia",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Ciudad del Este",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Asuncion",

    country: "Paraguay",
    timezone: "America/Asuncion",
  },
  {
    city: "Ferrenafe",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Motupe",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Mollendo",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Urubamba",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Santo Tomas",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Putina",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Casma",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Tournavista",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Huamachuco",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Otuzco",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Lamas",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Nauta",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Puquio",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Chosica",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Satipo",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Tarma",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "La Oroya",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Huaura",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Huacho",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Pimentel",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Olmos",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Sechura",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Chulucanas",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Sullana",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Abancay",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Camana",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Sicuani",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Puno",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Ayaviri",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Ilave",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Desaguadero",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Huarmey",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Cajabamba",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Jaen",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Chota",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Tingo Maria",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Moyobamba",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Juanjui",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Tocache",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Sechura",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Chachapoyas",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Caballococha",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Puca Urco",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Andoas",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Soldado Bartra",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Nuevo Rocafuerte",

    country: "Peru",
    timezone: "America/Guayaquil",
  },
  {
    city: "Requena",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Huanta",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Coracora",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Chincha Alta",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Santiago",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "San Ramon",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Junin",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Jauja",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Pativilca",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Chancay",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Chilca",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Chiclayo",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Juliaca",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Cerro de Pasco",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Tarapoto",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Ayacucho",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Callao",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Paita",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Talara",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Tumbes",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Puerto Maldonado",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Ilo",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Moquegua",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Huaraz",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Cajamarca",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Huanuco",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Pacasmayo",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Salaverry",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Gueppi",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Contamana",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Huancavelica",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Pisco",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Nasca",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Piura",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Arequipa",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Chimbote",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Pucallpa",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Iquitos",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Huancayo",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Cusco",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Tacna",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Trujillo",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Ica",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "Lima",

    country: "Peru",
    timezone: "America/Lima",
  },
  {
    city: "San Carlos",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Cadiz",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Pagadian",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Ozamis",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Tarlac",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Cabanatuan",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Olongapo",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Dagupan",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "San Pablo",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Quezon City",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Pasay City",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Iligan",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Ormac",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Tacloban",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Butuan",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Tagum",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Surigao",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Gingoog",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Legazpi",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Tuguegarao",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Vigan",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Bacolod",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Roxas",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Puerto Princesa",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Naga",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Angeles",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Batangas",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Cotabato",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Calbayog",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Cagayan de Oro",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Zamboanga",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Laoag",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Baguio City",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "General Santos",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Cebu",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Iloilo",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Davao",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Manila",

    country: "Philippines",
    timezone: "Asia/Manila",
  },
  {
    city: "Olsztyn",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Elblag",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Inowroclaw",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Bytom",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Opole",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Koszalin",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Elk",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Gdynia",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Wroclaw",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Szczecin",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Zielona Gora",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Poznan",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Grudziadz",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Bydgoszcz",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Katowice",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Gliwice",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Kielce",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Bialystok",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Lublin",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Rzeszow",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Lódz",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Gdansk",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Kraków",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Warsaw",

    country: "Poland",
    timezone: "Europe/Warsaw",
  },
  {
    city: "Aveiro",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Leiria",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Viana Do Castelo",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Beja",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Evora",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Portalegre",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Santarem",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Braganca",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Castelo Branco",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Guarda",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Viseu",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Vila Real",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Braga",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Covilha",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Horta",

    country: "Portugal",
    timezone: "Atlantic/Azores",
  },
  {
    city: "Angra do Heroismo",

    country: "Portugal",
    timezone: "Atlantic/Azores",
  },
  {
    city: "Portimao",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Faro",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Coimbra",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Setubal",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Porto",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Funchal",

    country: "Portugal",
    timezone: "Atlantic/Madeira",
  },
  {
    city: "Ponta Delgada",

    country: "Portugal",
    timezone: "Atlantic/Azores",
  },
  {
    city: "Lisbon",

    country: "Portugal",
    timezone: "Europe/Lisbon",
  },
  {
    city: "Ponce",

    country: "Puerto Rico",
    timezone: "America/Puerto_Rico",
  },
  {
    city: "Mayaguez",

    country: "Puerto Rico",
    timezone: "America/Puerto_Rico",
  },
  {
    city: "Arecibo",

    country: "Puerto Rico",
    timezone: "America/Puerto_Rico",
  },
  {
    city: "San Juan",

    country: "Puerto Rico",
    timezone: "America/Puerto_Rico",
  },
  {
    city: "Doha",

    country: "Qatar",
    timezone: "Asia/Qatar",
  },
  {
    city: "Targu Jiu",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Slatina",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Alexandria",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Targoviste",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Giurgiu",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Slobozia",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Alba Lulia",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Bistrita",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Deva",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Zalau",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Satu Mare",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Rimnicu Vilcea",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Sfintu-Gheorghe",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Miercurea Cuic",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Piatra-Neamt",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Braila",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Vaslui",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Drobeta-Turnu Severin",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Tulcea",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Arad",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Oradea",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Sibiu",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Suceava",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Buzau",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Galati",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Focsani",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Craiova",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Calarasi",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Resita",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Timisoara",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Botosani",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Baia Mare",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Tirgu Mures",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Pitesti",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Brasov",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Ploiesti",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Bacau",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Cluj-Napoca",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Constanta",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Iasi",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Bucharest",

    country: "Romania",
    timezone: "Europe/Bucharest",
  },
  {
    city: "Nazran",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Ust' Ordynskiy",

    country: "Russia",
    timezone: "Asia/Irkutsk",
  },
  {
    city: "Maykop",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Mozdok",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Georgievsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Pyatigorsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kislovodsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Nevinnomyssk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Enurmino",

    country: "Russia",
    timezone: "Asia/Anadyr",
  },
  {
    city: "Lavrentiya",

    country: "Russia",
    timezone: "Asia/Anadyr",
  },
  {
    city: "Zvezdnyy",

    country: "Russia",
    timezone: "Asia/Anadyr",
  },
  {
    city: "Mikhalkino",

    country: "Russia",
    timezone: "Asia/Srednekolymsk",
  },
  {
    city: "Chernyakhovsk",

    country: "Russia",
    timezone: "Europe/Kaliningrad",
  },
  {
    city: "Severomorsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Apatity",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Polyarnyy",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Slantsy",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kolpino",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Novozybkov",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Dyatkovo",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Shuya",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kineshma",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Balakhna",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Arzamas",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Rzhev",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Vyshnniy Volochek",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Uglich",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Yelets",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Orekhovo-Zuevo",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Klin",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Sergiyev Posad",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kolomna",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Bataysk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Taganrog",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Novocherkassk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kamensk Shakhtinskiy",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Novoshakhtinsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Aleksin",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Novomoskovsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Shchekino",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Nikolayevsk",

    country: "Russia",
    timezone: "Europe/Volgograd",
  },
  {
    city: "Shebekino",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Gubkin",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Apsheronsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kropotkin",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Ruzayevka",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kirsanov",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Michurinsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Borisoglebsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Oktyabrskiy",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Plast",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Bakal",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Verkhniy Ufaley",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Severnyy",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kirovo-Chepetsk",

    country: "Russia",
    timezone: "Europe/Kirov",
  },
  {
    city: "Krasnoturinsk",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Asbest",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Alapayevsk",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Krasnouralsk",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Severouralsk",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Novotroitsk",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Buguruslan",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Chapayevsk",

    country: "Russia",
    timezone: "Europe/Samara",
  },
  {
    city: "Syzran",

    country: "Russia",
    timezone: "Europe/Samara",
  },
  {
    city: "Novokuybishevsk",

    country: "Russia",
    timezone: "Europe/Samara",
  },
  {
    city: "Naberezhnyye Chelny",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Zelenodolsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Leninogorsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Bugulma",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Nefteyugansk",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Leninsk Kuznetsky",

    country: "Russia",
    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Anzhero Sudzhensk",

    country: "Russia",
    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Kiselevsk",

    country: "Russia",
    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Mundybash",

    country: "Russia",
    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Chernogorsk",

    country: "Russia",
    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Abaza",

    country: "Russia",
    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Iskitim",

    country: "Russia",
    timezone: "Asia/Novosibirsk",
  },
  {
    city: "Toguchin",

    country: "Russia",
    timezone: "Asia/Novosibirsk",
  },
  {
    city: "Kupina",

    country: "Russia",
    timezone: "Asia/Novosibirsk",
  },
  {
    city: "Zaozernyy",

    country: "Russia",
    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Bogotol",

    country: "Russia",
    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Shilka",

    country: "Russia",
    timezone: "Asia/Chita",
  },
  {
    city: "Sherlovaya Gora",

    country: "Russia",
    timezone: "Asia/Chita",
  },
  {
    city: "Petrovsk Zabaykalskiy",

    country: "Russia",
    timezone: "Asia/Chita",
  },
  {
    city: "Arsenyev",

    country: "Russia",
    timezone: "Asia/Vladivostok",
  },
  {
    city: "Partizansk",

    country: "Russia",
    timezone: "Asia/Vladivostok",
  },
  {
    city: "Dalnerechensk",

    country: "Russia",
    timezone: "Asia/Vladivostok",
  },
  {
    city: "Zemlya Bunge",

    country: "Russia",
    timezone: "Asia/Vladivostok",
  },
  {
    city: "Khorgo",

    country: "Russia",
    timezone: "Asia/Yakutsk",
  },
  {
    city: "Put Lenina",

    country: "Russia",
    timezone: "Asia/Yakutsk",
  },
  {
    city: "Obluchye",

    country: "Russia",
    timezone: "Asia/Vladivostok",
  },
  {
    city: "Vanino",

    country: "Russia",
    timezone: "Asia/Vladivostok",
  },
  {
    city: "Omchak",

    country: "Russia",
    timezone: "Asia/Magadan",
  },
  {
    city: "Uglegorsk",

    country: "Russia",
    timezone: "Asia/Sakhalin",
  },
  {
    city: "Kholmsk",

    country: "Russia",
    timezone: "Asia/Sakhalin",
  },
  {
    city: "Solikamsk",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Kizel",

    country: "Russia",
    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Pakhachi",

    country: "Russia",
    timezone: "Asia/Kamchatka",
  },
  {
    city: "Oymyakon",

    country: "Russia",
    timezone: null,
  },
  {
    city: "Timiryazevskiy",

    country: "Russia",
    timezone: "Asia/Tomsk",
  },
  {
    city: "Asino",

    country: "Russia",
    timezone: "Asia/Tomsk",
  },
  {
    city: "Strezhevoy",

    country: "Russia",
    timezone: "Asia/Tomsk",
  },
  {
    city: "Cherkessk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Vladikavkaz",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Blagodarnyy",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Zelenokumsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Mukhomornoye",

    country: "Russia",
    timezone: "Asia/Anadyr",
  },
  {
    city: "Beringovskiy",

    country: "Russia",
    timezone: "Asia/Anadyr",
  },
  {
    city: "Bilibino",

    country: "Russia",
    timezone: "Asia/Anadyr",
  },
  {
    city: "Mys Shmidta",

    country: "Russia",
    timezone: "Asia/Anadyr",
  },
  {
    city: "Egvekinot",

    country: "Russia",
    timezone: "Asia/Anadyr",
  },
  {
    city: "Sovetsk",

    country: "Russia",
    timezone: "Europe/Kaliningrad",
  },
  {
    city: "Nikel",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Monchegorsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kirovsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Borovichi",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Staraya Russa",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Volkhov",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Tikhvin",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Svetogorsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Gatchina",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Luga",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Klintsy",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Roslavl",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Safonovo",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Vyazma",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Segezha",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Vichuga",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Sharya",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Buy",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Dzerzhinsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Vyska",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kimry",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Bezhetsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Nelidovo",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Bologoye",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Torzhok",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Sokol",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Cherepovets",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Rybinsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Rostov",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kaluga",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kirov",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Obninsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Lgov",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Zheleznogorsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Gryazi",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Yegoryevsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Podolsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Solnechnogorsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Noginsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Serpukhov",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Livny",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Mtsensk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Salsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Belaya Kalitva",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Shakhty",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Millerovo",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Yefremov",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Bogoroditsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kamyshin",

    country: "Russia",
    timezone: "Europe/Volgograd",
  },
  {
    city: "Pallasovka",

    country: "Russia",
    timezone: "Europe/Volgograd",
  },
  {
    city: "Frolovo",

    country: "Russia",
    timezone: "Europe/Volgograd",
  },
  {
    city: "Volzhskiy",

    country: "Russia",
    timezone: "Europe/Volgograd",
  },
  {
    city: "Mikhaylovka",

    country: "Russia",
    timezone: "Europe/Volgograd",
  },
  {
    city: "Uryupinsk",

    country: "Russia",
    timezone: "Europe/Volgograd",
  },
  {
    city: "Starsy Oskol",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Alekseyevka",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Valuyki",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Tuapse",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Gelendzhik",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Labinsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Armavir",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Timashevsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Tikhoretsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Yeysk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Saransk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kamenka",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kuznetsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Serdobsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kasimov",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Sasovo",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kotovsk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Morshansk",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Kovrov",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Murom",

    country: "Russia",
    timezone: "Europe/Moscow",
  },
  {
    city: "Rayevskiy",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Sibay",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Kumertau",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Salavat",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Belebey",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Tuymazy",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Neftekamsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Troitsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Yemanzhelinsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Kartaly",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Asha",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Miass",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Kyshtym",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Kurtamysh",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Shadrinsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Varnek",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Bugrino",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Yamburg",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Nakhodka",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Sosnogorsk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Sovetsk",

    country: "Russia",

    timezone: "Europe/Kirov",
  },
  {
    city: "Slobodskoy",

    country: "Russia",

    timezone: "Europe/Kirov",
  },
  {
    city: "Kirs",

    country: "Russia",

    timezone: "Europe/Kirov",
  },
  {
    city: "Omutninsk",

    country: "Russia",

    timezone: "Europe/Kirov",
  },
  {
    city: "Kotelnich",

    country: "Russia",

    timezone: "Europe/Kirov",
  },
  {
    city: "Yoshkar Ola",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Kamensk Uralskiy",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Polevskoy",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Tavda",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Artemovskiy",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Nevyansk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Verkhnyaya Salda",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Nizhnyaya Tura",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Karpinsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Ivdel",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Krasnoufimsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Sarapul",

    country: "Russia",

    timezone: "Europe/Samara",
  },
  {
    city: "Mozhga",

    country: "Russia",

    timezone: "Europe/Samara",
  },
  {
    city: "Votkinsk",

    country: "Russia",

    timezone: "Europe/Samara",
  },
  {
    city: "Glazov",

    country: "Russia",

    timezone: "Europe/Samara",
  },
  {
    city: "Kanash",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Shumerlya",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Alatyr",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Sol-lletsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Dombarovskiy",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Mednogorsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Gay",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Buzuluk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Otradnyy",

    country: "Russia",

    timezone: "Europe/Samara",
  },
  {
    city: "Tolyatti",

    country: "Russia",

    timezone: "Europe/Samara",
  },
  {
    city: "Engels",

    country: "Russia",

    timezone: "Europe/Saratov",
  },
  {
    city: "Pugachev",

    country: "Russia",

    timezone: "Europe/Saratov",
  },
  {
    city: "Volsk",

    country: "Russia",

    timezone: "Europe/Saratov",
  },
  {
    city: "Atkarsk",

    country: "Russia",

    timezone: "Europe/Saratov",
  },
  {
    city: "Balashov",

    country: "Russia",

    timezone: "Europe/Saratov",
  },
  {
    city: "Almetyevsk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Chistopol",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Nizhnekamsk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Dimitrovgrad",

    country: "Russia",

    timezone: "Europe/Ulyanovsk",
  },
  {
    city: "Peregrebnoye",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Saranpaul",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Uray",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Laryak",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Kogalym",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Megion",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Cherlak",

    country: "Russia",

    timezone: "Asia/Omsk",
  },
  {
    city: "Kalachinsk",

    country: "Russia",

    timezone: "Asia/Omsk",
  },
  {
    city: "Nazyvayevsk",

    country: "Russia",

    timezone: "Asia/Omsk",
  },
  {
    city: "Isikul",

    country: "Russia",

    timezone: "Asia/Omsk",
  },
  {
    city: "Ishim",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Golyshmanovo",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Yalutorovsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Biysk",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Zmeinogorsk",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Aleysk",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Novoaltaysk",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Kamenna Obi",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Gornyak",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Kulunda",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Slavgorod",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Tashtagol",

    country: "Russia",

    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Guryevsk",

    country: "Russia",

    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Yurga",

    country: "Russia",

    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Topki",

    country: "Russia",

    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Mariinsk",

    country: "Russia",

    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Shira",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Cherepanovo",

    country: "Russia",

    timezone: "Asia/Novosibirsk",
  },
  {
    city: "Kargat",

    country: "Russia",

    timezone: "Asia/Novosibirsk",
  },
  {
    city: "Ob",

    country: "Russia",

    timezone: "Asia/Novosibirsk",
  },
  {
    city: "Karasuk",

    country: "Russia",

    timezone: "Asia/Novosibirsk",
  },
  {
    city: "Barabinsk",

    country: "Russia",

    timezone: "Asia/Novosibirsk",
  },
  {
    city: "Tatarsk",

    country: "Russia",

    timezone: "Asia/Novosibirsk",
  },
  {
    city: "Kaspiysk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Derbent",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Buynaksk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Yessey",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Ulkan",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Kirensk",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Zheleznogorsk Ilimskiy",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Vikhorevka",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Biryusinsk",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Kodinskiy",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Artemovsk",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Uyar",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Uzhur",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Sayanogorsk",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Podkamennaya",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Igarka",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Agapa",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Boyarka",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Nordvik",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Chelyuskin",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Taksimo",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Gusinoozyorsk",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Aginskoye",

    country: "Russia",

    timezone: "Asia/Chita",
  },
  {
    city: "Progress",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Belogorsk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Nyukzha",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Nerchinsk",

    country: "Russia",

    timezone: "Asia/Chita",
  },
  {
    city: "Kavalerovo",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Spassk Dalniy",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Shalaurova",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Logashkino",

    country: "Russia",

    timezone: "Asia/Srednekolymsk",
  },
  {
    city: "Ust Kuyga",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Pokrovsk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Verkhnevilyuysk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Vitim",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Olyokminsk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Tunguskhaya",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Natara",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Zhilinda",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Trofimovsk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Tukchi",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Amursk",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Bikin",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Vyazemskiy",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Chegdomyn",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Siglan",

    country: "Russia",

    timezone: "Asia/Magadan",
  },
  {
    city: "Karamken",

    country: "Russia",

    timezone: "Asia/Magadan",
  },
  {
    city: "Strelka",

    country: "Russia",

    timezone: "Asia/Magadan",
  },
  {
    city: "Severo Kurilsk",

    country: "Russia",

    timezone: "Asia/Srednekolymsk",
  },
  {
    city: "Krasnogorsk",

    country: "Russia",

    timezone: "Asia/Sakhalin",
  },
  {
    city: "Poronaysk",

    country: "Russia",

    timezone: "Asia/Sakhalin",
  },
  {
    city: "Makarov",

    country: "Russia",

    timezone: "Asia/Sakhalin",
  },
  {
    city: "Dolinsk",

    country: "Russia",

    timezone: "Asia/Sakhalin",
  },
  {
    city: "Nevelsk",

    country: "Russia",

    timezone: "Asia/Sakhalin",
  },
  {
    city: "Kudymkar",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Kungur",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Krasnokamsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Chusovoy",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Gubakha",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Utkholok",

    country: "Russia",

    timezone: "Asia/Kamchatka",
  },
  {
    city: "Bol'sheretsk",

    country: "Russia",

    timezone: "Asia/Kamchatka",
  },
  {
    city: "Il'pyrskiy",

    country: "Russia",

    timezone: "Asia/Kamchatka",
  },
  {
    city: "Korf",

    country: "Russia",

    timezone: "Asia/Kamchatka",
  },
  {
    city: "Kolpashevo",

    country: "Russia",

    timezone: "Asia/Tomsk",
  },
  {
    city: "Omolon",

    country: "Russia",

    timezone: "Asia/Anadyr",
  },
  {
    city: "Pevek",

    country: "Russia",

    timezone: "Asia/Anadyr",
  },
  {
    city: "Umba",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Kovda",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Velikiy Novgorod",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Velikiye Luki",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Belomorsk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Kem",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Krasino",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Matochkin Shar",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Severodvinsk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Kursk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Tula",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Tambov",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Sterlitamak",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Kurgan",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Indiga",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Shoyna",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Novy Port",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Salekhard",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Gyda",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Tazovskiy",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Novy Urengoy",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Nadym",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Noyabrsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Syktyvkar",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Ukhta",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Serov",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Cheboksary",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Orsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Balakovo",

    country: "Russia",

    timezone: "Europe/Saratov",
  },
  {
    city: "Igrim",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Nyagan",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Khanty Mansiysk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Nizhenvartovsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Numto",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Tara",

    country: "Russia",

    timezone: "Asia/Omsk",
  },
  {
    city: "Tobolsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Rubtsovsk",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Gorno Altaysk",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Prokopyevsk",

    country: "Russia",

    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Makhachkala",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Tura",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Noginsk",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Yerema",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Tayshet",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Usolye Sibirskoye",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Slyudyanka",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Cheremkhovo",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Zima",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Tulun",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Nizhneudinsk",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Ust Kut",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Bodaybo",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Komsa",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Kansk",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Achinsk",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Yeniseysk",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Lesosibirsk",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Turukhansk",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Vorontsovo",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Starorybnoye",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Mikhaylova",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Dudinka",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Teli",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Novyy Uoyin",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Bagdarin",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Severobaykalsk",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Kyakhta",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Svobodnyy",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Zeya",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Magdagachi",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Shimanovsk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Skovorodino",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Tynda",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Olovyannaya",

    country: "Russia",

    timezone: "Asia/Chita",
  },
  {
    city: "Mogocha",

    country: "Russia",

    timezone: "Asia/Chita",
  },
  {
    city: "Krasnokamensk",

    country: "Russia",

    timezone: "Asia/Chita",
  },
  {
    city: "Borzya",

    country: "Russia",

    timezone: "Asia/Chita",
  },
  {
    city: "Khilok",

    country: "Russia",

    timezone: "Asia/Chita",
  },
  {
    city: "Nakhodka",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Ussuriysk",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Lesozavodsk",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Kavache",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Verkhoyansk",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Cherskiy",

    country: "Russia",

    timezone: "Asia/Srednekolymsk",
  },
  {
    city: "Srednekolymsk",

    country: "Russia",

    timezone: "Asia/Srednekolymsk",
  },
  {
    city: "Zyryanka",

    country: "Russia",

    timezone: "Asia/Srednekolymsk",
  },
  {
    city: "Eldikan",

    country: "Russia",

    timezone: "Asia/Khandyga",
  },
  {
    city: "Chagda",

    country: "Russia",

    timezone: "Asia/Khandyga",
  },
  {
    city: "Khandyga",

    country: "Russia",

    timezone: "Asia/Khandyga",
  },
  {
    city: "Ust Maya",

    country: "Russia",

    timezone: "Asia/Khandyga",
  },
  {
    city: "Neryungri",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Chernyshevskiy",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Terbyas",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Vilyuysk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Sangar",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Menkere",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Saskylakh",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Govorovo",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Sagastyr",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Ust Olensk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Suntar",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Olenek",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Udachnyy",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Birobidzhan",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Khakhar",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "De Kastri",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Chumikan",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Komsomolsk na Amure",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Ayan",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Nikolayevsk na Amure",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Savetskaya Gavan",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Evensk",

    country: "Russia",

    timezone: "Asia/Magadan",
  },
  {
    city: "Palatka",

    country: "Russia",

    timezone: "Asia/Magadan",
  },
  {
    city: "Omsukchan",

    country: "Russia",

    timezone: "Asia/Magadan",
  },
  {
    city: "Susuman",

    country: "Russia",

    timezone: "Asia/Magadan",
  },
  {
    city: "Nogliki",

    country: "Russia",

    timezone: "Asia/Sakhalin",
  },
  {
    city: "Aleksandrovsk Sakhalinskiy",

    country: "Russia",

    timezone: "Asia/Sakhalin",
  },
  {
    city: "Korsakov",

    country: "Russia",

    timezone: "Asia/Sakhalin",
  },
  {
    city: "Manily",

    country: "Russia",

    timezone: "Asia/Kamchatka",
  },
  {
    city: "Oktyabrskiy",

    country: "Russia",

    timezone: "Asia/Kamchatka",
  },
  {
    city: "Klyuchi",

    country: "Russia",

    timezone: "Asia/Kamchatka",
  },
  {
    city: "Ust Kamchatsk",

    country: "Russia",

    timezone: "Asia/Kamchatka",
  },
  {
    city: "Provideniya",

    country: "Russia",

    timezone: "Asia/Anadyr",
  },
  {
    city: "Uelen",

    country: "Russia",

    timezone: "Asia/Anadyr",
  },
  {
    city: "Kandalaksha",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Vyborg",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Kondopoga",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Rusanovo",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Mezen",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Velsk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Kotlas",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Onega",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Ivanovo",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Kostroma",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Velikiy Ustyug",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Lipetsk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Orel",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Volgodonsk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Belgorod",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Novorossiysk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Vladimir",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Birsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Zlatoust",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Amderma",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Naryan Mar",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Inta",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Usinsk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Pechora",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Pervouralsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Izhevsk",

    country: "Russia",

    timezone: "Europe/Samara",
  },
  {
    city: "Akhtubinsk",

    country: "Russia",

    timezone: "Europe/Astrakhan",
  },
  {
    city: "Elista",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Krasnoarmeysk",

    country: "Russia",

    timezone: "Europe/Saratov",
  },
  {
    city: "Berezniki",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Naltchik",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Stavropol",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Ugolnye Kopi",

    country: "Russia",

    timezone: "Asia/Anadyr",
  },
  {
    city: "Kaliningrad",

    country: "Russia",

    timezone: "Europe/Kaliningrad",
  },
  {
    city: "Pskov",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Bryansk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Smolensk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Petrozavodsk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Tver",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Vologda",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Yaroslavl",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Rostov",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Sochi",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Krasnodar",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Penza",

    country: "Russia",

    timezone: null,
  },
  {
    city: "Ryazan",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Voronezh",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Magnitogorsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Chelyabinsk",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Vorkuta",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Kirov",

    country: "Russia",

    timezone: "Europe/Kirov",
  },
  {
    city: "Nizhny Tagil",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Astrakhan",

    country: "Russia",

    timezone: "Europe/Astrakhan",
  },
  {
    city: "Orenburg",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Saratov",

    country: "Russia",

    timezone: "Europe/Saratov",
  },
  {
    city: "Ulyanovsk",

    country: "Russia",

    timezone: "Europe/Ulyanovsk",
  },
  {
    city: "Omsk",

    country: "Russia",

    timezone: "Asia/Omsk",
  },
  {
    city: "Tyumen",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Novokuznetsk",

    country: "Russia",

    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Kemerovo",

    country: "Russia",

    timezone: "Asia/Novokuznetsk",
  },
  {
    city: "Groznyy",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Ust-Ulimsk",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Angarsk",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Abakan",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Norilsk",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Khatanga",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Kyzyl",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Ulan Ude",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Blagoveshchensk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Bukachacha",

    country: "Russia",

    timezone: "Asia/Chita",
  },
  {
    city: "Dalnegorsk",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Ambarchik",

    country: "Russia",

    timezone: "Asia/Srednekolymsk",
  },
  {
    city: "Batagay",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Chokurdakh",

    country: "Russia",

    timezone: "Asia/Srednekolymsk",
  },
  {
    city: "Ust Nera",

    country: "Russia",

    timezone: "Asia/Ust-Nera",
  },
  {
    city: "Lensk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Aldan",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Mirnyy",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Zhigansk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Okhotsk",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Khabarovsk",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Okha",

    country: "Russia",

    timezone: "Asia/Sakhalin",
  },
  {
    city: "Yuzhno Sakhalinsk",

    country: "Russia",

    timezone: "Asia/Sakhalin",
  },
  {
    city: "Tomsk",

    country: "Russia",

    timezone: "Asia/Tomsk",
  },
  {
    city: "Anadyr",

    country: "Russia",

    timezone: "Asia/Anadyr",
  },
  {
    city: "Murmansk",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Archangel",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Nizhny Novgorod",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Volgograd",

    country: "Russia",

    timezone: "Europe/Volgograd",
  },
  {
    city: "Ufa",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Yekaterinburg",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Samara",

    country: "Russia",

    timezone: "Europe/Samara",
  },
  {
    city: "Kazan",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Surgut",

    country: "Russia",

    timezone: "Asia/Yekaterinburg",
  },
  {
    city: "Barnaul",

    country: "Russia",

    timezone: "Asia/Barnaul",
  },
  {
    city: "Novosibirsk",

    country: "Russia",

    timezone: "Asia/Novosibirsk",
  },
  {
    city: "Bratsk",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Irkutsk",

    country: "Russia",

    timezone: "Asia/Irkutsk",
  },
  {
    city: "Krasnoyarsk",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Dickson",

    country: "Russia",

    timezone: "Asia/Krasnoyarsk",
  },
  {
    city: "Chita",

    country: "Russia",

    timezone: "Asia/Chita",
  },
  {
    city: "Vladivostok",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Nizhneyansk",

    country: "Russia",

    timezone: "Asia/Vladivostok",
  },
  {
    city: "Yakutsk",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Tiksi",

    country: "Russia",

    timezone: "Asia/Yakutsk",
  },
  {
    city: "Magadan",

    country: "Russia",

    timezone: "Asia/Magadan",
  },
  {
    city: "Perm",

    country: "Russia",

    timezone: null,
  },
  {
    city: "Palana",

    country: "Russia",

    timezone: "Asia/Kamchatka",
  },
  {
    city: "Petropavlovsk Kamchatskiy",

    country: "Russia",

    timezone: "Asia/Kamchatka",
  },
  {
    city: "St. Petersburg",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Moscow",

    country: "Russia",

    timezone: "Europe/Moscow",
  },
  {
    city: "Gikongoro",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Kibuye",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Kibungo",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Nyanza",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Gitarama",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Butare",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Gisenyi",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Cyangugu",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Byumba",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Ruhengeri",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Kigali",

    country: "Rwanda",

    timezone: "Africa/Kigali",
  },
  {
    city: "Basseterre",

    country: "Saint Kitts and Nevis",

    timezone: "America/St_Kitts",
  },
  {
    city: "Castries",

    country: "Saint Lucia",

    timezone: "America/St_Lucia",
  },
  {
    city: "Kingstown",

    country: "Saint Vincent and the Grenadines",

    timezone: "America/St_Vincent",
  },
  {
    city: "Apia",

    country: "Samoa",

    timezone: "Pacific/Apia",
  },
  {
    city: "San Marino",

    country: "San Marino",

    timezone: "Europe/San_Marino",
  },
  {
    city: "Santo Antonio",

    country: "Sao Tome and Principe",

    timezone: "Africa/Sao_Tome",
  },
  {
    city: "Sao Tome",

    country: "Sao Tome and Principe",

    timezone: "Africa/Sao_Tome",
  },
  {
    city: "An Nabk",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Sakakah",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Yanbu al Bahr",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Dawmat al Jandal",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Qal at Bishah",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "At Taif",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Najran",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Al Quwayiyah",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Al Hillah",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Al Mubarraz",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Al-Qatif",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Az Zahran",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Buraydah",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Hail",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Arar",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Rafha",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Al Kharj",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Ad Damman",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Hafar al Batin",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Al Jubayl",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Al Qunfudhah",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Al Hufuf",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Al Wajh",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Abha",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Jizan",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "As Sulayyil",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Medina",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Tabuk",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Jeddah",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Makkah",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Riyadh",

    country: "Saudi Arabia",

    timezone: "Asia/Riyadh",
  },
  {
    city: "Fatick",

    country: "Senegal",

    timezone: "Africa/Dakar",
  },
  {
    city: "Diourbel",

    country: "Senegal",

    timezone: "Africa/Dakar",
  },
  {
    city: "Louga",

    country: "Senegal",

    timezone: "Africa/Dakar",
  },
  {
    city: "Thies",

    country: "Senegal",

    timezone: "Africa/Dakar",
  },
  {
    city: "Kolda",

    country: "Senegal",

    timezone: "Africa/Dakar",
  },
  {
    city: "Tambacounda",

    country: "Senegal",

    timezone: "Africa/Dakar",
  },
  {
    city: "Kedougou",

    country: "Senegal",

    timezone: "Africa/Dakar",
  },
  {
    city: "Ziguinchor",

    country: "Senegal",

    timezone: "Africa/Dakar",
  },
  {
    city: "Kaolack",

    country: "Senegal",

    timezone: "Africa/Dakar",
  },
  {
    city: "Kaedi",

    country: "Senegal",

    timezone: "Africa/Nouakchott",
  },
  {
    city: "Dakar",

    country: "Senegal",

    timezone: "Africa/Dakar",
  },
  {
    city: "Subotica",

    country: "Serbia",

    timezone: "Europe/Belgrade",
  },
  {
    city: "Kragujevac",

    country: "Serbia",

    timezone: "Europe/Belgrade",
  },
  {
    city: "Zrenjanin",

    country: "Serbia",

    timezone: "Europe/Belgrade",
  },
  {
    city: "Pec",

    country: "Serbia",

    timezone: "Europe/Belgrade",
  },
  {
    city: "Nis",

    country: "Serbia",

    timezone: "Europe/Belgrade",
  },
  {
    city: "Novi Sad",

    country: "Serbia",

    timezone: "Europe/Belgrade",
  },
  {
    city: "Belgrade",

    country: "Serbia",

    timezone: "Europe/Belgrade",
  },
  {
    city: "Victoria",

    country: "Seychelles",

    timezone: "Indian/Mahe",
  },
  {
    city: "Makeni",

    country: "Sierra Leone",

    timezone: "Africa/Freetown",
  },
  {
    city: "Koidu",

    country: "Sierra Leone",

    timezone: "Africa/Freetown",
  },
  {
    city: "Kenema",

    country: "Sierra Leone",

    timezone: "Africa/Freetown",
  },
  {
    city: "Bo",

    country: "Sierra Leone",

    timezone: "Africa/Freetown",
  },
  {
    city: "Freetown",

    country: "Sierra Leone",

    timezone: "Africa/Freetown",
  },
  {
    city: "Singapore",

    country: "Singapore",

    timezone: "Asia/Singapore",
  },
  {
    city: "Banska Bystrica",

    country: "Slovakia",

    timezone: "Europe/Bratislava",
  },
  {
    city: "Trnava",

    country: "Slovakia",

    timezone: "Europe/Bratislava",
  },
  {
    city: "Zvolen",

    country: "Slovakia",

    timezone: "Europe/Bratislava",
  },
  {
    city: "Zilina",

    country: "Slovakia",

    timezone: "Europe/Bratislava",
  },
  {
    city: "Kosice",

    country: "Slovakia",

    timezone: "Europe/Bratislava",
  },
  {
    city: "Presov",

    country: "Slovakia",

    timezone: "Europe/Bratislava",
  },
  {
    city: "Bratislava",

    country: "Slovakia",

    timezone: "Europe/Bratislava",
  },
  {
    city: "Maribor",

    country: "Slovenia",

    timezone: "Europe/Ljubljana",
  },
  {
    city: "Ljubljana",

    country: "Slovenia",

    timezone: "Europe/Ljubljana",
  },
  {
    city: "Gizo",

    country: "Solomon Islands",

    timezone: "Pacific/Guadalcanal",
  },
  {
    city: "Lata",

    country: "Solomon Islands",

    timezone: "Pacific/Guadalcanal",
  },
  {
    city: "Honiara",

    country: "Solomon Islands",

    timezone: "Pacific/Guadalcanal",
  },
  {
    city: "Hudur",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Garbahaarey",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Bu'aale",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Dhuusa Mareeb",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Buurhakaba",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Luuq",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Mandera",

    country: "Somalia",

    timezone: "Africa/Nairobi",
  },
  {
    city: "Ferfer",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Jawhar",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Hurdiyo",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Qardho",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Caluula",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Buur Gaabo",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Baydhabo",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Marka",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Mereeg",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Beledweyne",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Boosaaso",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Bandarbeyla",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Gaalkacyo",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Eyl",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Garoowe",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Jamaame",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Kismaayo",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Mogadishu",

    country: "Somalia",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Laascaanood",

    country: "Somaliland",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Ceerigaabo",

    country: "Somaliland",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Boorama",

    country: "Somaliland",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Burco",

    country: "Somaliland",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Maydh",

    country: "Somaliland",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Berbera",

    country: "Somaliland",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Hargeysa",

    country: "Somaliland",

    timezone: "Africa/Mogadishu",
  },
  {
    city: "Qacha's Nek",

    country: "South Africa",

    timezone: "Africa/Maseru",
  },
  {
    city: "Colesberg",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Poffader",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Carnarvon",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Prieska",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Kuruman",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Knysna",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Swellendam",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Hermanus",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Paarl",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Bredasdorp",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Beaufort West",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Brits",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Bloemhof",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Potchefstroom",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Brandfort",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Bethlehem",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Springs",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Volksrust",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Mbombela",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Komatipoort",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Middelburg",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Bethal",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Standerton",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Lebowakgomo",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Tzaneen",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Ulundi",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Ladysmith",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Port Shepstone",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Ubomba",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Cradock",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Uitenhage",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Port Alfred",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Grahamstown",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Port St. Johns",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Aliwal North",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Queenstown",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Benoni",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Vereeniging",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "De Aar",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Alexander Bay",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Kimberley",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Oudtshoorn",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Vanhynsdorp",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Saldanha",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Mossel Bay",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Vryburg",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Rustenburg",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Mmabatho",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Klerksdorp",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Kroonstad",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Polokwane",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Thohoyandou",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Musina",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Vryheid",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Pietermaritzburg",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Umtata",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Graaff Reinet",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Bhisho",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Springbok",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Upington",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Worcester",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "George",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Welkom",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "East London",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Middelburg",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Bloemfontein",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Pretoria",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Port Elizabeth",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Durban",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Johannesburg",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Cape Town",

    country: "South Africa",

    timezone: "Africa/Johannesburg",
  },
  {
    city: "Grytviken",

    country: "South Georgia and the Islands",

    timezone: "Atlantic/South_Georgia",
  },
  {
    city: "Eumseong",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Cheongju",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Wonju",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Chuncheon",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Ansan",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Iksan",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Gyeongju",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Changwon",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Yeosu",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Andong",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Jeju",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Gangneung",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Sokcho",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Jeonju",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Gunsan",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Mokpo",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Puch'on",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Songnam",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Goyang",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Suwon",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Pohang",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Ulsan",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Daegu",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Incheon",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Daejeon",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Gwangju",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Busan",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Seoul",

    country: "South Korea",

    timezone: "Asia/Seoul",
  },
  {
    city: "Bentiu",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Maridi",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Yei",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Melut",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Nasir",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Gogrial",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Kapoeta",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Aweil",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Rumbek",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Yambio",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Bor",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Nimule",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Juba",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Malakal",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Wau",

    country: "South Sudan",

    timezone: "Africa/Juba",
  },
  {
    city: "Merida",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Marbella",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Linares",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Algeciras",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Leon",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Mataro",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Gijon",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Vitoria",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Almeria",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Malaga",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Jaén",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Huelva",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Albacete",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Toledo",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Guadalajara",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Santander",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Salamanca",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Burgos",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Tarragona",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Lorca",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Cartagena",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Oviedo",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Santiago de Compostela",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Badajoz",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Logrono",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "San Sebastián",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Alicante",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Castello",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Arrecife",

    country: "Spain",

    timezone: "Atlantic/Canary",
  },
  {
    city: "Cadiz",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Granada",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Murcia",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Ceuta",

    country: "Spain",

    timezone: "Africa/Ceuta",
  },
  {
    city: "La Coruña",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Ourense",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Pamplona",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Valladolid",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Melilla",

    country: "Spain",

    timezone: "Africa/Ceuta",
  },
  {
    city: "Palma",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Zaragoza",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Santa Cruz de Tenerife",

    country: "Spain",

    timezone: "Atlantic/Canary",
  },
  {
    city: "Cordoba",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Vigo",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Bilbao",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Las Palmas",

    country: "Spain",

    timezone: "Atlantic/Canary",
  },
  {
    city: "Seville",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Valencia",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Barcelona",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Madrid",

    country: "Spain",

    timezone: "Europe/Madrid",
  },
  {
    city: "Trincomalee",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Puttalan",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Ratnapura",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Batticaloa",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Kilinochchi",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Matara",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Badulla",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Moratuwa",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Galle",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Anuradhapura",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Jaffna",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Kandy",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Sri Jawewardenepura Kotte",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Colombo",

    country: "Sri Lanka",

    timezone: "Asia/Colombo",
  },
  {
    city: "Ad Damazin",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Haiya",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "El Manaqil",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Shendi",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Berber",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Kerma",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Ed Dueim",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Umm Ruwaba",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "En Nuhud",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Muglad",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Tokar",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Medani",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Gedaref",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "EdDamer",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Atbara",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Wadi Halfa",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Merowe",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Kosti",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Sennar",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "El Fasher",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Kadugli",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Babanusa",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Geneina",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Omdurman",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "El Obeid",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Port Sudan",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Niyala",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Dongola",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Kassala",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Khartoum",

    country: "Sudan",

    timezone: "Africa/Khartoum",
  },
  {
    city: "Onverwacht",

    country: "Suriname",

    timezone: "America/Paramaribo",
  },
  {
    city: "Groningen",

    country: "Suriname",

    timezone: "America/Paramaribo",
  },
  {
    city: "Brownsweg",

    country: "Suriname",

    timezone: "America/Paramaribo",
  },
  {
    city: "Moengo",

    country: "Suriname",

    timezone: "America/Paramaribo",
  },
  {
    city: "Nieuw Amsterdam",

    country: "Suriname",

    timezone: "America/Paramaribo",
  },
  {
    city: "Nieuw Nickerie",

    country: "Suriname",

    timezone: "America/Paramaribo",
  },
  {
    city: "Brokopondo",

    country: "Suriname",

    timezone: "America/Paramaribo",
  },
  {
    city: "Totness",

    country: "Suriname",

    timezone: "America/Paramaribo",
  },
  {
    city: "Cottica",

    country: "Suriname",

    timezone: "America/Paramaribo",
  },
  {
    city: "Paramaribo",

    country: "Suriname",

    timezone: "America/Paramaribo",
  },
  {
    city: "Longyearbyen",

    country: "Svalbard and Jan Mayen Islands",

    timezone: "Arctic/Longyearbyen",
  },
  {
    city: "Piggs Peak",

    country: "Swaziland",

    timezone: "Africa/Mbabane",
  },
  {
    city: "Siteki",

    country: "Swaziland",

    timezone: "Africa/Mbabane",
  },
  {
    city: "Manzini",

    country: "Swaziland",

    timezone: "Africa/Mbabane",
  },
  {
    city: "Hlatikulu",

    country: "Swaziland",

    timezone: "Africa/Mbabane",
  },
  {
    city: "Golela",

    country: "Swaziland",

    timezone: "Africa/Mbabane",
  },
  {
    city: "Lobamba",

    country: "Swaziland",

    timezone: "Africa/Mbabane",
  },
  {
    city: "Mbabane",

    country: "Swaziland",

    timezone: "Africa/Mbabane",
  },
  {
    city: "Falun",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Nykoping",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Harnosand",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Karlskrona",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Mariestad",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Vannersborg",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Borlänge",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Västerås",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Bollnäs",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Gävle",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Kalmar",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Växjö",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Örebro",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Norrköping",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Halmstad",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Karlstad",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Skellefteå",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Visby",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Trollhättan",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Borås",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Kristianstad",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Helsingborg",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Jönköping",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Örnsköldsvik",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Linköping",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Östersund",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Kiruna",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Umeå",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Uppsala",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Göteborg",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Luleå",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Sundsvall",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Malmö",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Stockholm",

    country: "Sweden",

    timezone: "Europe/Stockholm",
  },
  {
    city: "Delemont",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Neuchatel",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Aarau",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Stans",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Sion",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Herisau",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Saint Gallen",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Bellinzona",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Glarus",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Schaffhausen",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Schwyz",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Frauenfeld",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Altdorf",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Zug",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Fribourg",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Liestal",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Solothurn",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Sarnen",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Appenzell",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Chur",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Biel",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Luzern",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Lugano",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Lausanne",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Basel",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Bern",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Zürich",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Geneva",

    country: "Switzerland",

    timezone: "Europe/Zurich",
  },
  {
    city: "Dar'a",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Al Ladhiqiyah",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Madinat ath Thawrah",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Izaz",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Manbij",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Idlib",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Al Qamishli",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Al Hasakah",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Douma",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Tartus",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Ar Raqqah",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Hamah",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Tadmur",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Abu Kamal",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Dayr az Zawr",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "As Suwayda",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Ad Nabk",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Al Qunaytirah",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Hims",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Aleppo",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Damascus",

    country: "Syria",

    timezone: "Asia/Damascus",
  },
  {
    city: "Bade",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Pingzhen",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Taibao",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Taoyuan",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Yangmei",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Yilan",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Zhubei",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Douliou",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Zhongli",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Keelung",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Nantou",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Puzi",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Changhua",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Chiayi",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Hsinchu",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Miaoli",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Pingtung",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Hualien",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "New Taipei",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Tainan",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Taitung",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Magong",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Taichung",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Kaohsiung",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Taipei",

    country: "Taiwan",

    timezone: "Asia/Taipei",
  },
  {
    city: "Leninobod",

    country: "Tajikistan",

    timezone: "Asia/Dushanbe",
  },
  {
    city: "Qurghonteppa",

    country: "Tajikistan",

    timezone: "Asia/Dushanbe",
  },
  {
    city: "Konibodom",

    country: "Tajikistan",

    timezone: "Asia/Dushanbe",
  },
  {
    city: "Kuybyshevskiy",

    country: "Tajikistan",

    timezone: "Asia/Dushanbe",
  },
  {
    city: "Kulob",

    country: "Tajikistan",

    timezone: "Asia/Dushanbe",
  },
  {
    city: "Uroteppa",

    country: "Tajikistan",

    timezone: "Asia/Dushanbe",
  },
  {
    city: "Khorugh",

    country: "Tajikistan",

    timezone: "Asia/Dushanbe",
  },
  {
    city: "Khujand",

    country: "Tajikistan",

    timezone: "Asia/Dushanbe",
  },
  {
    city: "Dushanbe",

    country: "Tajikistan",

    timezone: "Asia/Dushanbe",
  },
  {
    city: "Wete",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Kibaha",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Mkokotoni",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Tunduma",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Tukuyu",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Sumbawanga",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Mpanda",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Kipili",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Karema",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Geita",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Nyahanga",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Kahama",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Shinyanga",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Nzega",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Sikonge",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Biharamulo",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Bukoba",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Ngara",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Kakonko",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Kasulu",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Kanyato",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Uvinza",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Kigoma",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Mikumi",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Ifakara",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Kilosa",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Chake Chake",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Kibiti",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Bagamoyo",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Kilindoni",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Mpwapwa",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Njombe",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Iringa",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Masasi",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Mtwara",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Tunduru",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Mbamba Bay",

    country: "Tanzania",

    timezone: "Africa/Blantyre",
  },
  {
    city: "Manyoni",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Itigi",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Singida",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Ngorongoro",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Oldeani",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Mbulu",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Babati",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Same",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Moshi",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Musoma",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Korogwe",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Tabora",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Lindi",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Songea",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Tanga",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Mwanza",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Morogoro",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Dodoma",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Arusha",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Mbeya",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Zanzibar",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Dar es Salaam",

    country: "Tanzania",

    timezone: "Africa/Dar_es_Salaam",
  },
  {
    city: "Mae Hong Son",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Phangnga",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Ranong",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Krabi",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Phatthalung",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Satun",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Lamphun",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Kamphaeng Phet",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Phichit",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Phetchabun",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Supham Buri",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Ang Thong",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Chainat",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Nakhon Nayok",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Sing Buri",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Nakhon Pathom",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Prachuap Khiri Khan",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Samut Sakhon",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Samut Songkhram",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Yasothon",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Chachoengsao",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Trat",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Kalasin",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Maha Sarakham",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Roi Et",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Pattani",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Chumphon",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Thung Song",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Trang",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Yala",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Chiang Rai",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Lampang",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Nan",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Phayao",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Phrae",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Phitsanulok",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Sukhothai",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Uttaradit",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Kanchanaburi",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Mae Sot",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Tak",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Uthai Thani",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Lop Buri",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Prachin Buri",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Ayutthaya",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Pathum Thani",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Saraburi",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Nonthaburi",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Phetchaburi",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Hua Hin",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Ratchaburi",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Samut Prakan",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Sisaket",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Si Racha",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Chon Buri",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Chanthaburi",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Aranyaprathet",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Rayong",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Buriram",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Chaiyaphum",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Bua Yai",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Surin",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Loei",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Nong Khai",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Sakhon Nakhon",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Udon Thani",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Nakhon Phanom",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Narathiwat",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Khon Kaen",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Phuket",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Nakhon Si Thammarat",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Songkhla",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Hat Yai",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Nakhon Sawan",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Ubon Ratchathani",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Surat Thani",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Chiang Mai",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Nakhon Ratchasima",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Bangkok",

    country: "Thailand",

    timezone: "Asia/Bangkok",
  },
  {
    city: "Freeport",

    country: "The Bahamas",

    timezone: "America/Nassau",
  },
  {
    city: "Nassau",

    country: "The Bahamas",

    timezone: "America/Nassau",
  },
  {
    city: "Georgetown",

    country: "The Gambia",

    timezone: "Africa/Banjul",
  },
  {
    city: "Basse Santa Su",

    country: "The Gambia",

    timezone: "Africa/Banjul",
  },
  {
    city: "Kerewan",

    country: "The Gambia",

    timezone: "Africa/Banjul",
  },
  {
    city: "Mansa Konko",

    country: "The Gambia",

    timezone: "Africa/Banjul",
  },
  {
    city: "Bansang",

    country: "The Gambia",

    timezone: "Africa/Banjul",
  },
  {
    city: "Brikama",

    country: "The Gambia",

    timezone: "Africa/Banjul",
  },
  {
    city: "Banjul",

    country: "The Gambia",

    timezone: "Africa/Banjul",
  },
  {
    city: "Bassar",

    country: "Togo",

    timezone: "Africa/Lome",
  },
  {
    city: "Sotouboua",

    country: "Togo",

    timezone: "Africa/Lome",
  },
  {
    city: "Kpalime",

    country: "Togo",

    timezone: "Africa/Lome",
  },
  {
    city: "Sokode",

    country: "Togo",

    timezone: "Africa/Lome",
  },
  {
    city: "Mango",

    country: "Togo",

    timezone: "Africa/Lome",
  },
  {
    city: "Atakpame",

    country: "Togo",

    timezone: "Africa/Lome",
  },
  {
    city: "Lome",

    country: "Togo",

    timezone: "Africa/Lome",
  },
  {
    city: "Neiafu",

    country: "Tonga",

    timezone: "Pacific/Tongatapu",
  },
  {
    city: "Nukualofa",

    country: "Tonga",

    timezone: "Pacific/Tongatapu",
  },
  {
    city: "San Fernando",

    country: "Trinidad and Tobago",

    timezone: "America/Port_of_Spain",
  },
  {
    city: "Port-of-Spain",

    country: "Trinidad and Tobago",

    timezone: "America/Port_of_Spain",
  },
  {
    city: "Medenine",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Kebili",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Tataouine",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "L'Ariana",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Jendouba",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Kasserine",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Sdid Bouzid",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Siliana",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Mahdia",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Monastir",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Zaghouan",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Ben Gardane",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Zarzis",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Dehibat",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Tozeur",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Beja",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Bizerte",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Nabeul",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "El Kef",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Qasserine",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Gabes",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Gafsa",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Qairouan",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Sfax",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Sousse",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Tunis",

    country: "Tunisia",

    timezone: "Africa/Tunis",
  },
  {
    city: "Kirklareli",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Bilecik",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Sakarya",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Kastamonu",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Burdur",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Kirsehir",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Nevsehir",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Antioch",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Giresun",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Sinop",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Tokat",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Artvin",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Bingol",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Bitlis",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Cankiri",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Nigde",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Yozgat",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Gumushane",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Siirt",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Tunceli",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Aydin",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Luleburgaz",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Isparta",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Kutahya",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Mugla",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Elazig",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Kahramanmaras",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Icel",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Corum",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Rize",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Tatvan",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Polatli",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Karabuk",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Nusaybin",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Hakkari",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Soke",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Balikesir",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Canakkale",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Edirne",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Tekirdag",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Izmit",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Bolu",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Afyon",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Denizli",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Manisa",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Adiyaman",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Malatya",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Tarsus",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Samandagi",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Hatay",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Iskenderun",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Amasya",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Ordu",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Sivas",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Bafra",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Erzurum",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Erzincan",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Agri",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Diyarbakir",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Mus",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Zonguldak",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Eregli",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Karaman",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Usak",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Kilis",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Kirikkale",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Kars",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Mardin",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Batman",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Van",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Adapazari",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Trabzon",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Sanliurfa",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Eskisehir",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Antalya",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Kayseri",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Gaziantep",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Izmir",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Bursa",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Samsun",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Konya",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Adana",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Ankara",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Istanbul",

    country: "Turkey",

    timezone: "Europe/Istanbul",
  },
  {
    city: "Gyzlarbat",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Celeken",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Tejen",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Buzmeyin",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Koneurgench",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Balkanabat",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Kaka",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Atamyrat",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Dasoguz",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Turkmenbasy",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Turkmenabat",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Mary",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Ashgabat",

    country: "Turkmenistan",

    timezone: "Asia/Ashgabat",
  },
  {
    city: "Grand Turk",

    country: "Turks and Caicos Islands",

    timezone: "America/Grand_Turk",
  },
  {
    city: "Funafuti",

    country: "Tuvalu",

    timezone: "Pacific/Funafuti",
  },
  {
    city: "Kalangala",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kumi",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kaberamaido",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kayunga",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Iganga",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kamuli",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Pallisa",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Mpigi",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Adjumani",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Nebbi",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kiboga",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Nakasongola",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Bombo",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Masindi",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Fort Portal",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kibale",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Sironko",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Busia",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Katakwi",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Ntungamo",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kisoro",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Jinja",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Soroti",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Arua",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Pakwach",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Moyo",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Entebbe",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Mubende",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Mityana",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kitgum",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Lira",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Masindi-Port",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Mbale",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Tororo",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kaabong",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Moroto",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Masaka",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Katwe",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Mbarara",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kabale",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kasese",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Gulu",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Kampala",

    country: "Uganda",

    timezone: "Africa/Kampala",
  },
  {
    city: "Mykolayiv",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Chernihiv",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Khmelnytskyy",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Kamyanets-Podilskyy",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Drohobych",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Uzhgorod",

    country: "Ukraine",

    timezone: "Europe/Uzhgorod",
  },
  {
    city: "Uman",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Brovary",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Bila Tserkva",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Illichivsk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Konotop",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Kryvyy Rih",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Makiyivka",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Horlivka",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Kramatorsk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Berdyansk",

    country: "Ukraine",

    timezone: "Europe/Zaporozhye",
  },
  {
    city: "Dzhankoy",

    country: "Ukraine",

    timezone: "Europe/Simferopol",
  },
  {
    city: "Yevpatoriya",

    country: "Ukraine",

    timezone: "Europe/Simferopol",
  },
  {
    city: "Kerch",

    country: "Ukraine",

    timezone: "Europe/Simferopol",
  },
  {
    city: "Simferopol",

    country: "Ukraine",

    timezone: "Europe/Simferopol",
  },
  {
    city: "Kherson",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Voznesensk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Nizhyn",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Rivne",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Chernivtsi",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Ivano-Frankivsk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Ternopil",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Lutsk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Kovel",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Cherkasy",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Kirovohrad",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Izmayil",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Vinnytsya",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Korosten",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Shostka",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Nikopol",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Kupyansk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Lysychansk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Luhansk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Poltava",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Kremenchuk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Melitopol",

    country: "Ukraine",

    timezone: "Europe/Zaporozhye",
  },
  {
    city: "Zaporizhzhya",

    country: "Ukraine",

    timezone: "Europe/Zaporozhye",
  },
  {
    city: "Yalta",

    country: "Ukraine",

    timezone: "Europe/Simferopol",
  },
  {
    city: "Chernobyl",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Sumy",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Mariupol",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Lvov",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Odessa",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Zhytomyr",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Dnipropetrovsk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Donetsk",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Kharkiv",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Sevastapol",

    country: "Ukraine",

    timezone: "Europe/Simferopol",
  },
  {
    city: "Kiev",

    country: "Ukraine",

    timezone: "Europe/Kiev",
  },
  {
    city: "Umm al Qaywayn",

    country: "United Arab Emirates",

    timezone: "Asia/Dubai",
  },
  {
    city: "Sharjah",

    country: "United Arab Emirates",

    timezone: "Asia/Dubai",
  },
  {
    city: "Jabal Ali",

    country: "United Arab Emirates",

    timezone: "Asia/Dubai",
  },
  {
    city: "Ras al Khaymah",

    country: "United Arab Emirates",

    timezone: "Asia/Dubai",
  },
  {
    city: "Al Fujayrah",

    country: "United Arab Emirates",

    timezone: "Asia/Dubai",
  },
  {
    city: "Al Ayn",

    country: "United Arab Emirates",

    timezone: "Asia/Dubai",
  },
  {
    city: "Abu Dhabi",

    country: "United Arab Emirates",

    timezone: "Asia/Dubai",
  },
  {
    city: "Dubai",

    country: "United Arab Emirates",

    timezone: "Asia/Dubai",
  },
  {
    city: "Greenock",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Sunderland",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Southampton",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Bristol",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Bournemouth",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Omagh",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Chester",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Swansea",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Carlisle",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Southend-on-Sea",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Reading",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Leicester",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Bradford",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Sheffield",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Fort William",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Ayr",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Aberdeen",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Perth",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Dundee",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Middlesbrough",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Coventry",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Bath",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Exeter",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Cambridge",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Kingston upon Hull",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Londonderry",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Lisburn",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Penzance",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "York",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Blackpool",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Dumfries",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Scarborough",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Plymouth",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Ipswich",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Norwich",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Brighton",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Kirkwall",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Inverness",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Oxford",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Luton",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Portsmouth",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Peterborough",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Nottingham",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Stoke",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Dover",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Edinburgh",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Newcastle",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Liverpool",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Cardiff",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Wick",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Leeds",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Lerwick",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Manchester",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Birmingham",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Belfast",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Glasgow",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "London",

    country: "United Kingdom",

    timezone: "Europe/London",
  },
  {
    city: "Faribault",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Mankato",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Albert Lea",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Willmar",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Brainerd",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Crookston",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Hardin",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Glendive",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Dillon",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Polson",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Devils Lake",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Burley",

    country: "United States of America",
    timezone: "America/Boise",
  },
  {
    city: "Wallace",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Kennewick",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Centralia",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Glendale",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Safford",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Casa Grande",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Mesa",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Lake Havasu City",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Berkeley",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "National City",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Mendocino",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Paso Robles",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Riverside",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Delano",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "San Mateo",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Vallejo",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Glenwood Springs",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Aurora",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Greeley",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Tonopah",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Deming",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Truth or Consequences",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Las Vegas",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Farmington",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Springfield",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Tillamook",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Ontario",

    country: "United States of America",
    timezone: "America/Boise",
  },
  {
    city: "La Grande",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Richfield",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Nephi",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Lander",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Powell",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Paragould",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Iowa City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Ottumwa",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Spencer",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Ft. Dodge",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Hutchinson",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Kansas City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Lawrence",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Garden City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Manhattan",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Hays",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Goodland",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Independence",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Kirksville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Kearney",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Grand Island",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Alliance",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Bartlesville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Enid",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Ardmore",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "McAlester",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Stillwater",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Lead",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Slidell",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Lake Charles",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Metairie",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "New Iberia",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Bryan",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "San Marcos",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Longview",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "McAllen",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Harlingen",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Alice",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "New Braunfels",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Cleburne",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Brownwood",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Alpine",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Van Horn",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Big Spring",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Vernon",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Childress",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Hereford",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Dalhart",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Texas City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Pasadena",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Baytown",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Arlington",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "New London",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Stamford",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Waterbury",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "New Bedford",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Springfield",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Salem",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Pittsfield",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Montpelier",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Auburn",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Florence",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Winter Haven",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Melbourne",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Homestead",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Sanford",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Miami Beach",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Coral Springs",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Port Charlotte",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Spring Hill",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Palm Coast",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Palatka",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Leesburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Lake City",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Crestview",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Panama City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Dalton",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Marietta",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Waycross",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "La Grange",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Southaven",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Meridian",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Laurel",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Spartanburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Orangeburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Galesburg",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Joliet",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Cape Girardeau",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Rockford",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Evanston",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Rock Island",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Elgin",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Richmond",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "Terre Haute",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "Lafayette",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "Marion",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "South Bend",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "New Albany",

    country: "United States of America",
    timezone: "America/Kentucky/Louisville",
  },
  {
    city: "Elkhart",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "Hopkinsville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "London",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Madisonville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Rocky Mount",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Salisbury",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Durham",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Lumberton",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Zanesville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Mansfield",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Bowling Green",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Springfield",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Lancaster",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Johnson City",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Kingsport",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Columbia",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Barlett",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Blacksburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Harrisonburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Petersburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Hampton",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Sheboygan",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Waukesha",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "La Crosse",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Eau Claire",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Tomah",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Janesville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Appleton",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Parkersburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "White Sulphur Springs",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Clarksburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Dover",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "St. Charles",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Annapolis",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Hagerstown",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Paterson",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Saratoga Springs",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Poughkeepsie",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Plattsburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Beaver Falls",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Altoona",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Williamsport",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Lancaster",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Allentown",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Waterville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Calais",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Houlton",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Benton Harbor",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Battle Creek",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Bay City",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Alpena",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Iron Mountain",

    country: "United States of America",
    timezone: "America/Menominee",
  },
  {
    city: "Ironwood",

    country: "United States of America",
    timezone: "America/Menominee",
  },
  {
    city: "Sand Point",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Hydaburg",

    country: "United States of America",
    timezone: "America/Sitka",
  },
  {
    city: "Mekoryuk",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Atqasuk",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Port Heiden",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Perryville",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Dillingham",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Goodnews Bay",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Nyac",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Tununak",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Mountain Village",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Emmonak",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Kaltag",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Teller",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Koyukuk",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Kobuk",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Selawik",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Talkeetna",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Whittier",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Montana",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Lake Minchumina",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Cantwell",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Gulkana",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Eagle",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Nenana",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Big Delta",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Allakaket",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Tanana",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Virginia",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Winona",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Rochester",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Lakeville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Ely",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Moorhead",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "St. Cloud",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Miles City",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Bozeman",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Glasgow",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Dickinson",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Jamestown",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Williston",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Lihue",

    country: "United States of America",
    timezone: "Pacific/Honolulu",
  },
  {
    city: "Wahiawa",

    country: "United States of America",
    timezone: "Pacific/Honolulu",
  },
  {
    city: "Wailuku",

    country: "United States of America",
    timezone: "Pacific/Honolulu",
  },
  {
    city: "Montpelier",

    country: "United States of America",
    timezone: "America/Boise",
  },
  {
    city: "Twin Falls",

    country: "United States of America",
    timezone: "America/Boise",
  },
  {
    city: "Caldwell",

    country: "United States of America",
    timezone: "America/Boise",
  },
  {
    city: "Salmon",

    country: "United States of America",
    timezone: "America/Boise",
  },
  {
    city: "Coeur d'Alene",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Richland",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Bellingham",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Longview",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Walla Walla",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Aberdeen",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Bremerton",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Everett",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Bullhead City",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Winslow",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Gila Bend",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Tombstone",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Willcox",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Scottsdale",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Kingman",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Grand Canyon",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Arcata",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Stockton",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Barstow",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Victorville",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Pasadena",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Visalia",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "El Centro",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "San Luis Obispo",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Merced",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Yuba City",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Redding",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Santa Rosa",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Oceanside",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Modesto",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Irvine",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Ukiah",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Needles",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Bishop",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Palm Springs",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Santa Maria",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Tulare",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Mt. Shasta",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Crescent City",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Fort Collins",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Pueblo",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Lamar",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Trinidad",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Gunnison",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Durango",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Montrose",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Craig",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Boulder",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Boulder City",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Winnemucca",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Roswell",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Clovis",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Las Cruces",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Hobbs",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Socorro",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Gallup",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Raton",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Tucumcari",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Roseburg",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Pendleton",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "John Day",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Grants Pass",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Corvallis",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Albany",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Astoria",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Logan",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Parowan",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Kanab",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Monticello",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Moab",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Price",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Cedar City",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Vernal",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Ogden",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Green River",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Rawlins",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Douglas",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Riverton",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Thermopolis",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Gillette",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Jonesboro",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Texarkana",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Pine Bluff",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Hot Springs",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Fort Smith",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Fayetteville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Conway",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "El Dorado",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Davenport",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Burlington",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Dubuque",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Waterloo",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Sioux City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Council Bluffs",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Ames",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Mason City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Emporia",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Salina",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Dodge City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Coffeyville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "St. Charles",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Poplar Bluff",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Joplin",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Columbia",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "St. Joseph",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "McCook",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Norfolk",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "North Platte",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Sidney",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Scottsbluff",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Chadron",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Lawton",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Norman",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Muskogee",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Ponca City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Shawnee",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Woodward",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Guymon",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Yankton",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Brookings",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Mitchell",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Aberdeen",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Mobridge",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Houma",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Monroe",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Conroe",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Nacogdoches",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Eagle Pass",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Edinburg",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Kingsville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Port Arthur",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Huntsville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Killeen",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Lufkin",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Del Rio",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "San Angelo",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Sherman",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Beaumont",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Bay City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Port Lavaca",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Falfurrias",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Beeville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Fort Stockton",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Pecos",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Dumas",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Denton",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Midland",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Temple",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "New Haven",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Lowell",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Worcester",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Manchester",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Newport",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Dothan",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Tuscaloosa",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Gadsden",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Enterprise",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Selma",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Coral Gables",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Cape Coral",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Naples",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Fort Pierce",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Kissimmee",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Titusville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "St. Augustine",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Ocala",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Fort Lauderdale",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Apalachicola",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Vero Beach",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Valdosta",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Albany",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Athens",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Macon",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Columbus",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Douglas",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Dublin",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Gulfport",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Hattiesburg",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Tupelo",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Greenville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Natchez",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Florence",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Greenville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Sumter",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Anderson",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Aiken",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Beaufort",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Rock Hill",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Decatur",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Alton",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Quincy",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Urbana",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Bloomington",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Kankakee",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Waukegan",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Aurora",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Carbondale",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Belleville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Bloomington",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "Muncie",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "Kokomo",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "Gary",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Fort Wayne",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "Covington",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Bowling Green",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Paducah",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Owensboro",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Jacksonville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Goldsboro",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Greenville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Fayetteville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Hickory",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Asheville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Winston-Salem",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Kitty Hawk",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Akron",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Lima",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Oak Ridge",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Murfreesboro",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Clarksville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Jackson",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Alexandria",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Fredericksburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Roanoke",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Danville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Winchester",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Bristol",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Superior",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "West Bend",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Fond du Lac",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Oshkosh",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Rhinelander",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Racine",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Marinette",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Wheeling",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Morgantown",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Huntington",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Beckley",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Wilmington",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Cumberland",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Atlantic City",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Newark",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Schenectady",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Binghamton",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Utica",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Watertown",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Niagara Falls",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Jamestown",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Elmira",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "York",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Johnstown",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Scranton",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "State College",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Erie",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Wilkes Barre",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Bar Harbor",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Lewiston",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Presque Isle",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Ann Arbor",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Kalamazoo",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Muskegon",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Flint",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Grand Rapids",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Pontiac",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Cadillac",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Traverse City",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Petoskey",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Escanaba",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Marquette",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Hancock",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Wrangell",

    country: "United States of America",
    timezone: "America/Sitka",
  },
  {
    city: "Shishmaref",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Hoonah",

    country: "United States of America",
    timezone: "America/Juneau",
  },
  {
    city: "Atka",

    country: "United States of America",
    timezone: "America/Adak",
  },
  {
    city: "Nikolski",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Karluk",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "False Pass",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Kivalina",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Newhalen",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Pilot Point",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Chignik",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "King Salmon",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Quinhagak",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Aniak",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Kotlit",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Unalakleet",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Koyuk",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "McGrath",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Hughes",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Ambler",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Wales",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Kotzebue",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Wasilla",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Circle",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Denali Park",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Yakutat",

    country: "United States of America",
    timezone: "America/Yakutat",
  },
  {
    city: "Homer",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Tanacross",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Wiseman",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Kailua-Kona",

    country: "United States of America",
    timezone: "Pacific/Honolulu",
  },
  {
    city: "Butte",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Grand Forks",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Pocatello",

    country: "United States of America",
    timezone: "America/Boise",
  },
  {
    city: "Tacoma",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Yuma",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Prescott",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Long Beach",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Grand Junction",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Ely",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Carson City",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Carlsbad",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Alamogordo",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Medford",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Klamath Falls",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "St. George",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Provo",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Laramie",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Little Rock",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Wichita",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Jefferson City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Rapid City",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Lafayette",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Galveston",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Freeport",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Victoria",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Odessa",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Wichita Falls",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Waco",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Lubbock",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Hartford",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Providence",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Birmingham",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Mobile",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Pensacola",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "St. Petersburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Biloxi",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Springfield",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Frankfort",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Greensboro",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Dayton",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Virginia Beach",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Madison",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Green Bay",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Trenton",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Lansing",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Gambell",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Palmer",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Seward",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Duluth",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Bemidji",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Havre",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Kalispell",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Idaho Falls",

    country: "United States of America",
    timezone: "America/Boise",
  },
  {
    city: "Lewiston",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Yakima",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Wenatchee",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Douglas",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Bakersfield",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Oakland",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Lancaster",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Chico",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Monterey",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Salinas",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Los Alamos",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Eugene",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Coos Bay",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Bend",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Cody",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Cedar Rapids",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Springfield",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Lincoln",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Alexandria",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Abilene",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Brownsville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Tyler",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Concord",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Huntsville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Key West",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "West Palm Beach",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Sarasota",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Daytona Beach",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Gainesville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Ft. Myers",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Brunswick",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Augusta",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Vicksburg",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Myrtle Beach",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Charleston",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Peoria",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Evansville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Louisville",

    country: "United States of America",
    timezone: "America/Kentucky/Louisville",
  },
  {
    city: "Lexington",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Charlotte",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Youngstown",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Canton",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Toledo",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Columbus",

    country: "United States of America",

    timezone: "America/New_York",
  },
  {
    city: "Chattanooga",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Charlottesville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Lynchburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Wausau",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Albany",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Ithaca",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Harrisburg",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Bangor",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Portland",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Saginaw",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Ketchikan",

    country: "United States of America",
    timezone: "America/Sitka",
  },
  {
    city: "Unalaska",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Togiak",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Red Devil",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Hooper Bay",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Wainwright",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Galena",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Kaktovik",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Skagway",

    country: "United States of America",
    timezone: "America/Juneau",
  },
  {
    city: "Cordova",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Kenai",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Fort Yukon",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Santa Cruz",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "San Bernardino",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Bridgeport",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Rochester",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "International Falls",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "St. Paul",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Billings",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Great Falls",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Missoula",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Minot",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Fargo",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Hilo",

    country: "United States of America",
    timezone: "Pacific/Honolulu",
  },
  {
    city: "Olympia",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Spokane",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Vancouver",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Flagstaff",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Tucson",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "Santa Barbara",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Fresno",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Eureka",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Colorado Springs",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Reno",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Elko",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Albuquerque",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Salem",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Casper",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Topeka",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Kansas City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Tulsa",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Sioux Falls",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Shreveport",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Baton Rouge",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Ft. Worth",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Corpus Christi",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Austin",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Amarillo",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "El Paso",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Laredo",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Burlington",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Montgomery",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Tallahassee",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Orlando",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Jacksonville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Savannah",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Columbia",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Indianapolis",

    country: "United States of America",
    timezone: "America/Indiana/Indianapolis",
  },
  {
    city: "Wilmington",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Knoxville",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Richmond",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Charleston",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Baltimore",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Syracuse",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Augusta",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Sault Ste. Marie",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Sitka",

    country: "United States of America",
    timezone: "America/Sitka",
  },
  {
    city: "Helena",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Bismarck",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Boise",

    country: "United States of America",
    timezone: "America/Boise",
  },
  {
    city: "San Jose",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Sacramento",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Las Vegas",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Santa Fe",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Portland",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Salt Lake City",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Cheyenne",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Des Moines",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Omaha",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Oklahoma City",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Pierre",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "San Antonio",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Jackson",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Raleigh",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Cleveland",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Cincinnati",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Nashville",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Memphis",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Norfolk",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Milwaukee",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Buffalo",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Pittsburgh",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Kodiak",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Cold Bay",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Bethel",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Point Hope",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Barrow",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Nome",

    country: "United States of America",
    timezone: "America/Nome",
  },
  {
    city: "Valdez",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Juneau",

    country: "United States of America",
    timezone: "America/Juneau",
  },
  {
    city: "Fairbanks",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Prudhoe Bay",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "Minneapolis",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Honolulu",

    country: "United States of America",
    timezone: "Pacific/Honolulu",
  },
  {
    city: "Seattle",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Phoenix",

    country: "United States of America",
    timezone: "America/Phoenix",
  },
  {
    city: "San Diego",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "St. Louis",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "New Orleans",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Dallas",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Boston",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Tampa",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Philadelphia",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Detroit",

    country: "United States of America",
    timezone: "America/Detroit",
  },
  {
    city: "Anchorage",

    country: "United States of America",
    timezone: "America/Anchorage",
  },
  {
    city: "San Francisco",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Denver",

    country: "United States of America",
    timezone: "America/Denver",
  },
  {
    city: "Houston",

    country: "United States of America",
    timezone: "America/Chicago",
  },
  {
    city: "Miami",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Atlanta",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Chicago",

    country: "United States of America",

    timezone: "America/Chicago",
  },
  {
    city: "Los Angeles",

    country: "United States of America",
    timezone: "America/Los_Angeles",
  },
  {
    city: "Washington, D.C.",

    country: "United States of America",

    timezone: "America/New_York",
  },
  {
    city: "New York",

    country: "United States of America",
    timezone: "America/New_York",
  },
  {
    city: "Christiansted",

    country: "United States Virgin Islands",
    timezone: "America/St_Thomas",
  },
  {
    city: "Colonia del Sacramento",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Trinidad",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Fray Bentos",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Canelones",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Florida",

    country: "Uruguay",
    timezone: "America/Montevideo",
  },
  {
    city: "Artigas",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Baltasar Brum",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Tranqueras",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Tacuarembo",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Paso de los Toros",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Vergara",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Treinta y Tres",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Santa Lucia",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Jose Batlle y Ordonez",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Minas",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Maldonado",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Punta del Este",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Aigua",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "La Paloma",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Carmelo",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Bella Union",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Mercedes",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Melo",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Rivera",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Lascano",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Castillos",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "San Jose de Mayo",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Rocha",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Paysandu",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Salto",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Durazno",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Montevideo",

    country: "Uruguay",

    timezone: "America/Montevideo",
  },
  {
    city: "Khujayli",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Urgut",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Kattaqorgon",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Denow",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Guliston",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Iskandar",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Chirchiq",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Kogon",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Khiwa",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Chimboy",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Qunghirot",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Zarafshon",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Navoi",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Shahrisabz",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Qarshi",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Qoqon",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Jizzax",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Angren",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Olmaliq",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Muynoq",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Termiz",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Fargona",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Namangan",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Urgentch",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Bukhara",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Nukus",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Andijon",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Samarqand",

    country: "Uzbekistan",

    timezone: "Asia/Samarkand",
  },
  {
    city: "Tashkent",

    country: "Uzbekistan",

    timezone: "Asia/Tashkent",
  },
  {
    city: "Luganville",

    country: "Vanuatu",

    timezone: "Pacific/Efate",
  },
  {
    city: "Port Vila",

    country: "Vanuatu",

    timezone: "Pacific/Efate",
  },
  {
    city: "Vatican City",

    country: "Vatican (Holy Sea)",

    timezone: "Europe/Rome",
  },
  {
    city: "San Carlos",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "San Felipe",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "San Juan De Los Morros",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "La Asuncion",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Guasdualito",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Barinas",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Valera",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Cabimas",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Carora",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Guanare",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Puerto la Cruz",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Anaco",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Los Teques",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Valle de la Pascua",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Ocumare del Tuy",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Carupano",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Trujillo",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Santa Rita",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Machiques",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "San Carlos del Zulia",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Puerto Cabello",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Acarigua",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Upata",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "El Manteco",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Chaguaramas",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Barcelona",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "El Tigre",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Maiquetia",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Calabozo",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Zaraza",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Altagracia de Orituco",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Tucupita",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Porlamar",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "San Fernando de Apure",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Barquisimeto",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Maturin",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Cumana",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Coro",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Punto Fijo",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "La Esmeralda",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Ciudad Bolivar",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "El Dorado",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Maracay",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Merida",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Puerto Ayacucho",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "San Cristobal",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Valencia",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Ciudad Guayana",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Maracaibo",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Caracas",

    country: "Venezuela",

    timezone: "America/Caracas",
  },
  {
    city: "Tay Ninh",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Luan Chau",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Bac Kan",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Lang Son",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Son La",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Tuyen Quang",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Yen Bai",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Hai Duong",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Thai Binh",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Tuy Hoa",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Thu Dau Mot",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Dong Ha",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Cao Lanh",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Truc Giang",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Tra Vinh",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Vinh Long",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Cao Bang",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Hong Gai",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Cam Pha",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Lao Chi",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Hoa Binh",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Son Tay",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Ninh Binh",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Viet Tri",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Bac Giang",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Ha Tinh",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Buon Me Thuot",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Da Lat",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Phan Rang",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Hon Quan",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Kon Tum",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Quang Ngai",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Quang Tri",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Vung Tau",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Phan Thiet",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Long Xuyen",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Chau Doc",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Rach Gia",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Tan An",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "My Tho",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Bac Lieu",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Ca Mau",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Soc Trang",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Ha Giang",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Thai Nguyen",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Thanh Hoa",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Nam Dinh",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Vinh",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Dong Hoi",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Play Ku",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Nha Trang",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Cam Ranh",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Qui Nhon",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Hue",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Bien Hoa",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Can Tho",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Haiphong",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Da Nang",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Hanoi",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Ho Chi Minh City",

    country: "Vietnam",

    timezone: "Asia/Ho_Chi_Minh",
  },
  {
    city: "Bir Lehlou",

    country: "Western Sahara",

    timezone: "Africa/El_Aaiun",
  },
  {
    city: "Al Bayda",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "'Ataq",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Marib",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Dhamar",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Ibb",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Ash Shihr",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Zabid",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Hajjah",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Lahij",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Al Ghaydah",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Rida",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Hadiboh",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Saywun",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Sadah",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Al Hudaydah",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Sayhut",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Al Mukalla",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Taizz",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Aden",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Sanaa",

    country: "Yemen",

    timezone: "Asia/Aden",
  },
  {
    city: "Kawambwa",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Nchelenge",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Chinsali",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Kasama",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Kapiri Mposhi",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Mumbwa",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Chingola",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Chililabombwe",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Nyimba",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Lundazi",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Chipata",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Mwinilunga",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Kasempa",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Solwezi",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Choma",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Mongu",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Kaoma",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Sesheke",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Lukulu",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Kalabo",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Senanga",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Mansa",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Mpika",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Mbala",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Luanshya",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Ndola",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Zambezi",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Kafue",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Mazabuka",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Kabwe",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Mufulira",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Kitwe",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Livingstone",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Lusaka",

    country: "Zambia",

    timezone: "Africa/Lusaka",
  },
  {
    city: "Mazowe",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Shamva",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Victoria Falls",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Zvishavane",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Kwekwe",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Plumtree",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Beitbridge",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Gwanda",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Chiredzi",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Masvingo",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Karoi",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Chinhoyi",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Kariba",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Hwange",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Gweru",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Mutare",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Kadoma",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Chitungwiza",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Harare",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Bulawayo",

    country: "Zimbabwe",

    timezone: "Africa/Harare",
  },
  {
    city: "Copenhagen",

    country: "Denmark",

    timezone: "Europe/Copenhagen",
  },
];
